import React from "react";
export const picture = ({ width, height }) => {
  return <div />;
};
export const ShopIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.309"
      height="24"
      viewBox="0 0 25.309 24"
    >
      <g id="shopping-bag" transform="translate(-24 -32)">
        <path
          id="Path_73"
          data-name="Path 73"
          d="M151.418,40.727a.436.436,0,0,1-.436-.436V35.927a3.055,3.055,0,1,0-6.109,0v4.364a.436.436,0,1,1-.873,0V35.927a3.927,3.927,0,1,1,7.855,0v4.364A.436.436,0,0,1,151.418,40.727Z"
          transform="translate(-113.455)"
          fill="#028360"
        />
        <path
          id="Path_74"
          data-name="Path 74"
          d="M38.836,169.455H24L24.873,152H37.964Z"
          transform="translate(0 -113.455)"
          fill="#c8d952"
        />
        <path
          id="Path_75"
          data-name="Path 75"
          d="M284.364,169.455h-3.491L280,152h3.491Z"
          transform="translate(-242.036 -113.455)"
          fill="#028360"
        />
        <path
          id="Path_76"
          data-name="Path 76"
          d="M305.335,167.272h-.026a.436.436,0,0,1-.435-.411L304,152.026c0-.009,0-.017,0-.026h.874l.871,14.811A.437.437,0,0,1,305.335,167.272Z"
          transform="translate(-264.727 -113.455)"
          fill="#55b56a"
        />
        <path
          id="Path_77"
          data-name="Path 77"
          d="M412.364,275.345h-3.491l-.055-.705h0L408,264h3.491l.8,10.456h0Z"
          transform="translate(-363.055 -219.345)"
          fill="#c8d952"
        />
        <path
          id="Path_78"
          data-name="Path 78"
          d="M433.353,273.161l-.044,0a.436.436,0,0,1-.434-.393l-.016-.156L432,264.044a.393.393,0,0,1,0-.044h.875l.857,8.575.011.109A.436.436,0,0,1,433.353,273.161Z"
          transform="translate(-385.745 -219.345)"
          fill="#028360"
        />
        <path
          id="Path_79"
          data-name="Path 79"
          d="M426.545,419.055h-.525l-1.221-1.832-1.221,1.832h-.525l-.055-.705h0l1.35-2.025.087-.13a.437.437,0,0,1,.727,0l.06.09,1.254,1.881h0Z"
          transform="translate(-377.236 -363.055)"
          fill="#028360"
        />
        <path
          id="Path_80"
          data-name="Path 80"
          d="M227.345,275.345H216L216.873,264h9.6Z"
          transform="translate(-181.527 -219.345)"
          fill="#55b56a"
        />
        <path
          id="Path_81"
          data-name="Path 81"
          d="M275.055,310.109h-.873A2.184,2.184,0,0,1,272,307.927v-3.491a.436.436,0,0,1,.873,0v3.491a1.311,1.311,0,0,0,1.309,1.309h.873a1.311,1.311,0,0,0,1.309-1.309v-3.491a.436.436,0,1,1,.873,0v3.491A2.184,2.184,0,0,1,275.055,310.109Z"
          transform="translate(-234.473 -257.164)"
          fill="#e9eef2"
        />
        <path
          id="Path_83"
          data-name="Path 83"
          d="M96.436,40.727A.436.436,0,0,1,96,40.291V35.927a3.927,3.927,0,1,1,7.855,0v4.364a.436.436,0,1,1-.873,0V35.927a3.055,3.055,0,1,0-6.109,0v4.364A.436.436,0,0,1,96.436,40.727Z"
          transform="translate(-68.073)"
          fill="#55b56a"
        />
        <path
          id="Path_82"
          data-name="Path 82"
          d="M96,184h.744v4.364H96Z"
          transform="translate(-68.073 -145.455)"
          fill="#028360"
        />
        <path
          id="Path_84"
          data-name="Path 84"
          d="M82.618,220.364H80v-3.491L81.309,216l1.309.873Z"
          transform="translate(-52.945 -173.964)"
          fill="#028360"
        />
      </g>
    </svg>
  );
};
export const RewardsIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.467"
        height="24"
        viewBox="0 0 23.467 24"
      >
        <g id="rewards" transform="translate(-32 -552)">
          <g id="Group_118" data-name="Group 118" transform="translate(32 554)">
            <path
              id="Path_85"
              data-name="Path 85"
              d="M333.865,42.9a.733.733,0,0,1-.107-1.458c4.828-.729,5.842-6,6.053-7.973h-5.079a.733.733,0,0,1,0-1.467H340.6a.734.734,0,0,1,.733.744c0,.091-.21,9.068-7.357,10.146A.9.9,0,0,1,333.865,42.9Z"
              transform="translate(-317.865 -32.002)"
              fill="#340761"
            />
            <path
              id="Path_86"
              data-name="Path 86"
              d="M7.466,42.9a.923.923,0,0,1-.11-.007C.21,41.813,0,32.837,0,32.746A.734.734,0,0,1,.734,32H6.6a.733.733,0,1,1,0,1.467H1.515c.2,1.983,1.173,7.235,6.06,7.973a.733.733,0,0,1-.11,1.458Z"
              transform="translate(0 -32.002)"
              fill="#340761"
            />
            <path
              id="Path_87"
              data-name="Path 87"
              d="M139.279,290.81l-.942-.384a3.655,3.655,0,0,1-2.269-3.381v-3.109a.734.734,0,0,0-.733-.733H132.4a.734.734,0,0,0-.733.733v3.055a3.733,3.733,0,0,1-2.317,3.454l-.895.367a.732.732,0,0,0-.455.678v2.2h11.733v-2.2A.734.734,0,0,0,139.279,290.81Z"
              transform="translate(-122.135 -271.689)"
              fill="#340761"
            />
          </g>
          <path
            id="Path_88"
            data-name="Path 88"
            d="M139.252,0h-10.5a.75.75,0,0,0-.75.75V9a6,6,0,1,0,12,0V.752A.75.75,0,0,0,139.252,0Z"
            transform="translate(-90.002 551.998)"
            fill="#c8d952"
          />
        </g>
      </svg>
    );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.467"
      height="24"
      viewBox="0 0 23.467 24"
    >
      <g id="Rewards" transform="translate(-32 -552)">
        <g id="Group_118" data-name="Group 118" transform="translate(32 554)">
          <path
            id="Path_85"
            data-name="Path 85"
            d="M333.865,42.9a.733.733,0,0,1-.107-1.458c4.828-.729,5.842-6,6.053-7.973h-5.079a.733.733,0,0,1,0-1.467H340.6a.734.734,0,0,1,.733.744c0,.091-.21,9.068-7.357,10.146A.9.9,0,0,1,333.865,42.9Z"
            transform="translate(-317.865 -32.002)"
            fill="#55b56a"
          />
          <path
            id="Path_86"
            data-name="Path 86"
            d="M7.466,42.9a.923.923,0,0,1-.11-.007C.21,41.813,0,32.837,0,32.746A.734.734,0,0,1,.734,32H6.6a.733.733,0,1,1,0,1.467H1.515c.2,1.983,1.173,7.235,6.06,7.973a.733.733,0,0,1-.11,1.458Z"
            transform="translate(0 -32.002)"
            fill="#55b56a"
          />
          <path
            id="Path_87"
            data-name="Path 87"
            d="M139.279,290.81l-.942-.384a3.655,3.655,0,0,1-2.269-3.381v-3.109a.734.734,0,0,0-.733-.733H132.4a.734.734,0,0,0-.733.733v3.055a3.733,3.733,0,0,1-2.317,3.454l-.895.367a.732.732,0,0,0-.455.678v2.2h11.733v-2.2A.734.734,0,0,0,139.279,290.81Z"
            transform="translate(-122.135 -271.689)"
            fill="#55b56a"
          />
        </g>
        <path
          id="Path_88"
          data-name="Path 88"
          d="M139.252,0h-10.5a.75.75,0,0,0-.75.75V9a6,6,0,1,0,12,0V.752A.75.75,0,0,0,139.252,0Z"
          transform="translate(-90.002 551.998)"
          fill="#c8d952"
        />
      </g>
    </svg>
  );
};
export const ReferralsIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.001"
        height="24"
        viewBox="0 0 24.001 24"
      >
        <g id="affiliate" transform="translate(0.001 -0.012)">
          <g
            id="Group_121"
            data-name="Group 121"
            transform="translate(5.794 0.012)"
          >
            <g id="Group_120" data-name="Group 120" transform="translate(0 0)">
              <path
                id="Path_127"
                data-name="Path 127"
                d="M127.679,1.314a2.109,2.109,0,1,0-1.948,2.917c.037,0,.074,0,.111,0l.352.85a7.776,7.776,0,0,1,1.3-.539l-.352-.849A2.112,2.112,0,0,0,127.679,1.314Z"
                transform="translate(-123.621 -0.012)"
                fill="#340761"
              />
            </g>
          </g>
          <g
            id="Group_123"
            data-name="Group 123"
            transform="translate(-0.001 5.806)"
          >
            <g id="Group_122" data-name="Group 122" transform="translate(0)">
              <path
                id="Path_128"
                data-name="Path 128"
                d="M4.216,125.827a2.109,2.109,0,0,0-4.055-.919,2.109,2.109,0,0,0,3.517,2.218l.848.351a7.783,7.783,0,0,1,.539-1.3Z"
                transform="translate(0.001 -123.606)"
                fill="#c8d952"
              />
            </g>
          </g>
          <g
            id="Group_125"
            data-name="Group 125"
            transform="translate(0 13.999)"
          >
            <g id="Group_124" data-name="Group 124">
              <path
                id="Path_129"
                data-name="Path 129"
                d="M5.086,300.042a7.781,7.781,0,0,1-.539-1.3l-.848.351a2.111,2.111,0,1,0,.537,1.3Z"
                transform="translate(-0.021 -298.396)"
                fill="#340761"
              />
            </g>
          </g>
          <g
            id="Group_127"
            data-name="Group 127"
            transform="translate(5.793 18.947)"
          >
            <g id="Group_126" data-name="Group 126">
              <path
                id="Path_130"
                data-name="Path 130"
                d="M127.647,406.093a2.1,2.1,0,0,0-.537-.762l.351-.848a7.783,7.783,0,0,1-1.3-.539l-.352.849c-.037,0-.074,0-.111,0a2.109,2.109,0,1,0,1.948,1.3Z"
                transform="translate(-123.588 -403.945)"
                fill="#c8d952"
              />
            </g>
          </g>
          <g
            id="Group_129"
            data-name="Group 129"
            transform="translate(13.988 18.947)"
          >
            <g id="Group_128" data-name="Group 128">
              <path
                id="Path_131"
                data-name="Path 131"
                d="M302.46,406.092a2.1,2.1,0,0,0-1.949-1.3c-.037,0-.074,0-.111,0l-.352-.849a7.772,7.772,0,0,1-1.3.539l.352.849a2.109,2.109,0,1,0,3.359.761Z"
                transform="translate(-298.402 -403.944)"
                fill="#340761"
              />
            </g>
          </g>
          <g
            id="Group_131"
            data-name="Group 131"
            transform="translate(18.935 5.806)"
          >
            <g id="Group_130" data-name="Group 130">
              <path
                id="Path_132"
                data-name="Path 132"
                d="M408.84,124.916a2.109,2.109,0,0,0-4.054.918l-.85.352a7.779,7.779,0,0,1,.539,1.3l.848-.351a2.109,2.109,0,0,0,3.517-2.218Z"
                transform="translate(-403.936 -123.614)"
                fill="#340761"
              />
            </g>
          </g>
          <g
            id="Group_133"
            data-name="Group 133"
            transform="translate(13.987 0.012)"
          >
            <g id="Group_132" data-name="Group 132" transform="translate(0 0)">
              <path
                id="Path_133"
                data-name="Path 133"
                d="M302.443,1.319a2.109,2.109,0,1,0-3.359,2.376l-.351.848a7.779,7.779,0,0,1,1.3.539l.352-.85c.037,0,.074,0,.111,0a2.109,2.109,0,0,0,1.949-2.916Z"
                transform="translate(-298.385 -0.017)"
                fill="#c8d952"
              />
            </g>
          </g>
          <g
            id="Group_135"
            data-name="Group 135"
            transform="translate(18.935 14)"
          >
            <g id="Group_134" data-name="Group 134">
              <path
                id="Path_134"
                data-name="Path 134"
                d="M408.844,299.705a2.109,2.109,0,0,0-3.517-.6l-.848-.351a7.784,7.784,0,0,1-.539,1.3l.849.352a2.109,2.109,0,1,0,4.055-.7Z"
                transform="translate(-403.94 -298.403)"
                fill="#c8d952"
              />
            </g>
          </g>
          <g
            id="Group_137"
            data-name="Group 137"
            transform="translate(9.68 9.106)"
          >
            <g id="Group_136" data-name="Group 136">
              <path
                id="Path_135"
                data-name="Path 135"
                d="M208.824,194.012a2.32,2.32,0,1,0,2.32,2.32A2.323,2.323,0,0,0,208.824,194.012Z"
                transform="translate(-206.504 -194.012)"
                fill="#6115ad"
              />
            </g>
          </g>
          <g
            id="Group_139"
            data-name="Group 139"
            transform="translate(5.578 5.591)"
          >
            <g id="Group_138" data-name="Group 138">
              <path
                id="Path_136"
                data-name="Path 136"
                d="M125.43,119.016a6.421,6.421,0,0,0-4.365,11.132,3.526,3.526,0,0,1,1.831-2.567,3.727,3.727,0,1,1,5.067,0,3.526,3.526,0,0,1,1.831,2.567,6.421,6.421,0,0,0-4.365-11.132Z"
                transform="translate(-119.008 -119.016)"
                fill="#340761"
              />
            </g>
          </g>
          <g
            id="Group_141"
            data-name="Group 141"
            transform="translate(9 15.153)"
          >
            <g id="Group_140" data-name="Group 140">
              <path
                id="Path_137"
                data-name="Path 137"
                d="M195.895,323.006h-1.781A2.112,2.112,0,0,0,192,325.113v.431a6.429,6.429,0,0,0,6,0v-.432A2.112,2.112,0,0,0,195.895,323.006Z"
                transform="translate(-192.004 -323.006)"
                fill="#6115ad"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.001"
      height="24"
      viewBox="0 0 24.001 24"
    >
      <g id="Referrals" transform="translate(0.001 -0.012)">
        <g
          id="Group_121"
          data-name="Group 121"
          transform="translate(5.794 0.012)"
        >
          <g id="Group_120" data-name="Group 120" transform="translate(0 0)">
            <path
              id="Path_127"
              data-name="Path 127"
              d="M127.679,1.314a2.109,2.109,0,1,0-1.948,2.917c.037,0,.074,0,.111,0l.352.85a7.776,7.776,0,0,1,1.3-.539l-.352-.849A2.112,2.112,0,0,0,127.679,1.314Z"
              transform="translate(-123.621 -0.012)"
              fill="#55b56a"
            />
          </g>
        </g>
        <g
          id="Group_123"
          data-name="Group 123"
          transform="translate(-0.001 5.806)"
        >
          <g id="Group_122" data-name="Group 122" transform="translate(0)">
            <path
              id="Path_128"
              data-name="Path 128"
              d="M4.216,125.827a2.109,2.109,0,0,0-4.055-.919,2.109,2.109,0,0,0,3.517,2.218l.848.351a7.783,7.783,0,0,1,.539-1.3Z"
              transform="translate(0.001 -123.606)"
              fill="#c8d952"
            />
          </g>
        </g>
        <g id="Group_125" data-name="Group 125" transform="translate(0 13.999)">
          <g id="Group_124" data-name="Group 124">
            <path
              id="Path_129"
              data-name="Path 129"
              d="M5.086,300.042a7.781,7.781,0,0,1-.539-1.3l-.848.351a2.111,2.111,0,1,0,.537,1.3Z"
              transform="translate(-0.021 -298.396)"
              fill="#55b56a"
            />
          </g>
        </g>
        <g
          id="Group_127"
          data-name="Group 127"
          transform="translate(5.793 18.947)"
        >
          <g id="Group_126" data-name="Group 126">
            <path
              id="Path_130"
              data-name="Path 130"
              d="M127.647,406.093a2.1,2.1,0,0,0-.537-.762l.351-.848a7.783,7.783,0,0,1-1.3-.539l-.352.849c-.037,0-.074,0-.111,0a2.109,2.109,0,1,0,1.948,1.3Z"
              transform="translate(-123.588 -403.945)"
              fill="#c8d952"
            />
          </g>
        </g>
        <g
          id="Group_129"
          data-name="Group 129"
          transform="translate(13.988 18.947)"
        >
          <g id="Group_128" data-name="Group 128">
            <path
              id="Path_131"
              data-name="Path 131"
              d="M302.46,406.092a2.1,2.1,0,0,0-1.949-1.3c-.037,0-.074,0-.111,0l-.352-.849a7.772,7.772,0,0,1-1.3.539l.352.849a2.109,2.109,0,1,0,3.359.761Z"
              transform="translate(-298.402 -403.944)"
              fill="#55b56a"
            />
          </g>
        </g>
        <g
          id="Group_131"
          data-name="Group 131"
          transform="translate(18.935 5.806)"
        >
          <g id="Group_130" data-name="Group 130">
            <path
              id="Path_132"
              data-name="Path 132"
              d="M408.84,124.916a2.109,2.109,0,0,0-4.054.918l-.85.352a7.779,7.779,0,0,1,.539,1.3l.848-.351a2.109,2.109,0,0,0,3.517-2.218Z"
              transform="translate(-403.936 -123.614)"
              fill="#55b56a"
            />
          </g>
        </g>
        <g
          id="Group_133"
          data-name="Group 133"
          transform="translate(13.987 0.012)"
        >
          <g id="Group_132" data-name="Group 132" transform="translate(0 0)">
            <path
              id="Path_133"
              data-name="Path 133"
              d="M302.443,1.319a2.109,2.109,0,1,0-3.359,2.376l-.351.848a7.779,7.779,0,0,1,1.3.539l.352-.85c.037,0,.074,0,.111,0a2.109,2.109,0,0,0,1.949-2.916Z"
              transform="translate(-298.385 -0.017)"
              fill="#c8d952"
            />
          </g>
        </g>
        <g
          id="Group_135"
          data-name="Group 135"
          transform="translate(18.935 14)"
        >
          <g id="Group_134" data-name="Group 134">
            <path
              id="Path_134"
              data-name="Path 134"
              d="M408.844,299.705a2.109,2.109,0,0,0-3.517-.6l-.848-.351a7.784,7.784,0,0,1-.539,1.3l.849.352a2.109,2.109,0,1,0,4.055-.7Z"
              transform="translate(-403.94 -298.403)"
              fill="#c8d952"
            />
          </g>
        </g>
        <g
          id="Group_137"
          data-name="Group 137"
          transform="translate(9.68 9.106)"
        >
          <g id="Group_136" data-name="Group 136">
            <path
              id="Path_135"
              data-name="Path 135"
              d="M208.824,194.012a2.32,2.32,0,1,0,2.32,2.32A2.323,2.323,0,0,0,208.824,194.012Z"
              transform="translate(-206.504 -194.012)"
              fill="#028360"
            />
          </g>
        </g>
        <g
          id="Group_139"
          data-name="Group 139"
          transform="translate(5.578 5.591)"
        >
          <g id="Group_138" data-name="Group 138">
            <path
              id="Path_136"
              data-name="Path 136"
              d="M125.43,119.016a6.421,6.421,0,0,0-4.365,11.132,3.526,3.526,0,0,1,1.831-2.567,3.727,3.727,0,1,1,5.067,0,3.526,3.526,0,0,1,1.831,2.567,6.421,6.421,0,0,0-4.365-11.132Z"
              transform="translate(-119.008 -119.016)"
              fill="#55b56a"
            />
          </g>
        </g>
        <g id="Group_141" data-name="Group 141" transform="translate(9 15.153)">
          <g id="Group_140" data-name="Group 140">
            <path
              id="Path_137"
              data-name="Path 137"
              d="M195.895,323.006h-1.781A2.112,2.112,0,0,0,192,325.113v.431a6.429,6.429,0,0,0,6,0v-.432A2.112,2.112,0,0,0,195.895,323.006Z"
              transform="translate(-192.004 -323.006)"
              fill="#028360"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PickleBallIcon = ({isPickleball}) => {
  return isPickleball ?(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="114.51"
      height="40"
      viewBox="0 0 114.51 40"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_223"
            data-name="Rectangle 223"
            width="114.51"
            height="40"
            transform="translate(0 0)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_13"
        data-name="Mask Group 13"
        clip-path="url(#clip-path)"
      >
        <g
          id="Group_463"
          data-name="Group 463"
          transform="translate(-0.157 -9.494)"
        >
          <g id="Group_462" data-name="Group 462" transform="translate(0 0)">
            <path
              id="Path_297"
              data-name="Path 297"
              d="M5.939-187.4a.43.43,0,0,1-.352-.15.436.436,0,0,1-.079-.378l3.044-14.3a.636.636,0,0,1,.226-.391.632.632,0,0,1,.411-.15h5.628a8.1,8.1,0,0,1,2.309.3,4.164,4.164,0,0,1,1.684.921,3.182,3.182,0,0,1,.91,1.53,4.537,4.537,0,0,1-.012,2.131,5.759,5.759,0,0,1-2.148,3.625,7.13,7.13,0,0,1-4.3,1.189H9.745l-1.1,5.146a.641.641,0,0,1-.22.378.624.624,0,0,1-.418.15Zm4.279-8.107h3.1a3.653,3.653,0,0,0,2.1-.607,2.782,2.782,0,0,0,1.151-1.791,3.464,3.464,0,0,0,.066-1.282,1.185,1.185,0,0,0-.587-.842,3.049,3.049,0,0,0-1.542-.3H11.254Zm9.963,8.107a.43.43,0,0,1-.352-.15.436.436,0,0,1-.079-.378l2.2-10.364a.622.622,0,0,1,.231-.378.649.649,0,0,1,.416-.15h1.819a.4.4,0,0,1,.341.15.46.46,0,0,1,.068.378l-2.2,10.364a.641.641,0,0,1-.22.378.607.607,0,0,1-.4.15ZM22.9-200.706a.411.411,0,0,1-.345-.15.485.485,0,0,1-.086-.378l.349-1.575a.661.661,0,0,1,.224-.385.608.608,0,0,1,.409-.156h2a.428.428,0,0,1,.354.156.45.45,0,0,1,.081.385l-.349,1.575a.564.564,0,0,1-.22.378.657.657,0,0,1-.418.15Zm7.555,13.525a5.41,5.41,0,0,1-2.592-.6,3.621,3.621,0,0,1-1.629-1.728,4.608,4.608,0,0,1-.25-2.719q.066-.338.176-.878t.2-.887a6.8,6.8,0,0,1,2.208-3.718,6.185,6.185,0,0,1,4.081-1.333,5.95,5.95,0,0,1,2.32.4,3.99,3.99,0,0,1,1.473,1.012,3.517,3.517,0,0,1,.742,1.273,2.851,2.851,0,0,1,.137,1.188.565.565,0,0,1-.187.378.551.551,0,0,1-.381.15H34.765a.509.509,0,0,1-.349-.108.48.48,0,0,1-.135-.344,1.588,1.588,0,0,0-.482-1.266,2.021,2.021,0,0,0-1.337-.4,2.947,2.947,0,0,0-1.931.693,3.983,3.983,0,0,0-1.211,2.186q-.1.392-.185.809t-.145.737a3.1,3.1,0,0,0,.2,2.191,1.729,1.729,0,0,0,1.549.679,3.175,3.175,0,0,0,1.529-.365,2.849,2.849,0,0,0,1.136-1.233,1.16,1.16,0,0,1,.281-.351.6.6,0,0,1,.365-.1h1.974a.409.409,0,0,1,.337.15.4.4,0,0,1,.055.378,4.884,4.884,0,0,1-.553,1.141,5.63,5.63,0,0,1-1.11,1.256,5.788,5.788,0,0,1-1.77,1.008A7.212,7.212,0,0,1,30.459-187.181Zm8.04-.22a.43.43,0,0,1-.352-.15.436.436,0,0,1-.079-.378l3.1-14.537a.641.641,0,0,1,.22-.378.607.607,0,0,1,.4-.15h1.783a.43.43,0,0,1,.352.15.437.437,0,0,1,.079.378l-1.58,7.415,4.3-3.4q.248-.179.416-.276a.964.964,0,0,1,.479-.1h2.243q.352,0,.392.3a.618.618,0,0,1-.306.567l-5.422,4.4,3.873,5.373a.446.446,0,0,1,.045.51.487.487,0,0,1-.469.264H45.985a.7.7,0,0,1-.447-.116,1.622,1.622,0,0,1-.233-.231l-3.438-4.7-.96,4.517a.641.641,0,0,1-.22.378.607.607,0,0,1-.4.15Zm12.123,0a.43.43,0,0,1-.352-.15.436.436,0,0,1-.079-.378l3.1-14.537a.641.641,0,0,1,.22-.378.607.607,0,0,1,.4-.15h1.819a.43.43,0,0,1,.352.15.437.437,0,0,1,.079.378l-3.1,14.537a.641.641,0,0,1-.22.378.607.607,0,0,1-.4.15Zm10.455.22a5.159,5.159,0,0,1-2.674-.632,3.282,3.282,0,0,1-1.468-1.841,6.071,6.071,0,0,1-.118-2.925q.035-.213.107-.557t.133-.548a8.063,8.063,0,0,1,1.358-2.858,6.221,6.221,0,0,1,2.246-1.85,6.61,6.61,0,0,1,2.932-.646,4.77,4.77,0,0,1,2.821.739,3.505,3.505,0,0,1,1.373,2.044,6.7,6.7,0,0,1,0,3.008l-.093.463a.612.612,0,0,1-.237.378.675.675,0,0,1-.422.15h-7.3q0,.009-.011.07a.99.99,0,0,1-.024.1,3.834,3.834,0,0,0,.008,1.414,1.838,1.838,0,0,0,.586,1.043,1.761,1.761,0,0,0,1.2.395,2.8,2.8,0,0,0,1.07-.187,3.144,3.144,0,0,0,.761-.43q.305-.242.459-.391a1.532,1.532,0,0,1,.384-.3,1.019,1.019,0,0,1,.38-.055h1.895a.4.4,0,0,1,.316.125.346.346,0,0,1,.057.332,2.409,2.409,0,0,1-.534.856,5.5,5.5,0,0,1-1.192.988,7.28,7.28,0,0,1-1.769.8A7.5,7.5,0,0,1,61.077-187.181Zm-.949-6.922h4.86l.013-.061a3.07,3.07,0,0,0,.053-1.495,1.761,1.761,0,0,0-.639-1.011,2,2,0,0,0-1.246-.364,2.628,2.628,0,0,0-1.377.364,3.108,3.108,0,0,0-1.023,1.011,5.027,5.027,0,0,0-.629,1.495Zm14.8,6.922a4.418,4.418,0,0,1-2.1-.441,2.891,2.891,0,0,1-1.206-1.125l-.175.818a.629.629,0,0,1-.226.378.632.632,0,0,1-.411.15H69.08a.411.411,0,0,1-.345-.15.45.45,0,0,1-.073-.378l3.088-14.537a.629.629,0,0,1,.226-.378.632.632,0,0,1,.411-.15H74.26a.411.411,0,0,1,.345.15.45.45,0,0,1,.073.378l-1.036,4.875a6.571,6.571,0,0,1,1.481-1.038,4.335,4.335,0,0,1,1.988-.411,4.454,4.454,0,0,1,1.965.392,3.17,3.17,0,0,1,1.27,1.085,3.948,3.948,0,0,1,.61,1.629,6.331,6.331,0,0,1-.046,2.036q-.062.392-.145.778t-.189.787a8.807,8.807,0,0,1-1.117,2.662,5.568,5.568,0,0,1-1.869,1.827A5.134,5.134,0,0,1,74.933-187.181Zm-.491-2.353a2.751,2.751,0,0,0,1.53-.4,3.222,3.222,0,0,0,1.017-1.072,6.533,6.533,0,0,0,.635-1.444,5.8,5.8,0,0,0,.178-.659q.068-.33.1-.66a5.419,5.419,0,0,0,.046-1.45,1.716,1.716,0,0,0-.485-1.065,1.876,1.876,0,0,0-1.347-.4,3.01,3.01,0,0,0-1.543.393,3.429,3.429,0,0,0-1.1,1,3.964,3.964,0,0,0-.6,1.271q-.106.392-.2.834t-.145.843a3.981,3.981,0,0,0-.009,1.339,1.8,1.8,0,0,0,.561,1.059A1.946,1.946,0,0,0,74.442-189.535Zm11.842,2.353a4.408,4.408,0,0,1-1.935-.385,3.016,3.016,0,0,1-1.248-1.087,3.964,3.964,0,0,1-.579-1.655,7.263,7.263,0,0,1,.055-2.089q.071-.4.141-.722t.167-.713a10.049,10.049,0,0,1,.748-2.042,6.6,6.6,0,0,1,1.161-1.655,4.914,4.914,0,0,1,1.63-1.111,5.436,5.436,0,0,1,2.141-.4,4.088,4.088,0,0,1,2.076.425,3.217,3.217,0,0,1,1.1,1.051l.157-.729a.641.641,0,0,1,.22-.378.607.607,0,0,1,.4-.15h1.729a.43.43,0,0,1,.352.15.436.436,0,0,1,.079.378l-2.2,10.364a.641.641,0,0,1-.22.378.607.607,0,0,1-.4.15H90.117a.43.43,0,0,1-.352-.15.436.436,0,0,1-.079-.378l.175-.818a6.445,6.445,0,0,1-1.462,1.125A4.343,4.343,0,0,1,86.284-187.181Zm.99-2.353a2.869,2.869,0,0,0,1.567-.415,3.428,3.428,0,0,0,1.067-1.059,4.522,4.522,0,0,0,.587-1.339q.106-.4.2-.843t.158-.834a3.28,3.28,0,0,0,.013-1.271,1.724,1.724,0,0,0-.568-1,1.973,1.973,0,0,0-1.332-.393,2.618,2.618,0,0,0-1.474.4,3.172,3.172,0,0,0-1,1.065,6.635,6.635,0,0,0-.625,1.45q-.088.329-.163.66t-.119.659a6.434,6.434,0,0,0-.05,1.45A1.646,1.646,0,0,0,86-189.936,1.748,1.748,0,0,0,87.274-189.535Zm8.565,2.134a.43.43,0,0,1-.352-.15.437.437,0,0,1-.079-.378l3.1-14.537a.641.641,0,0,1,.22-.378.607.607,0,0,1,.4-.15h1.819a.43.43,0,0,1,.352.15.437.437,0,0,1,.079.378l-3.1,14.537a.641.641,0,0,1-.22.378.606.606,0,0,1-.4.15Zm5.824,0a.43.43,0,0,1-.352-.15.437.437,0,0,1-.079-.378l2.238-10.693a.641.641,0,0,1,.22-.378.607.607,0,0,1,.4-.15h1.819a.43.43,0,0,1,.352.15.437.437,0,0,1,.079.378l-2.238,10.693a.641.641,0,0,1-.22.378.607.607,0,0,1-.4.15Z"
              transform="translate(-5.497 236.032)"
              fill="#340761"
            />
            <g
              id="Group_461"
              data-name="Group 461"
              transform="matrix(0.966, 0.259, -0.259, 0.966, 64.013, 0)"
            >
              <circle
                id="Ellipse_51"
                data-name="Ellipse 51"
                cx="7.444"
                cy="7.444"
                r="7.444"
                transform="translate(30.503 4.452)"
                fill="#cb4edb"
              />
              <g id="pickball" transform="translate(0 0)">
                <path
                  id="Path_298"
                  data-name="Path 298"
                  d="M32.381.225c-4.671.336-4.6.328-5.313.555A5.7,5.7,0,0,0,23.222,5.26c-.051.387-.08.423-.759,1.087l-.7.679-3.795.679c-2.087.372-6.9,1.226-10.691,1.9C2.284,10.478.328,10.851.2,10.945a.49.49,0,0,0,.255.883c.131,0,2.89-.482,13.136-2.3,5.641-1,7.218-1.277,7.305-1.277.058,0,.029.124-.088.365-.095.2-.255.6-.35.883a3.626,3.626,0,0,1-.234.577,10.069,10.069,0,0,1-1.16.248c-.6.1-2.474.438-4.16.73s-3.474.613-3.977.7c-1.124.19-1.277.248-1.394.518a.334.334,0,0,0,.058.416.531.531,0,0,0,.394.219c.139.007,1.744-.248,3.569-.569,3.78-.671,6.086-1.073,6.335-1.109.168-.022.168-.015.182.847l.015.876-1.2.2c-1.416.241-1.343.219-1.5.445a.5.5,0,0,0,.153.686c.161.1.27.095,1.284-.08.613-.109,1.2-.212,1.306-.234.168-.029.2-.007.241.168.029.109.168.474.314.81a4.3,4.3,0,0,1,.234.628c-.015.015-2.773.511-6.123,1.1s-6.138,1.109-6.2,1.153a.734.734,0,0,0-.2.606.472.472,0,0,0,.255.248c.219.088.409.058,10.516-1.744l2.365-.423.182.226c.1.124.409.452.679.73a2.426,2.426,0,0,1,.46.547c-.022.015-.81.168-1.752.336a7.117,7.117,0,0,0-1.861.438.5.5,0,0,0,.35.839c.109,0,1.131-.168,2.27-.365s2.109-.365,2.16-.365.131.139.182.307A5.78,5.78,0,0,0,25.9,21.732a7.93,7.93,0,0,0,2.321,1.263c1.949.81,2.591,1.255,3.021,2.116a4.508,4.508,0,0,1,.336.927c.2,1.007.161.934.423.956.234.022.234.029.234.416,0,.416.117.62.365.62.117,0,.139.08.182.533s.547,7.794.547,7.9c0,.022-.058.036-.139.036-.277,0-.314.161-.263,1.1.044.671.088.92.175,1.007.109.109.248.109,1.8.007a14.255,14.255,0,0,0,1.773-.175c.08-.044.088-.255.044-.985-.051-.956-.124-1.175-.4-1.175-.153,0-.175-.175-.285-1.9-.044-.664-.161-2.35-.255-3.758s-.182-2.605-.182-2.664.1-.153.226-.2c.226-.088.226-.095.2-.547-.029-.409-.015-.46.117-.482.285-.058.328-.161.328-.781a3.161,3.161,0,0,1,.584-1.941c.46-.613.722-.81,2.97-2.175a5.48,5.48,0,0,0,2.343-2.452c.577-1.153.65-1.854.46-4.488-.08-1.146-.263-3.773-.409-5.838s-.27-3.941-.3-4.16a6.257,6.257,0,0,0-1.007-2.554,6.236,6.236,0,0,0-2.6-1.992C37.343-.089,36.92-.1,32.381.225Zm5.51.912a5.949,5.949,0,0,1,1.7.963,5,5,0,0,1,1.54,2.686c.117.62.832,11.151.832,12.115a3.551,3.551,0,0,1-.2,1.387c-.489,1.5-1.007,2.007-3.671,3.612a4.571,4.571,0,0,0-2.51,3.211c-.044.3-.095.584-.1.628-.022.08-.452.124-2.124.219l-.8.051-.095-.416a4.006,4.006,0,0,0-1.029-1.846A7.711,7.711,0,0,0,28.9,22.257c-1.817-.8-2.022-.9-2.6-1.474a5.218,5.218,0,0,1-.766-.934c-.234-.409-.3-.628-.168-.54A7.779,7.779,0,0,0,30.826,4.749a7.164,7.164,0,0,0-2.642-.562,8.045,8.045,0,0,0-3.788.744c-.124.051-.131.036-.088-.153a5.052,5.052,0,0,1,1.963-2.562c.963-.606,1.387-.708,3.627-.861.9-.058,1.919-.131,2.262-.153C36.679.889,37.154.882,37.891,1.137ZM28.958,5.231a6.8,6.8,0,0,1-2.087,13.428,5.843,5.843,0,0,1-2.087-.671,6.8,6.8,0,0,1-3.474-4.167,4.882,4.882,0,0,1-.2-1.846,5.465,5.465,0,0,1,.569-2.883A6.78,6.78,0,0,1,28.958,5.231Zm6.378,22.645c-.066.058-2.284,1.1-2.35,1.1a.684.684,0,0,1-.022-.219c0-.2.051-.234.642-.511a6.1,6.1,0,0,1,.927-.365C34.95,27.8,35.417,27.8,35.336,27.877Zm.139.752c.022.095.015.19-.015.212-.073.073-2.277,1.087-2.357,1.087-.036,0-.066-.088-.066-.2,0-.182.073-.234,1.117-.722.606-.285,1.146-.518,1.19-.525S35.446,28.541,35.475,28.628Zm.029,1.014c-.022.219-.073.255-1.182.766-.642.3-1.175.54-1.2.54a.467.467,0,0,1,0-.219c.022-.212.088-.255,1.153-.759.62-.3,1.16-.547,1.19-.547S35.519,29.519,35.5,29.643Zm.088,1c0,.182-.073.234-1.146.73-.635.292-1.175.525-1.2.525s-.058-.088-.058-.2c0-.182.073-.234,1.117-.722a12.891,12.891,0,0,1,1.2-.525C35.555,30.438,35.592,30.526,35.592,30.642Zm.058.971c-.022.212-.08.248-1.182.766-.635.3-1.175.54-1.19.54a.438.438,0,0,1-.007-.226c.022-.219.073-.255,1.153-.759.62-.292,1.16-.54,1.19-.54S35.665,31.489,35.65,31.613Zm.088.993c0,.19-.073.241-1.1.715-.606.277-1.146.518-1.2.533s-.109-.066-.124-.168c-.036-.182,0-.212.7-.533.4-.19.92-.431,1.138-.54C35.672,32.365,35.738,32.365,35.738,32.606Zm.058.971c-.022.212-.088.255-1.182.766-.635.307-1.168.54-1.175.533a.983.983,0,0,1-.066-.19c-.044-.131-.015-.182.153-.277.3-.161,2.16-1.036,2.233-1.044C35.8,33.357,35.811,33.459,35.8,33.576Zm.088,1c0,.182-.066.234-.693.525a1.908,1.908,0,0,0-.65.379c.022.036-.007.044-.066.022a1.28,1.28,0,0,0-.547.182l-.438.219-.051-.19a.373.373,0,0,1,.015-.248c.088-.08,2.233-1.073,2.343-1.08C35.847,34.379,35.884,34.467,35.884,34.576Zm.073.963c0,.19-.058.234-.679.533a3.294,3.294,0,0,1-1.2.387,1.318,1.318,0,0,1-.525,0,1.4,1.4,0,0,1,.387-.219c.2-.095.722-.336,1.146-.54s.788-.365.825-.372S35.957,35.423,35.957,35.539Z"
                  transform="translate(9.698 0)"
                  fill="#6115ad"
                />
                <path
                  id="Union_7"
                  data-name="Union 7"
                  d="M4.682,11.956A.649.649,0,0,1,5,11.044a1.1,1.1,0,0,1,1,.044c.314.2.365.263.365.555s-.321.577-.7.649a.656.656,0,0,1-.122.01A1.2,1.2,0,0,1,4.682,11.956ZM9.63,9.548a1.027,1.027,0,0,1,.131-1.175,1.331,1.331,0,0,1,.358-.284c.65-.27,1.095.547.657,1.211a.924.924,0,0,1-.742.426A.5.5,0,0,1,9.63,9.548Zm-8.7.168A.991.991,0,0,1,.012,8.7.581.581,0,0,1,.34,8.1c.212-.117.336-.1.606.059.708.434.708,1.555.006,1.555ZM4.339,6.234A1.1,1.1,0,0,1,5.2,5.023,1.176,1.176,0,0,1,6.631,6.3a1.149,1.149,0,0,1-1.157,1A1.109,1.109,0,0,1,4.339,6.234ZM.056,3.965A1.1,1.1,0,0,1,.6,2.673c.306-.161.321-.161.576-.022.241.117.3.241.3.591A1.119,1.119,0,0,1,.734,4.256a.427.427,0,0,1-.094.01A.708.708,0,0,1,.056,3.965Zm9.633-.109c-.314-.379-.248-1.087.124-1.241a.78.78,0,0,1,.686.117c.569.365.606,1.306.058,1.489a.648.648,0,0,1-.2.032A.913.913,0,0,1,9.689,3.855ZM4.609.7A.655.655,0,0,1,5.127.06a.882.882,0,0,1,.642,0c.576.168.774.672.4,1.044a.958.958,0,0,1-.683.262C5.043,1.366,4.609,1.109,4.609.7Z"
                  transform="translate(32.069 5.784)"
                  fill="#fafffb"
                />
                <path
                  id="Path_306"
                  data-name="Path 306"
                  d="M4.2.679C2.137,1.051.378,1.38.291,1.4a.545.545,0,0,0-.277.606.567.567,0,0,0,.241.285c.2.1.686.029,4.641-.693.3-.058,1.175-.2,3.226-.562A.838.838,0,0,0,8.5.854.5.5,0,0,0,8.165,0C8.048.008,6.268.314,4.2.679Z"
                  transform="translate(0 11.179)"
                  fill="#6115ad"
                />
                <path
                  id="Path_307"
                  data-name="Path 307"
                  d="M2.007.318C.088.668,0,.7,0,1.194c0,.277.153.394.525.394.255,0,3.372-.54,3.576-.62a.549.549,0,0,0-.007-.9C3.912-.04,4.05-.054,2.007.318Z"
                  transform="translate(13.836 12.284)"
                  fill="#6115ad"
                />
                <path
                  id="Path_308"
                  data-name="Path 308"
                  d="M11.8.613c-1.868.336-4.371.781-5.561.993a21.536,21.536,0,0,0-2.131.445c.022.029-.015.036-.08.015A25.679,25.679,0,0,0,.19,2.759a.523.523,0,0,0-.073.73.527.527,0,0,0,.321.153C.8,3.642,15.647.985,15.8.9c.117-.08.161-.175.161-.387A.452.452,0,0,0,15.442,0C15.3,0,13.669.278,11.8.613Z"
                  transform="translate(9.99 13.733)"
                  fill="#6115ad"
                />
                <path
                  id="Path_309"
                  data-name="Path 309"
                  d="M4.336.285,2.366.642c-2.423.438-2.394.423-2.357.912.036.547.015.547,3.313-.036C6.467.963,6.489.956,6.489.511A.54.54,0,0,0,6.029,0C5.942,0,5.183.132,4.336.285Z"
                  transform="translate(21.286 18.988)"
                  fill="#6115ad"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ):(
      <svg xmlns="http://www.w3.org/2000/svg" width="104.706" height="40" viewBox="0 0 104.706 40">
        <g id="tennis-logo" transform="translate(1938.318 -3250)">
          <circle id="Ellipse_52" data-name="Ellipse 52" cx="11.655" cy="11.655" r="11.655" transform="translate(-1856.921 3262.161)" fill="#c4e04c"/>
          <path id="Ellipse_52_-_Outline" data-name="Ellipse 52 - Outline" d="M11.655,1.013A10.641,10.641,0,1,0,22.3,11.655,10.653,10.653,0,0,0,11.655,1.013m0-1.013A11.655,11.655,0,1,1,0,11.655,11.655,11.655,0,0,1,11.655,0Z" transform="translate(-1856.921 3262.161)" fill="#000001"/>
          <path id="Path_361" data-name="Path 361" d="M-1846.562,3281.254a7.969,7.969,0,0,1-1.958-.248,8.438,8.438,0,0,1-4.06-2.384,8.233,8.233,0,0,1-2.174-4.524,3.8,3.8,0,0,0-2.162-3.045.507.507,0,0,1-.313-.645.507.507,0,0,1,.644-.313,4.779,4.779,0,0,1,2.831,3.836l0,.016a7.318,7.318,0,0,0,5.481,6.076,6.189,6.189,0,0,0,6.7-2.317,5.86,5.86,0,0,0,.746-6.068c-.985-2.3-3.172-4.038-4.6-4.216-3.016-.377-6.073-3.269-6.1-3.3l.679-.751.715.584a.5.5,0,0,1,.095.1,10.828,10.828,0,0,0,4.738,2.357,6.049,6.049,0,0,1,2.965,1.52,9.319,9.319,0,0,1,2.438,3.3,7.064,7.064,0,0,1,.582,3.4,7.135,7.135,0,0,1-1.446,3.671,7.165,7.165,0,0,1-3.594,2.606A7.316,7.316,0,0,1-1846.562,3281.254Z" transform="translate(1.089 0.18)"/>
          <g id="Group_515" data-name="Group 515" transform="translate(-1866.549 3250)">
            <path id="Path_362" data-name="Path 362" d="M-1851.632,3260.671a.757.757,0,0,1-.537-.223l-4.631-4.631a.76.76,0,0,1,0-1.075.76.76,0,0,1,1.075,0l4.631,4.631a.76.76,0,0,1,0,1.075A.758.758,0,0,1-1851.632,3260.671Z" transform="translate(1867.641 -3249.939)"/>
            <path id="Path_364" data-name="Path 364" d="M-1850.182,3262.121a.757.757,0,0,1-.537-.223l-6.081-6.081a.76.76,0,0,1,0-1.075.76.76,0,0,1,1.075,0l6.081,6.081a.76.76,0,0,1,0,1.075A.757.757,0,0,1-1850.182,3262.121Z" transform="translate(1860.048 -3245.308)"/>
            <path id="Path_365" data-name="Path 365" d="M-1852.5,3259.6a.758.758,0,0,1-.522-.208l-3.765-3.563a.76.76,0,0,1-.03-1.074.76.76,0,0,1,1.075-.03l3.765,3.563a.76.76,0,0,1,.03,1.074A.757.757,0,0,1-1852.5,3259.6Z" transform="translate(1860.048 -3239.75)"/>
            <path id="Path_363" data-name="Path 363" d="M-1845.674,3266.628a.757.757,0,0,1-.537-.223l-10.588-10.588a.76.76,0,0,1,0-1.075.76.76,0,0,1,1.075,0l10.588,10.588a.76.76,0,0,1,0,1.075A.758.758,0,0,1-1845.674,3266.628Z" transform="translate(1858.52 -3252.979)"/>
            <circle id="Ellipse_53" data-name="Ellipse 53" cx="0.76" cy="0.76" r="0.76"/>
            <path id="Ellipse_53_-_Outline" data-name="Ellipse 53 - Outline" d="M.76,0A.76.76,0,1,1,0,.76.76.76,0,0,1,.76,0Z"/>
            <circle id="Ellipse_54" data-name="Ellipse 54" cx="0.76" cy="0.76" r="0.76" transform="translate(1.52 13.175)"/>
            <path id="Ellipse_54_-_Outline" data-name="Ellipse 54 - Outline" d="M.76,0A.76.76,0,1,1,0,.76.76.76,0,0,1,.76,0Z" transform="translate(1.52 13.175)"/>
          </g>
          <path id="Path_361-2" data-name="Path 361" d="M3.682-15.353l.72-3.358H19.764l-.72,3.358H13.37L10.063.253H6.075L9.381-15.353ZM24.061-2.9a4.469,4.469,0,0,0,.888-.965h3.744a6.172,6.172,0,0,1-1.84,2.535A7.828,7.828,0,0,1,21.372.716a5.81,5.81,0,0,1-4.355-1.724q-1.679-1.724-.856-5.61a9.766,9.766,0,0,1,3.03-5.584,7.745,7.745,0,0,1,5.2-1.943,6.484,6.484,0,0,1,3.017.656,4.019,4.019,0,0,1,1.872,2.071,5.916,5.916,0,0,1,.45,2.895,17.958,17.958,0,0,1-.463,2.779h-9.6q-.373,2.11.695,2.959a2.615,2.615,0,0,0,1.711.528A3.19,3.19,0,0,0,24.061-2.9Zm-.309-8.221a3.049,3.049,0,0,0-2.142.8,5.086,5.086,0,0,0-1.332,2.161h5.7a2.685,2.685,0,0,0-.418-2.206A2.237,2.237,0,0,0,23.752-11.12ZM41.224-8.277a3.534,3.534,0,0,0,.064-1.7q-.309-1.081-1.827-1.081a3.264,3.264,0,0,0-2.895,1.583,6.276,6.276,0,0,0-.811,2.136L34.148.253H30.494l2.972-14H37L36.567-11.7a8.541,8.541,0,0,1,1.673-1.557,5.488,5.488,0,0,1,3.049-.849A4.488,4.488,0,0,1,44.6-12.967q1.139,1.139.585,3.776L43.18.253H39.423Zm16.1,0a3.534,3.534,0,0,0,.064-1.7q-.309-1.081-1.827-1.081a3.264,3.264,0,0,0-2.895,1.583,6.276,6.276,0,0,0-.811,2.136L50.243.253H46.589l2.972-14H53.1L52.662-11.7a8.541,8.541,0,0,1,1.673-1.557,5.488,5.488,0,0,1,3.049-.849A4.488,4.488,0,0,1,60.7-12.967q1.139,1.139.585,3.776L59.275.253H55.518Zm8.363-5.494H69.4L66.429.253H62.71Zm1.081-5.056h3.718l-.72,3.384H66.043Zm8.633,8.71a.758.758,0,0,0,.347.913,19.714,19.714,0,0,0,3.6,1.016A5.466,5.466,0,0,1,82.292-6.63a2.986,2.986,0,0,1,.528,2.638,5.535,5.535,0,0,1-2.277,3.4A8.528,8.528,0,0,1,75.473.729q-3.307,0-4.587-1.4a3.814,3.814,0,0,1-.83-3.557h3.718a2.052,2.052,0,0,0,.219,1.39q.515.733,2.354.733a4.332,4.332,0,0,0,1.788-.322,1.373,1.373,0,0,0,.849-.965.845.845,0,0,0-.322-.939,17.625,17.625,0,0,0-3.59-1.106,6.2,6.2,0,0,1-3.036-1.48A2.7,2.7,0,0,1,71.6-9.435a5.643,5.643,0,0,1,2.232-3.339,7.318,7.318,0,0,1,4.587-1.4,6.756,6.756,0,0,1,4.053,1.049Q83.9-12.073,83.6-9.5H79.938a1.924,1.924,0,0,0-.167-1.119,2.059,2.059,0,0,0-1.9-.746,3.374,3.374,0,0,0-1.782.373A1.4,1.4,0,0,0,75.4-10.117Z" transform="translate(-1942 3289.271)" fill="#004331"/>
        </g>
      </svg>
  );
};
export const QuoteIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61.042"
      height="48"
      viewBox="0 0 61.042 48"
    >
      <path
        id="quote"
        d="M32.507-79.1a33.328,33.328,0,0,0-7.743,3.26,28.763,28.763,0,0,0-6.249,4.845A22.965,22.965,0,0,0,14.3-65.058a14.764,14.764,0,0,0-1.54,6.521,7.169,7.169,0,0,0,.815,3.487q.815,1.494,1.9,1.494a3.794,3.794,0,0,0,1.947-.453q.77-.453,1.585-1a11.886,11.886,0,0,1,1.857-1,7.028,7.028,0,0,1,2.762-.453,7.671,7.671,0,0,1,3.4.77,9.106,9.106,0,0,1,2.808,2.128,10.29,10.29,0,0,1,1.947,3.26,11.351,11.351,0,0,1,.725,4.075,9.583,9.583,0,0,1-1,4.347,11.021,11.021,0,0,1-2.672,3.442,13.175,13.175,0,0,1-3.894,2.309,13.036,13.036,0,0,1-4.755.86,13.437,13.437,0,0,1-6.249-1.494A16.43,16.43,0,0,1,8.87-40.832a20.1,20.1,0,0,1-3.442-5.977A20.677,20.677,0,0,1,4.16-54.1,27.406,27.406,0,0,1,6.47-65.42a29.852,29.852,0,0,1,6.158-9.011,29.852,29.852,0,0,1,9.011-6.158,31.246,31.246,0,0,1,10.868-2.672Zm32.694,0a34.707,34.707,0,0,0-7.7,3.26,27.38,27.38,0,0,0-6.249,4.845,23.514,23.514,0,0,0-4.166,5.932,14.764,14.764,0,0,0-1.54,6.521,7.514,7.514,0,0,0,.77,3.487,2.255,2.255,0,0,0,1.947,1.494,3.794,3.794,0,0,0,1.947-.453q.77-.453,1.54-1a10.164,10.164,0,0,1,1.811-1,7.028,7.028,0,0,1,2.762-.453,7.671,7.671,0,0,1,3.4.77,9.106,9.106,0,0,1,2.808,2.128,10.29,10.29,0,0,1,1.947,3.26A11.351,11.351,0,0,1,65.2-46.22a9.961,9.961,0,0,1-.951,4.347,10.46,10.46,0,0,1-2.626,3.442,13.038,13.038,0,0,1-3.94,2.309,13.4,13.4,0,0,1-4.8.86,13.437,13.437,0,0,1-6.249-1.494,16.43,16.43,0,0,1-5.072-4.075,20.1,20.1,0,0,1-3.442-5.977A20.677,20.677,0,0,1,36.854-54.1,27.406,27.406,0,0,1,39.164-65.42a29.445,29.445,0,0,1,6.2-9.011,30.619,30.619,0,0,1,9.011-6.158A30.838,30.838,0,0,1,65.2-83.262Z"
        transform="translate(-4.16 83.262)"
        fill="#e1e87e"
        opacity="0.3"
      />
    </svg>
  );
};
export const PriceBackgroundIcon = ({ width, height, isPickleball }) => {
  if (isPickleball) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "65.2"}
        height={height ? height : "66"}
        viewBox="0 0 65.2 66"
      >
        <defs>
          <filter
            id="Path_46"
            x="0"
            y="0"
            width="65.2"
            height="66"
            filterUnits="userSpaceOnUse"
          >
            <feOffset dy="3" input="SourceAlpha" />
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feFlood flood-opacity="0.392" />
            <feComposite operator="in" in2="blur" />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g id="Component_1_21" transform="translate(9 6)">
          <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Path_46)">
            <path
              id="Path_46-2"
              data-name="Path 46"
              d="M1952.828,3273.94h38.954l-8.3,48-18.84-7.7-20.064,7.1Z"
              transform="translate(-1935.58 -3267.94)"
              fill="#340761"
            />
          </g>
        </g>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "65.2"}
      height={height ? height : "66"}
      viewBox="0 0 65.2 66"
    >
      <defs>
        <filter
          id="Path_46"
          x="0"
          y="0"
          width="65.2"
          height="66"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.392" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="price-bg" transform="translate(9 6)">
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Path_46)">
          <path
            id="Path_46-2"
            data-name="Path 46"
            d="M1952.828,3273.94h38.954l-8.3,48-18.84-7.7-20.064,7.1Z"
            transform="translate(-1935.58 -3267.94)"
            fill="#55b56a"
          />
        </g>
      </g>
    </svg>
  );
};

export const MatchesIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="matches" transform="translate(27 -3) rotate(90)">
          <path
            id="Path_89"
            data-name="Path 89"
            d="M0,0H19.862V11.172H0Z"
            transform="translate(24.931 27) rotate(180)"
            fill="#340761"
          />
          <path
            id="Path_90"
            data-name="Path 90"
            d="M0,0H16.552V9.517H0Z"
            transform="translate(23.276 25.345) rotate(180)"
            fill="#e1e87e"
          />
          <path
            id="Path_91"
            data-name="Path 91"
            d="M12,41H28.552v6.621H12Z"
            transform="translate(-5.276 -22.276)"
            fill="#c8d952"
          />
          <path
            id="Path_92"
            data-name="Path 92"
            d="M46.069,51.069H44v-.828h1.241V49h.828Z"
            transform="translate(-24.034 -26.966)"
            fill="#fff"
          />
          <path
            id="Path_93"
            data-name="Path 93"
            d="M17.069,51.069H15V49h.828v1.241h1.241Z"
            transform="translate(-7.034 -26.966)"
            fill="#fff"
          />
          <path
            id="Path_94"
            data-name="Path 94"
            d="M31,51h.828v.828H31Z"
            transform="translate(-16.414 -28.138)"
            fill="#fff"
          />
          <path
            id="Path_95"
            data-name="Path 95"
            d="M31,47h.828v.828H31Z"
            transform="translate(-16.414 -25.793)"
            fill="#fff"
          />
          <path
            id="Path_96"
            data-name="Path 96"
            d="M8,3H27.862V14.172H8Z"
            transform="translate(-2.931)"
            fill="#340761"
          />
          <path
            id="Path_97"
            data-name="Path 97"
            d="M12,7H28.552v9.517H12Z"
            transform="translate(-5.276 -2.345)"
            fill="#e1e87e"
          />
          <path
            id="Path_98"
            data-name="Path 98"
            d="M12,7H28.552v6.621H12Z"
            transform="translate(-5.276 -2.345)"
            fill="#c8d952"
          />
          <g
            id="Group_108"
            data-name="Group 108"
            transform="translate(7.966 5.897)"
          >
            <path
              id="Path_99"
              data-name="Path 99"
              d="M31,23h.828v2.9H31Z"
              transform="translate(-24.379 -17.621)"
              fill="#fff"
            />
            <path
              id="Path_100"
              data-name="Path 100"
              d="M31,34h.828v2.9H31Z"
              transform="translate(-24.379 -24.069)"
              fill="#fff"
            />
            <path
              id="Path_101"
              data-name="Path 101"
              d="M15.828,12.069H15V10h2.069v.828H15.828Z"
              transform="translate(-15 -10)"
              fill="#fff"
            />
            <path
              id="Path_102"
              data-name="Path 102"
              d="M46.069,12.069h-.828V10.828H44V10h2.069Z"
              transform="translate(-32 -10)"
              fill="#fff"
            />
            <path
              id="Path_103"
              data-name="Path 103"
              d="M31,11h.828v.828H31Z"
              transform="translate(-24.379 -10.586)"
              fill="#fff"
            />
            <path
              id="Path_104"
              data-name="Path 104"
              d="M31,15h.828v.828H31Z"
              transform="translate(-24.379 -12.931)"
              fill="#fff"
            />
          </g>
          <path
            id="Path_105"
            data-name="Path 105"
            d="M3,30H27v1.655H3Z"
            transform="translate(0 -15.828)"
            fill="#6115ad"
          />
        </g>
      </svg>
    );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Matches" transform="translate(27 -3) rotate(90)">
        <path
          id="Path_89"
          data-name="Path 89"
          d="M0,0H19.862V11.172H0Z"
          transform="translate(24.931 27) rotate(180)"
          fill="#55b56a"
        />
        <path
          id="Path_90"
          data-name="Path 90"
          d="M0,0H16.552V9.517H0Z"
          transform="translate(23.276 25.345) rotate(180)"
          fill="#e1e87e"
        />
        <path
          id="Path_91"
          data-name="Path 91"
          d="M12,41H28.552v6.621H12Z"
          transform="translate(-5.276 -22.276)"
          fill="#c8d952"
        />
        <path
          id="Path_92"
          data-name="Path 92"
          d="M46.069,51.069H44v-.828h1.241V49h.828Z"
          transform="translate(-24.034 -26.966)"
          fill="#fff"
        />
        <path
          id="Path_93"
          data-name="Path 93"
          d="M17.069,51.069H15V49h.828v1.241h1.241Z"
          transform="translate(-7.034 -26.966)"
          fill="#fff"
        />
        <path
          id="Path_94"
          data-name="Path 94"
          d="M31,51h.828v.828H31Z"
          transform="translate(-16.414 -28.138)"
          fill="#fff"
        />
        <path
          id="Path_95"
          data-name="Path 95"
          d="M31,47h.828v.828H31Z"
          transform="translate(-16.414 -25.793)"
          fill="#fff"
        />
        <path
          id="Path_96"
          data-name="Path 96"
          d="M8,3H27.862V14.172H8Z"
          transform="translate(-2.931)"
          fill="#55b56a"
        />
        <path
          id="Path_97"
          data-name="Path 97"
          d="M12,7H28.552v9.517H12Z"
          transform="translate(-5.276 -2.345)"
          fill="#e1e87e"
        />
        <path
          id="Path_98"
          data-name="Path 98"
          d="M12,7H28.552v6.621H12Z"
          transform="translate(-5.276 -2.345)"
          fill="#c8d952"
        />
        <g
          id="Group_108"
          data-name="Group 108"
          transform="translate(7.966 5.897)"
        >
          <path
            id="Path_99"
            data-name="Path 99"
            d="M31,23h.828v2.9H31Z"
            transform="translate(-24.379 -17.621)"
            fill="#fff"
          />
          <path
            id="Path_100"
            data-name="Path 100"
            d="M31,34h.828v2.9H31Z"
            transform="translate(-24.379 -24.069)"
            fill="#fff"
          />
          <path
            id="Path_101"
            data-name="Path 101"
            d="M15.828,12.069H15V10h2.069v.828H15.828Z"
            transform="translate(-15 -10)"
            fill="#fff"
          />
          <path
            id="Path_102"
            data-name="Path 102"
            d="M46.069,12.069h-.828V10.828H44V10h2.069Z"
            transform="translate(-32 -10)"
            fill="#fff"
          />
          <path
            id="Path_103"
            data-name="Path 103"
            d="M31,11h.828v.828H31Z"
            transform="translate(-24.379 -10.586)"
            fill="#fff"
          />
          <path
            id="Path_104"
            data-name="Path 104"
            d="M31,15h.828v.828H31Z"
            transform="translate(-24.379 -12.931)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_105"
          data-name="Path 105"
          d="M3,30H27v1.655H3Z"
          transform="translate(0 -15.828)"
          fill="#028360"
        />
      </g>
    </svg>
  );
};
export const EventsIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.999"
        height="24"
        viewBox="0 0 27.999 24"
      >
        <g id="pickleball-league" transform="translate(3.984)">
          <g
            id="Group_106"
            data-name="Group 106"
            transform="translate(8.825 0.579)"
          >
            <rect
              id="Rectangle_147"
              data-name="Rectangle 147"
              width="1.5"
              height="13.502"
              transform="translate(12.613 11.551) rotate(135)"
              fill="#6115ad"
            />
            <rect
              id="Rectangle_148"
              data-name="Rectangle 148"
              width="1.5"
              height="11.671"
              transform="translate(14.616 8.253) rotate(135)"
              fill="#6115ad"
            />
            <rect
              id="Rectangle_149"
              data-name="Rectangle 149"
              width="1.5"
              height="11.671"
              transform="translate(9.314 13.555) rotate(135)"
              fill="#6115ad"
            />
            <rect
              id="Rectangle_150"
              data-name="Rectangle 150"
              width="14.132"
              height="1.5"
              transform="translate(11.243 1.256) rotate(135)"
              fill="#6115ad"
            />
            <rect
              id="Rectangle_151"
              data-name="Rectangle 151"
              width="14.132"
              height="1.5"
              transform="translate(14.425 4.432) rotate(135)"
              fill="#6115ad"
            />
          </g>
          <path
            id="Path_71"
            data-name="Path 71"
            d="M117.12,2.165C114.195-.76,109.2-.52,105.981,2.7a8.615,8.615,0,0,0-2.574,5.719h0l-.285,6.686-3.054,3.054a.751.751,0,0,0,1.062,1.061l3.054-3.054,6.686-.284h0A8.628,8.628,0,0,0,116.59,13.3C119.805,10.085,120.044,5.089,117.12,2.165ZM105.45,13.834a7.082,7.082,0,0,0,.9.734l-1.706.072.074-1.716A6.841,6.841,0,0,0,105.45,13.834Zm5.354.545a5.529,5.529,0,0,1-5.9-5.9,7.127,7.127,0,0,1,2.136-4.723,7.126,7.126,0,0,1,4.994-2.141,5.62,5.62,0,0,1,4.023,1.611c2.339,2.34,2.1,6.385-.531,9.016A7.123,7.123,0,0,1,110.8,14.378Z"
            transform="translate(-95.152 -0.113)"
            fill="#340761"
          />
          <path
            id="Path_72"
            data-name="Path 72"
            d="M5.987,371.853a2.308,2.308,0,0,0-3.183,0L.682,373.974a2.25,2.25,0,0,0,3.183,3.182l2.121-2.121A2.252,2.252,0,0,0,5.987,371.853Z"
            transform="translate(-0.008 -353.813)"
            fill="#6115ad"
          />
          <g id="tennis-ball" transform="translate(-3.984)">
            <circle
              id="Ellipse_14"
              data-name="Ellipse 14"
              cx="4"
              cy="4"
              r="4"
              transform="translate(0 0)"
              fill="#340761"
            />
            <path
              id="Path_52"
              data-name="Path 52"
              d="M70.477,100.238l-.564-.263a2.562,2.562,0,0,0-2.343.127l-.068.038a1.937,1.937,0,0,1-1.037.3,1.972,1.972,0,0,1,0-3.943,1.933,1.933,0,0,1,1.037.3l.065.038h0a2.567,2.567,0,0,0,2.341.127l.566-.264a4.031,4.031,0,0,0-.241-.418l-.525.231a2.072,2.072,0,0,1-1.943-.132l-.065-.037h0A2.433,2.433,0,0,0,66.465,96a2.465,2.465,0,0,0,0,4.929,2.429,2.429,0,0,0,1.238-.335l.066-.037a2.075,2.075,0,0,1,1.945-.132l.523.23A3.971,3.971,0,0,0,70.477,100.238Z"
              transform="translate(-63.014 -94.521)"
              fill="#fafafa"
            />
          </g>
        </g>
      </svg>
    );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.998"
      height="24"
      viewBox="0 0 27.998 24"
    >
      <g id="Events" transform="translate(3.984)">
        <g
          id="Group_106"
          data-name="Group 106"
          transform="translate(8.825 0.579)"
        >
          <rect
            id="Rectangle_147"
            data-name="Rectangle 147"
            width="1.5"
            height="13.502"
            transform="translate(12.613 11.551) rotate(135)"
            fill="#028360"
          />
          <rect
            id="Rectangle_148"
            data-name="Rectangle 148"
            width="1.5"
            height="11.671"
            transform="translate(14.616 8.253) rotate(135)"
            fill="#028360"
          />
          <rect
            id="Rectangle_149"
            data-name="Rectangle 149"
            width="1.5"
            height="11.671"
            transform="translate(9.314 13.555) rotate(135)"
            fill="#028360"
          />
          <rect
            id="Rectangle_150"
            data-name="Rectangle 150"
            width="14.132"
            height="1.5"
            transform="translate(11.243 1.256) rotate(135)"
            fill="#028360"
          />
          <rect
            id="Rectangle_151"
            data-name="Rectangle 151"
            width="14.132"
            height="1.5"
            transform="translate(14.425 4.432) rotate(135)"
            fill="#028360"
          />
        </g>
        <path
          id="Path_71"
          data-name="Path 71"
          d="M117.12,2.165C114.195-.76,109.2-.52,105.981,2.7a8.615,8.615,0,0,0-2.574,5.719h0l-.285,6.686-3.054,3.054a.751.751,0,0,0,1.062,1.061l3.054-3.054,6.686-.284h0A8.628,8.628,0,0,0,116.59,13.3C119.805,10.085,120.044,5.089,117.12,2.165ZM105.45,13.834a7.082,7.082,0,0,0,.9.734l-1.706.072.074-1.716A6.841,6.841,0,0,0,105.45,13.834Zm5.354.545a5.529,5.529,0,0,1-5.9-5.9,7.127,7.127,0,0,1,2.136-4.723,7.126,7.126,0,0,1,4.994-2.141,5.62,5.62,0,0,1,4.023,1.611c2.339,2.34,2.1,6.385-.531,9.016A7.123,7.123,0,0,1,110.8,14.378Z"
          transform="translate(-95.152 -0.113)"
          fill="#55b56a"
        />
        <path
          id="Path_72"
          data-name="Path 72"
          d="M5.987,371.853a2.308,2.308,0,0,0-3.183,0L.682,373.974a2.25,2.25,0,0,0,3.183,3.182l2.121-2.121A2.252,2.252,0,0,0,5.987,371.853Z"
          transform="translate(-0.008 -353.813)"
          fill="#028360"
        />
        <g id="tennis-ball" transform="translate(-3.984)">
          <circle
            id="Ellipse_14"
            data-name="Ellipse 14"
            cx="4"
            cy="4"
            r="4"
            transform="translate(0 0)"
            fill="#55b56a"
          />
          <path
            id="Path_52"
            data-name="Path 52"
            d="M70.477,100.238l-.564-.263a2.562,2.562,0,0,0-2.343.127l-.068.038a1.937,1.937,0,0,1-1.037.3,1.972,1.972,0,0,1,0-3.943,1.933,1.933,0,0,1,1.037.3l.065.038h0a2.567,2.567,0,0,0,2.341.127l.566-.264a4.031,4.031,0,0,0-.241-.418l-.525.231a2.072,2.072,0,0,1-1.943-.132l-.065-.037h0A2.433,2.433,0,0,0,66.465,96a2.465,2.465,0,0,0,0,4.929,2.429,2.429,0,0,0,1.238-.335l.066-.037a2.075,2.075,0,0,1,1.945-.132l.523.23A3.971,3.971,0,0,0,70.477,100.238Z"
            transform="translate(-63.014 -94.521)"
            fill="#fafafa"
          />
        </g>
      </g>
    </svg>
  );
};

export const LeaderboardIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="leaderboard" transform="translate(-3 -3)">
          <g
            id="Group_109"
            data-name="Group 109"
            transform="translate(5.069 4.241)"
          >
            <path
              id="Path_106"
              data-name="Path 106"
              d="M37,6h.828V8.069H37Z"
              transform="translate(-25 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_107"
              data-name="Path 107"
              d="M41,6h.828V8.069H41Z"
              transform="translate(-27.345 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_108"
              data-name="Path 108"
              d="M48,6h.828V8.069H48Z"
              transform="translate(-31.448 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_109"
              data-name="Path 109"
              d="M54,6h.828V8.069H54Z"
              transform="translate(-34.966 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_110"
              data-name="Path 110"
              d="M25,6h.828V8.069H25Z"
              transform="translate(-17.966 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_111"
              data-name="Path 111"
              d="M21,6h.828V8.069H21Z"
              transform="translate(-15.621 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_112"
              data-name="Path 112"
              d="M14,6h.828V8.069H14Z"
              transform="translate(-11.517 -6)"
              fill="#c8d952"
            />
            <path
              id="Path_113"
              data-name="Path 113"
              d="M8,6h.828V8.069H8Z"
              transform="translate(-8 -6)"
              fill="#c8d952"
            />
          </g>
          <path
            id="Path_114"
            data-name="Path 114"
            d="M6,11h4.966v7.448H6Z"
            transform="translate(-1.759 -4.69)"
            fill="#e1e87e"
          />
          <path
            id="Path_115"
            data-name="Path 115"
            d="M46,11h4.966v7.448H46Z"
            transform="translate(-25.207 -4.69)"
            fill="#e1e87e"
          />
          <path
            id="Path_116"
            data-name="Path 116"
            d="M51.483,18.966H49V17.139l1.655-1.655v-.656h-.828v.828H49V14h2.483v1.826l-1.655,1.655v.656h1.655Z"
            transform="translate(-26.966 -6.448)"
            fill="#6115ad"
          />
          <path
            id="Path_117"
            data-name="Path 117"
            d="M3,3V4.655H14.172V15.414h1.655V4.655H27V3Z"
            transform="translate(0 0)"
            fill="#6115ad"
          />
          <path
            id="Path_118"
            data-name="Path 118"
            d="M30,45h1.655v6.621H30Z"
            transform="translate(-15.828 -24.621)"
            fill="#6115ad"
          />
          <path
            id="Path_119"
            data-name="Path 119"
            d="M13,33H28.724v4.966H13Z"
            transform="translate(-5.862 -17.586)"
            fill="#340761"
          />
          <path
            id="Path_120"
            data-name="Path 120"
            d="M21,36h.828v.828H21Z"
            transform="translate(-10.552 -19.345)"
            fill="#fcf05a"
          />
          <path
            id="Path_121"
            data-name="Path 121"
            d="M41,36h.828v.828H41Z"
            transform="translate(-22.276 -19.345)"
            fill="#fcf05a"
          />
          <path
            id="Path_122"
            data-name="Path 122"
            d="M18,11h4.966v5.793H18Z"
            transform="translate(-8.793 -4.69)"
            fill="#340761"
          />
          <path
            id="Path_123"
            data-name="Path 123"
            d="M34,11h4.966v5.793H34Z"
            transform="translate(-18.172 -4.69)"
            fill="#340761"
          />
          <path
            id="Path_124"
            data-name="Path 124"
            d="M39.483,17.31H37V14h2.483Zm-1.655-.828h.828V14.828h-.828Z"
            transform="translate(-19.931 -6.448)"
            fill="#fff"
          />
          <path
            id="Path_125"
            data-name="Path 125"
            d="M9,14.828h1.655v1.241H9V16.9h1.655v1.241H9v.828h2.483V14H9Z"
            transform="translate(-3.517 -6.448)"
            fill="#6115ad"
          />
          <path
            id="Path_126"
            data-name="Path 126"
            d="M22.241,16.483V14h-1l-.949.949.585.585L21.413,15v1.484h-.828v.828h2.483v-.828Z"
            transform="translate(-10.137 -6.448)"
            fill="#fff"
          />
        </g>
      </svg>
    );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Leaderboard" transform="translate(-3 -3)">
        <g
          id="Group_109"
          data-name="Group 109"
          transform="translate(5.069 4.241)"
        >
          <path
            id="Path_106"
            data-name="Path 106"
            d="M37,6h.828V8.069H37Z"
            transform="translate(-25 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_107"
            data-name="Path 107"
            d="M41,6h.828V8.069H41Z"
            transform="translate(-27.345 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_108"
            data-name="Path 108"
            d="M48,6h.828V8.069H48Z"
            transform="translate(-31.448 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_109"
            data-name="Path 109"
            d="M54,6h.828V8.069H54Z"
            transform="translate(-34.966 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_110"
            data-name="Path 110"
            d="M25,6h.828V8.069H25Z"
            transform="translate(-17.966 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_111"
            data-name="Path 111"
            d="M21,6h.828V8.069H21Z"
            transform="translate(-15.621 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_112"
            data-name="Path 112"
            d="M14,6h.828V8.069H14Z"
            transform="translate(-11.517 -6)"
            fill="#c8d952"
          />
          <path
            id="Path_113"
            data-name="Path 113"
            d="M8,6h.828V8.069H8Z"
            transform="translate(-8 -6)"
            fill="#c8d952"
          />
        </g>
        <path
          id="Path_114"
          data-name="Path 114"
          d="M6,11h4.966v7.448H6Z"
          transform="translate(-1.759 -4.69)"
          fill="#e1e87e"
        />
        <path
          id="Path_115"
          data-name="Path 115"
          d="M46,11h4.966v7.448H46Z"
          transform="translate(-25.207 -4.69)"
          fill="#e1e87e"
        />
        <path
          id="Path_116"
          data-name="Path 116"
          d="M51.483,18.966H49V17.139l1.655-1.655v-.656h-.828v.828H49V14h2.483v1.826l-1.655,1.655v.656h1.655Z"
          transform="translate(-26.966 -6.448)"
          fill="#028360"
        />
        <path
          id="Path_117"
          data-name="Path 117"
          d="M3,3V4.655H14.172V15.414h1.655V4.655H27V3Z"
          transform="translate(0 0)"
          fill="#028360"
        />
        <path
          id="Path_118"
          data-name="Path 118"
          d="M30,45h1.655v6.621H30Z"
          transform="translate(-15.828 -24.621)"
          fill="#028360"
        />
        <path
          id="Path_119"
          data-name="Path 119"
          d="M13,33H28.724v4.966H13Z"
          transform="translate(-5.862 -17.586)"
          fill="#55b56a"
        />
        <path
          id="Path_120"
          data-name="Path 120"
          d="M21,36h.828v.828H21Z"
          transform="translate(-10.552 -19.345)"
          fill="#fcf05a"
        />
        <path
          id="Path_121"
          data-name="Path 121"
          d="M41,36h.828v.828H41Z"
          transform="translate(-22.276 -19.345)"
          fill="#fcf05a"
        />
        <path
          id="Path_122"
          data-name="Path 122"
          d="M18,11h4.966v5.793H18Z"
          transform="translate(-8.793 -4.69)"
          fill="#55b56a"
        />
        <path
          id="Path_123"
          data-name="Path 123"
          d="M34,11h4.966v5.793H34Z"
          transform="translate(-18.172 -4.69)"
          fill="#55b56a"
        />
        <path
          id="Path_124"
          data-name="Path 124"
          d="M39.483,17.31H37V14h2.483Zm-1.655-.828h.828V14.828h-.828Z"
          transform="translate(-19.931 -6.448)"
          fill="#fff"
        />
        <path
          id="Path_125"
          data-name="Path 125"
          d="M9,14.828h1.655v1.241H9V16.9h1.655v1.241H9v.828h2.483V14H9Z"
          transform="translate(-3.517 -6.448)"
          fill="#028360"
        />
        <path
          id="Path_126"
          data-name="Path 126"
          d="M22.241,16.483V14h-1l-.949.949.585.585L21.413,15v1.484h-.828v.828h2.483v-.828Z"
          transform="translate(-10.137 -6.448)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const GSMIcon = ({ width, height, mobile }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={mobile ? "30" : "57.412"}
      height="59.323"
      viewBox="0 0 57.412 59.323"
    >
      <g id="logo-ico" transform="translate(-214 -179.677)">
        <g id="Group_56" data-name="Group 56" transform="translate(214 179)">
          <g id="Group_55" data-name="Group 55" transform="translate(0 0)">
            <g id="Group_38" data-name="Group 38" transform="translate(0 0)">
              <path
                id="Path_39"
                data-name="Path 39"
                d="M1953.451,3273.939h41.894l-8.922,51.624-20.262-8.286-21.579,7.637Z"
                transform="translate(-1944.582 -3265.608)"
                fill="#55b56a"
              />
              <g
                id="Group_36"
                data-name="Group 36"
                transform="translate(34.619 0) rotate(7)"
              >
                <path
                  id="Subtraction_2"
                  data-name="Subtraction 2"
                  d="M0,21.565H0a35.011,35.011,0,0,0,3.558-3.94A41.874,41.874,0,0,0,6.13,13.918a31.064,31.064,0,0,0,2.077-3.847,31.729,31.729,0,0,1-3.616,4.7c-1.216,1.344-2.22,2.31-2.238,2.31a28.819,28.819,0,0,0,3.149-4.2A34.3,34.3,0,0,0,7.593,8.956,28.6,28.6,0,0,0,9.118,4.889a5.823,5.823,0,0,0,1.194.709,8.539,8.539,0,0,0,2.043.723A32.545,32.545,0,0,1,8.742,12.8a38.408,38.408,0,0,1-4.053,4.784A38.094,38.094,0,0,1,1.38,20.549C.538,21.215.018,21.557,0,21.565Zm3.227-1.389h0A57.2,57.2,0,0,0,9.368,15a35.018,35.018,0,0,0,3.678-4.187,17.216,17.216,0,0,0,2.423-4.4,8.512,8.512,0,0,0,2.839-.96,31.48,31.48,0,0,1-4.554,6.6,36.5,36.5,0,0,1-4.936,4.581A36.68,36.68,0,0,1,4.856,19.31C3.849,19.893,3.233,20.173,3.227,20.176ZM.069,20.105h0a46.825,46.825,0,0,0,3.5-7.233A38.3,38.3,0,0,0,5.311,6.906a29.151,29.151,0,0,0,.558-4.323,14.76,14.76,0,0,0-.035-2.3c.065.183.185.455.355.808a8.585,8.585,0,0,0,.735,1.44c.215.406.409.764.525.978h0c.071.13.113.209.113.211a28.629,28.629,0,0,1-1.688,6.53,35.069,35.069,0,0,1-2.516,5.191A31.8,31.8,0,0,1,.069,20.105ZM9.794,12.3h0a17.886,17.886,0,0,0,2.534-3.882,6.932,6.932,0,0,0,.622-1.987c.235.034.476.058.716.072A13.242,13.242,0,0,1,9.794,12.3ZM6.509,9.383h0A13.035,13.035,0,0,0,8.33,4.218c.153.143.315.282.481.415A11.659,11.659,0,0,1,6.509,9.383ZM5.832.277A.652.652,0,0,1,5.773.01c0-.007,0-.01.005-.01a.8.8,0,0,1,.054.277Z"
                  transform="translate(0 10.725)"
                  fill="#55b56a"
                />
                <g
                  id="Ellipse_8"
                  data-name="Ellipse 8"
                  transform="translate(5.559 0)"
                  fill="#55b56a"
                  stroke="#028360"
                  strokeWidth="1"
                >
                  <circle cx="8.703" cy="8.703" r="8.703" stroke="none" />
                  <circle cx="8.703" cy="8.703" r="8.203" fill="none" />
                </g>
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M7.641,14.17c-.472-.7.314-1.908,1.174-2.693A7.868,7.868,0,0,0,11.408,8c.56-1.726.62-7.392-4.943-8C.263-.146,0,6.729,0,6.744A8.47,8.47,0,0,0,2.111,11.7,8.929,8.929,0,0,0,7.641,14.17Z"
                  transform="translate(6.222 2.815)"
                  fill="#55b56a"
                  stroke="#028360"
                  strokeLinecap="round"
                  strokeWidth="1"
                />
              </g>
              <g
                id="Group_37"
                data-name="Group 37"
                transform="translate(10.132 25.795)"
              >
                <ellipse
                  id="Ellipse_1"
                  data-name="Ellipse 1"
                  cx="3.602"
                  cy="4.693"
                  rx="3.602"
                  ry="4.693"
                  transform="translate(10.478 1.091)"
                  fill="#028360"
                />
                <path
                  id="Union_3"
                  data-name="Union 3"
                  d="M2.314,10.376c-.327-.1-.43-.678-.538-1.289a2.726,2.726,0,0,0-.459-1.351,4.547,4.547,0,0,1,.008-6.41,4.525,4.525,0,1,1,6.4,6.4,4.5,4.5,0,0,1-3.2,1.325c-.208,0-.561.294-.934.605-.432.36-.879.733-1.185.733A.3.3,0,0,1,2.314,10.376ZM4.525,7.542h0c.067-.268.17-.679.293-1.164-.332.082-.654.166-.953.245-.1.4-.167.688-.2.81A3.388,3.388,0,0,0,4.525,7.542ZM4.789,7.5l-.033.037a3.37,3.37,0,0,0,.961-.208c.083-.321.2-.757.325-1.237-.313.071-.642.148-.966.227C4.9,7.026,4.789,7.5,4.789,7.5ZM3.441,7.364c.046-.185.1-.414.169-.671-.385.1-.721.2-.976.272A3.386,3.386,0,0,0,3.441,7.364Zm2.552-.156A3.417,3.417,0,0,0,7.508,5.767c-.3.063-.727.156-1.214.265C6.164,6.519,6.06,6.934,5.992,7.208ZM2.364,6.763c.066-.261.147-.582.238-.938-.407.117-.713.208-.866.254A3.424,3.424,0,0,0,2.364,6.763Zm.255-.038c.308-.085.671-.183,1.055-.286.078-.3.164-.639.255-.987-.39.106-.753.208-1.071.3C2.757,6.155,2.675,6.492,2.619,6.725ZM3.93,6.372c.315-.083.639-.166.955-.245.081-.313.168-.65.259-.994l-.309.079c-.222.058-.441.116-.653.173C4.088,5.745,4,6.08,3.93,6.372Zm1.209-.308c.342-.084.67-.161.972-.23.089-.33.184-.674.28-1.01-.32.077-.656.16-.993.245C5.3,5.424,5.216,5.761,5.139,6.064ZM1.692,5.841c.261-.075.6-.17.977-.276.08-.309.166-.637.254-.971-.369.1-.7.2-.984.279C1.84,5.249,1.756,5.583,1.692,5.841Zm4.931-1c-.093.324-.181.64-.261.936.571-.128,1.026-.222,1.274-.273A3.368,3.368,0,0,0,7.9,4.467c-.323.074-.764.177-1.258.3ZM1.509,5.7c.06-.231.127-.49.2-.762l-.449.133A3.373,3.373,0,0,0,1.509,5.7Zm1.415-.209C3.261,5.4,3.625,5.3,4,5.2c.084-.318.171-.644.258-.963-.374.1-.737.194-1.077.288C3.085,4.867,3,5.195,2.924,5.494ZM4.482,4.267c-.082.3-.16.586-.233.864.274-.074.549-.146.818-.216l.145-.038c.084-.317.171-.637.257-.947-.314.077-.639.158-.96.24ZM1.131,4.148A3.4,3.4,0,0,0,1.2,4.84l.576-.164c.095-.355.2-.724.3-1.081-.4.113-.72.208-.932.271Q1.131,4.006,1.131,4.148Zm4.483.119c-.051.184-.1.367-.149.546.352-.089.688-.172,1-.247l.007-.026c.093-.321.185-.629.272-.915-.3.071-.652.154-1.018.243C5.688,4,5.651,4.135,5.614,4.267ZM2.239,3.775c-.082.288-.159.57-.23.836.3-.085.636-.178.982-.272.074-.278.15-.556.225-.827l.07-.253c-.349.094-.679.186-.977.27ZM6.722,4.5c.491-.117.9-.212,1.2-.277,0-.026,0-.052,0-.078a3.393,3.393,0,0,0-.089-.773c-.121.027-.42.095-.824.189C6.913,3.865,6.816,4.185,6.722,4.5ZM3.358,3.859q-.057.207-.112.411c.356-.1.722-.195,1.078-.288l.017-.063c.1-.352.194-.691.286-1.009l-.566.144-.515.135C3.483,3.412,3.419,3.637,3.358,3.859Zm1.223.056c.334-.086.656-.167.96-.242.105-.375.208-.732.3-1.062-.3.073-.628.151-.956.233C4.788,3.19,4.683,3.553,4.581,3.915ZM5.8,3.61c.383-.093.73-.175,1.024-.243.132-.426.25-.792.34-1.064-.273.062-.639.147-1.055.246C6.008,2.885,5.9,3.246,5.8,3.61Zm-4.625,0c.277-.079.611-.173.975-.274.1-.355.2-.691.294-.994-.367.1-.69.192-.94.264A3.367,3.367,0,0,0,1.174,3.61Zm5.913-.3c.345-.079.587-.131.684-.153A3.379,3.379,0,0,0,7.4,2.338C7.313,2.594,7.2,2.931,7.087,3.307Zm-4.7-.037c.312-.086.641-.176.973-.266.1-.347.194-.676.284-.978l-.068.017c-.309.078-.61.157-.89.232C2.589,2.587,2.486,2.926,2.385,3.27ZM3.62,2.934l.671-.177L4.7,2.652c.1-.352.2-.672.283-.948-.342.079-.712.166-1.08.257C3.815,2.267,3.718,2.6,3.62,2.934Zm1.346-.348c.34-.085.662-.163.957-.234.1-.351.2-.663.278-.921-.23.05-.565.124-.953.212C5.164,1.92,5.068,2.241,4.965,2.586ZM1.652,2.343c.263-.073.556-.153.863-.235.11-.356.206-.657.277-.877A3.42,3.42,0,0,0,1.652,2.343ZM6.185,2.29c.418-.1.767-.178,1.013-.232a3.423,3.423,0,0,0-.721-.686l-.015,0C6.383,1.63,6.288,1.943,6.185,2.29ZM2.756,2.044c.316-.084.641-.169.955-.248.12-.4.225-.744.306-1a3.368,3.368,0,0,0-.961.3C2.991,1.295,2.882,1.635,2.756,2.044Zm1.22-.314c.388-.1.755-.183,1.082-.258.085-.278.154-.5.2-.638A3.394,3.394,0,0,0,4.525.754q-.129,0-.256.01C4.193,1.012,4.09,1.346,3.975,1.729Zm1.343-.318c.392-.089.708-.157.908-.2A3.378,3.378,0,0,0,5.479.891C5.441,1.014,5.386,1.193,5.319,1.411Z"
                  transform="translate(0 0)"
                  fill="#028360"
                />
                <path
                  id="Path_2"
                  data-name="Path 2"
                  d="M716.846,310.739s1.919,5.235,12.04,5.554c6.615-.061,9.844-3.38,9.844-3.38s1.5-2.812-1.611-2.882c0,.046-7.063,3.36-12.785,2.882S716.846,310.739,716.846,310.739Z"
                  transform="translate(-715.773 -300.968)"
                  fill="#028360"
                />
                <path
                  id="Path_3"
                  data-name="Path 3"
                  d="M714.876,313.575s-.96,4.7,0,7.8,4.212,2.383,6.24,1.358a21.348,21.348,0,0,0,4.335-3.339s-4.689,1.567-7.68.409-2.894-6.488-2.894-6.488"
                  transform="translate(-714.28 -303.015)"
                  fill="#028360"
                />
                <path
                  id="Path_4"
                  data-name="Path 4"
                  d="M748.657,325.189s-5.609,2.543-7.733,3.119-2.9,1.535-3.093,5.612a86.682,86.682,0,0,0,.409,10.695c.048.066,1.822-9.722,4.867-13.376C746.185,327.576,748.657,325.189,748.657,325.189Z"
                  transform="translate(-728.818 -310.41)"
                  fill="#028360"
                />
              </g>
            </g>
          </g>
          <path
            id="Path_47"
            data-name="Path 47"
            d="M8.507-29.16v-4.19H7.688L6.469-30.3,5.25-33.35H4.431v4.19h.533v-3.467L6.393-29.16h.152l1.429-3.467v3.467Zm-4.762-3.7v-.5H.85v.5H2.031v3.7h.533v-3.7Z"
            transform="translate(45.596 87.539)"
            fill="#55b56a"
          />
        </g>
      </g>
    </svg>
  );
};
export const DashboardIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        id="dashboard-pickleball"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          id="Path_48"
          data-name="Path 48"
          d="M9.25,0H1.75A1.752,1.752,0,0,0,0,1.75v4.5A1.752,1.752,0,0,0,1.75,8h7.5A1.752,1.752,0,0,0,11,6.25V1.75A1.752,1.752,0,0,0,9.25,0Zm0,0"
          fill="#c8d952"
        />
        <path
          id="Path_49"
          data-name="Path 49"
          d="M9.25,213.332H1.75A1.752,1.752,0,0,0,0,215.082v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-10.5A1.752,1.752,0,0,0,9.25,213.332Zm0,0"
          transform="translate(0 -203.332)"
          fill="#6115ad"
        />
        <path
          id="Path_50"
          data-name="Path 50"
          d="M286.582,341.332h-7.5a1.752,1.752,0,0,0-1.75,1.75v4.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-4.5A1.752,1.752,0,0,0,286.582,341.332Zm0,0"
          transform="translate(-264.332 -325.332)"
          fill="#c8d952"
        />
        <path
          id="Path_51"
          data-name="Path 51"
          d="M286.582,0h-7.5a1.752,1.752,0,0,0-1.75,1.75v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75V1.75A1.752,1.752,0,0,0,286.582,0Zm0,0"
          transform="translate(-264.332)"
          fill="#6115ad"
        />
      </svg>
    );

  return (
    <svg
      id="dashboard"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Path_48"
        data-name="Path 48"
        d="M9.25,0H1.75A1.752,1.752,0,0,0,0,1.75v4.5A1.752,1.752,0,0,0,1.75,8h7.5A1.752,1.752,0,0,0,11,6.25V1.75A1.752,1.752,0,0,0,9.25,0Zm0,0"
        fill="#c8d952"
      />
      <path
        id="Path_49"
        data-name="Path 49"
        d="M9.25,213.332H1.75A1.752,1.752,0,0,0,0,215.082v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-10.5A1.752,1.752,0,0,0,9.25,213.332Zm0,0"
        transform="translate(0 -203.332)"
        fill="#028360"
      />
      <path
        id="Path_50"
        data-name="Path 50"
        d="M286.582,341.332h-7.5a1.752,1.752,0,0,0-1.75,1.75v4.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-4.5A1.752,1.752,0,0,0,286.582,341.332Zm0,0"
        transform="translate(-264.332 -325.332)"
        fill="#c8d952"
      />
      <path
        id="Path_51"
        data-name="Path 51"
        d="M286.582,0h-7.5a1.752,1.752,0,0,0-1.75,1.75v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75V1.75A1.752,1.752,0,0,0,286.582,0Zm0,0"
        transform="translate(-264.332)"
        fill="#028360"
      />
    </svg>
  );
};
export const ActivitiesIcon = ({ width, height, isPickleball }) => {
  if (isPickleball)
    return (
      <svg
        id="activities"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <circle
          id="Ellipse_14"
          data-name="Ellipse 14"
          cx="12"
          cy="12"
          r="12"
          fill="#340761"
        />
        <path
          id="Path_52"
          data-name="Path 52"
          d="M83.708,108.9l-1.717-.8a7.8,7.8,0,0,0-7.13.385l-.207.116a5.9,5.9,0,0,1-3.155.9,6,6,0,0,1,0-12,5.883,5.883,0,0,1,3.155.9l.2.116h.009a7.811,7.811,0,0,0,7.125.387l1.722-.8a12.259,12.259,0,0,0-.732-1.272l-1.6.7a6.306,6.306,0,0,1-5.913-.4l-.2-.112h0A7.4,7.4,0,0,0,71.5,96a7.5,7.5,0,0,0,0,15,7.392,7.392,0,0,0,3.767-1.02l.2-.112a6.314,6.314,0,0,1,5.917-.4l1.593.7A12.082,12.082,0,0,0,83.708,108.9Z"
          transform="translate(-61 -91.5)"
          fill="#e1e87e"
        />
      </svg>
    );
  return (
    <svg
      id="Activities"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <circle
        id="Ellipse_14"
        data-name="Ellipse 14"
        cx="12"
        cy="12"
        r="12"
        fill="#55b56a"
      />
      <path
        id="Path_52"
        data-name="Path 52"
        d="M83.708,108.9l-1.717-.8a7.8,7.8,0,0,0-7.13.385l-.207.116a5.9,5.9,0,0,1-3.155.9,6,6,0,0,1,0-12,5.883,5.883,0,0,1,3.155.9l.2.116h.009a7.811,7.811,0,0,0,7.125.387l1.722-.8a12.259,12.259,0,0,0-.732-1.272l-1.6.7a6.306,6.306,0,0,1-5.913-.4l-.2-.112h0A7.4,7.4,0,0,0,71.5,96a7.5,7.5,0,0,0,0,15,7.392,7.392,0,0,0,3.767-1.02l.2-.112a6.314,6.314,0,0,1,5.917-.4l1.593.7A12.082,12.082,0,0,0,83.708,108.9Z"
        transform="translate(-61 -91.5)"
        fill="#fafafa"
      />
    </svg>
  );
};
export const GSMLogo = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127.104"
      height="59.323"
      viewBox="0 0 127.104 59.323"
    >
      <g id="game-set-match" transform="translate(-214 -179.677)">
        <g id="Group_56" data-name="Group 56" transform="translate(214 179)">
          <g id="Group_55" data-name="Group 55" transform="translate(0 0)">
            <g id="Group_38" data-name="Group 38" transform="translate(0 0)">
              <path
                id="Path_39"
                data-name="Path 39"
                d="M1953.451,3273.939h41.894l-8.922,51.624-20.262-8.286-21.579,7.637Z"
                transform="translate(-1944.582 -3265.608)"
                fill="#55b56a"
              />
              <g
                id="Group_36"
                data-name="Group 36"
                transform="translate(34.619 0) rotate(7)"
              >
                <path
                  id="Subtraction_2"
                  data-name="Subtraction 2"
                  d="M0,21.565H0a35.011,35.011,0,0,0,3.558-3.94A41.874,41.874,0,0,0,6.13,13.918a31.064,31.064,0,0,0,2.077-3.847,31.729,31.729,0,0,1-3.616,4.7c-1.216,1.344-2.22,2.31-2.238,2.31a28.819,28.819,0,0,0,3.149-4.2A34.3,34.3,0,0,0,7.593,8.956,28.6,28.6,0,0,0,9.118,4.889a5.823,5.823,0,0,0,1.194.709,8.539,8.539,0,0,0,2.043.723A32.545,32.545,0,0,1,8.742,12.8a38.408,38.408,0,0,1-4.053,4.784A38.094,38.094,0,0,1,1.38,20.549C.538,21.215.018,21.557,0,21.565Zm3.227-1.389h0A57.2,57.2,0,0,0,9.368,15a35.018,35.018,0,0,0,3.678-4.187,17.216,17.216,0,0,0,2.423-4.4,8.512,8.512,0,0,0,2.839-.96,31.48,31.48,0,0,1-4.554,6.6,36.5,36.5,0,0,1-4.936,4.581A36.68,36.68,0,0,1,4.856,19.31C3.849,19.893,3.233,20.173,3.227,20.176ZM.069,20.105h0a46.825,46.825,0,0,0,3.5-7.233A38.3,38.3,0,0,0,5.311,6.906a29.151,29.151,0,0,0,.558-4.323,14.76,14.76,0,0,0-.035-2.3c.065.183.185.455.355.808a8.585,8.585,0,0,0,.735,1.44c.215.406.409.764.525.978h0c.071.13.113.209.113.211a28.629,28.629,0,0,1-1.688,6.53,35.069,35.069,0,0,1-2.516,5.191A31.8,31.8,0,0,1,.069,20.105ZM9.794,12.3h0a17.886,17.886,0,0,0,2.534-3.882,6.932,6.932,0,0,0,.622-1.987c.235.034.476.058.716.072A13.242,13.242,0,0,1,9.794,12.3ZM6.509,9.383h0A13.035,13.035,0,0,0,8.33,4.218c.153.143.315.282.481.415A11.659,11.659,0,0,1,6.509,9.383ZM5.832.277A.652.652,0,0,1,5.773.01c0-.007,0-.01.005-.01a.8.8,0,0,1,.054.277Z"
                  transform="translate(0 10.725)"
                  fill="#55b56a"
                />
                <g
                  id="Ellipse_8"
                  data-name="Ellipse 8"
                  transform="translate(5.559 0)"
                  fill="#55b56a"
                  stroke="#028360"
                  strokeWidth="1"
                >
                  <circle cx="8.703" cy="8.703" r="8.703" stroke="none" />
                  <circle cx="8.703" cy="8.703" r="8.203" fill="none" />
                </g>
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M7.641,14.17c-.472-.7.314-1.908,1.174-2.693A7.868,7.868,0,0,0,11.408,8c.56-1.726.62-7.392-4.943-8C.263-.146,0,6.729,0,6.744A8.47,8.47,0,0,0,2.111,11.7,8.929,8.929,0,0,0,7.641,14.17Z"
                  transform="translate(6.222 2.815)"
                  fill="#55b56a"
                  stroke="#028360"
                  strokeLinecap="round"
                  strokeWidth="1"
                />
              </g>
              <g
                id="Group_37"
                data-name="Group 37"
                transform="translate(10.132 25.795)"
              >
                <ellipse
                  id="Ellipse_1"
                  data-name="Ellipse 1"
                  cx="3.602"
                  cy="4.693"
                  rx="3.602"
                  ry="4.693"
                  transform="translate(10.478 1.091)"
                  fill="#028360"
                />
                <path
                  id="Union_3"
                  data-name="Union 3"
                  d="M2.314,10.376c-.327-.1-.43-.678-.538-1.289a2.726,2.726,0,0,0-.459-1.351,4.547,4.547,0,0,1,.008-6.41,4.525,4.525,0,1,1,6.4,6.4,4.5,4.5,0,0,1-3.2,1.325c-.208,0-.561.294-.934.605-.432.36-.879.733-1.185.733A.3.3,0,0,1,2.314,10.376ZM4.525,7.542h0c.067-.268.17-.679.293-1.164-.332.082-.654.166-.953.245-.1.4-.167.688-.2.81A3.388,3.388,0,0,0,4.525,7.542ZM4.789,7.5l-.033.037a3.37,3.37,0,0,0,.961-.208c.083-.321.2-.757.325-1.237-.313.071-.642.148-.966.227C4.9,7.026,4.789,7.5,4.789,7.5ZM3.441,7.364c.046-.185.1-.414.169-.671-.385.1-.721.2-.976.272A3.386,3.386,0,0,0,3.441,7.364Zm2.552-.156A3.417,3.417,0,0,0,7.508,5.767c-.3.063-.727.156-1.214.265C6.164,6.519,6.06,6.934,5.992,7.208ZM2.364,6.763c.066-.261.147-.582.238-.938-.407.117-.713.208-.866.254A3.424,3.424,0,0,0,2.364,6.763Zm.255-.038c.308-.085.671-.183,1.055-.286.078-.3.164-.639.255-.987-.39.106-.753.208-1.071.3C2.757,6.155,2.675,6.492,2.619,6.725ZM3.93,6.372c.315-.083.639-.166.955-.245.081-.313.168-.65.259-.994l-.309.079c-.222.058-.441.116-.653.173C4.088,5.745,4,6.08,3.93,6.372Zm1.209-.308c.342-.084.67-.161.972-.23.089-.33.184-.674.28-1.01-.32.077-.656.16-.993.245C5.3,5.424,5.216,5.761,5.139,6.064ZM1.692,5.841c.261-.075.6-.17.977-.276.08-.309.166-.637.254-.971-.369.1-.7.2-.984.279C1.84,5.249,1.756,5.583,1.692,5.841Zm4.931-1c-.093.324-.181.64-.261.936.571-.128,1.026-.222,1.274-.273A3.368,3.368,0,0,0,7.9,4.467c-.323.074-.764.177-1.258.3ZM1.509,5.7c.06-.231.127-.49.2-.762l-.449.133A3.373,3.373,0,0,0,1.509,5.7Zm1.415-.209C3.261,5.4,3.625,5.3,4,5.2c.084-.318.171-.644.258-.963-.374.1-.737.194-1.077.288C3.085,4.867,3,5.195,2.924,5.494ZM4.482,4.267c-.082.3-.16.586-.233.864.274-.074.549-.146.818-.216l.145-.038c.084-.317.171-.637.257-.947-.314.077-.639.158-.96.24ZM1.131,4.148A3.4,3.4,0,0,0,1.2,4.84l.576-.164c.095-.355.2-.724.3-1.081-.4.113-.72.208-.932.271Q1.131,4.006,1.131,4.148Zm4.483.119c-.051.184-.1.367-.149.546.352-.089.688-.172,1-.247l.007-.026c.093-.321.185-.629.272-.915-.3.071-.652.154-1.018.243C5.688,4,5.651,4.135,5.614,4.267ZM2.239,3.775c-.082.288-.159.57-.23.836.3-.085.636-.178.982-.272.074-.278.15-.556.225-.827l.07-.253c-.349.094-.679.186-.977.27ZM6.722,4.5c.491-.117.9-.212,1.2-.277,0-.026,0-.052,0-.078a3.393,3.393,0,0,0-.089-.773c-.121.027-.42.095-.824.189C6.913,3.865,6.816,4.185,6.722,4.5ZM3.358,3.859q-.057.207-.112.411c.356-.1.722-.195,1.078-.288l.017-.063c.1-.352.194-.691.286-1.009l-.566.144-.515.135C3.483,3.412,3.419,3.637,3.358,3.859Zm1.223.056c.334-.086.656-.167.96-.242.105-.375.208-.732.3-1.062-.3.073-.628.151-.956.233C4.788,3.19,4.683,3.553,4.581,3.915ZM5.8,3.61c.383-.093.73-.175,1.024-.243.132-.426.25-.792.34-1.064-.273.062-.639.147-1.055.246C6.008,2.885,5.9,3.246,5.8,3.61Zm-4.625,0c.277-.079.611-.173.975-.274.1-.355.2-.691.294-.994-.367.1-.69.192-.94.264A3.367,3.367,0,0,0,1.174,3.61Zm5.913-.3c.345-.079.587-.131.684-.153A3.379,3.379,0,0,0,7.4,2.338C7.313,2.594,7.2,2.931,7.087,3.307Zm-4.7-.037c.312-.086.641-.176.973-.266.1-.347.194-.676.284-.978l-.068.017c-.309.078-.61.157-.89.232C2.589,2.587,2.486,2.926,2.385,3.27ZM3.62,2.934l.671-.177L4.7,2.652c.1-.352.2-.672.283-.948-.342.079-.712.166-1.08.257C3.815,2.267,3.718,2.6,3.62,2.934Zm1.346-.348c.34-.085.662-.163.957-.234.1-.351.2-.663.278-.921-.23.05-.565.124-.953.212C5.164,1.92,5.068,2.241,4.965,2.586ZM1.652,2.343c.263-.073.556-.153.863-.235.11-.356.206-.657.277-.877A3.42,3.42,0,0,0,1.652,2.343ZM6.185,2.29c.418-.1.767-.178,1.013-.232a3.423,3.423,0,0,0-.721-.686l-.015,0C6.383,1.63,6.288,1.943,6.185,2.29ZM2.756,2.044c.316-.084.641-.169.955-.248.12-.4.225-.744.306-1a3.368,3.368,0,0,0-.961.3C2.991,1.295,2.882,1.635,2.756,2.044Zm1.22-.314c.388-.1.755-.183,1.082-.258.085-.278.154-.5.2-.638A3.394,3.394,0,0,0,4.525.754q-.129,0-.256.01C4.193,1.012,4.09,1.346,3.975,1.729Zm1.343-.318c.392-.089.708-.157.908-.2A3.378,3.378,0,0,0,5.479.891C5.441,1.014,5.386,1.193,5.319,1.411Z"
                  transform="translate(0 0)"
                  fill="#028360"
                />
                <path
                  id="Path_2"
                  data-name="Path 2"
                  d="M716.846,310.739s1.919,5.235,12.04,5.554c6.615-.061,9.844-3.38,9.844-3.38s1.5-2.812-1.611-2.882c0,.046-7.063,3.36-12.785,2.882S716.846,310.739,716.846,310.739Z"
                  transform="translate(-715.773 -300.968)"
                  fill="#028360"
                />
                <path
                  id="Path_3"
                  data-name="Path 3"
                  d="M714.876,313.575s-.96,4.7,0,7.8,4.212,2.383,6.24,1.358a21.348,21.348,0,0,0,4.335-3.339s-4.689,1.567-7.68.409-2.894-6.488-2.894-6.488"
                  transform="translate(-714.28 -303.015)"
                  fill="#028360"
                />
                <path
                  id="Path_4"
                  data-name="Path 4"
                  d="M748.657,325.189s-5.609,2.543-7.733,3.119-2.9,1.535-3.093,5.612a86.682,86.682,0,0,0,.409,10.695c.048.066,1.822-9.722,4.867-13.376C746.185,327.576,748.657,325.189,748.657,325.189Z"
                  transform="translate(-728.818 -310.41)"
                  fill="#028360"
                />
              </g>
            </g>
          </g>
          <path
            id="Path_45"
            data-name="Path 45"
            d="M-3.8-20.649a6.681,6.681,0,0,0,5.358-2.477l1.133-5.128H-3.474l-.653,2.9h2.881l-.211,1.018a3.481,3.481,0,0,1-2.151.768,3.062,3.062,0,0,1-3.246-3.111,4.14,4.14,0,0,1,3.995-4.3A2.988,2.988,0,0,1-.036-29.272L3-30.539A5.664,5.664,0,0,0-2.4-33.9c-4.648,0-7.893,3.188-7.893,7.432C-10.292-22.819-7.315-20.649-3.8-20.649Zm19.262-.23-2-12.81H9.3L1.654-20.879H5.572l1.018-1.844h5.07l.211,1.844ZM11.391-25.6H8.126l2.689-4.82Zm19.551,4.724,2.823-12.81H29.059l-4.244,7.067L23.7-33.689H19.226L16.4-20.879h3.3l1.863-8.469,1.383,8.469h1.46L29.5-29.348l-1.863,8.469Zm11.7,0,.634-2.881H37.183l.48-2.17h5.953l.634-2.881H38.316l.423-2h6.088l.634-2.881H36.069l-2.823,12.81ZM-7.862-5.285c3.246,0,5.243-2.074,5.243-4.571,0-3.726-6.2-3.572-6.2-4.9,0-.5.5-.883,1.248-.883a5.443,5.443,0,0,1,3.86,1.613l2.017-2.4a7.451,7.451,0,0,0-5.358-2.093c-3.4,0-5.243,2.209-5.243,4.379,0,3.8,6.184,3.534,6.184,4.955,0,.442-.423.979-1.479.979a5.621,5.621,0,0,1-4.359-1.978l-1.229,2.458A6.243,6.243,0,0,0-7.862-5.285Zm15.229-.23L8-8.4H1.914l.48-2.17H8.347l.634-2.881H3.047l.423-2H9.557l.634-2.881H.8L-2.023-5.515Zm8.085,0,2.189-9.929h3.572l.634-2.881H11.382l-.653,2.881H14.32L12.15-5.515ZM-2.162,9.849.661-2.961H-4.044L-8.288,4.106-9.4-2.961h-4.475L-16.7,9.849h3.3l1.863-8.469,1.383,8.469h1.46L-3.6,1.379-5.465,9.849Zm14.749,0-2-12.81H6.423L-1.221,9.849H2.7L3.715,8h5.07L9,9.849ZM8.516,5.124H5.251L7.94.3ZM18.31,9.849,20.5-.08h3.572l.634-2.881H14.239L13.586-.08h3.591l-2.17,9.929Zm12.214.23a6.789,6.789,0,0,0,5.55-2.708l-2.554-1.69a3.633,3.633,0,0,1-2.8,1.479,3.052,3.052,0,0,1-3.246-3.111,4.139,4.139,0,0,1,3.995-4.3A2.838,2.838,0,0,1,34.346,1.8L37.534.765a5.8,5.8,0,0,0-5.915-3.937A7.318,7.318,0,0,0,24.033,4.26C24.033,7.832,26.914,10.079,30.525,10.079Zm18.149-.23L51.5-2.961h-3.3L47.137,1.821h-5.32l1.056-4.782h-3.3L36.747,9.849h3.3L41.183,4.7H46.5L45.37,9.849Z"
            transform="translate(75.38 42.277)"
            fill="#e1e87e"
          />
          <path
            id="Path_41"
            data-name="Path 41"
            d="M8.507-29.16v-4.19H7.688L6.469-30.3,5.25-33.35H4.431v4.19h.533v-3.467L6.393-29.16h.152l1.429-3.467v3.467Zm-4.762-3.7v-.5H.85v.5H2.031v3.7h.533v-3.7Z"
            transform="translate(118.596 66.539)"
            fill="#e1e87e"
          />
        </g>
      </g>
    </svg>
  );
};

export const PlayerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="591.15"
      height="580"
      viewBox="0 0 531.15 520"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_208"
            data-name="Rectangle 208"
            width="531.15"
            height="520"
            transform="translate(44.316 60.018)"
            fill="#fff"
            opacity="0.5"
          />
        </clipPath>
        <radialGradient
          id="radial-gradient"
          cx="0.5"
          cy="0.5"
          r="0.5"
          gradientTransform="translate(0 0.45) scale(1 0.1)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" />
          <stop offset="0.107" stopColor="#191919" stopOpacity="0.941" />
          <stop offset="0.301" stopOpacity="0.78" />
          <stop offset="0.558" stopOpacity="0.522" />
          <stop offset="0.867" stopOpacity="0.165" />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g
        id="player"
        transform="translate(-44.316 -60.018)"
        clipPath="url(#clip-path)"
      >
        <g id="objects" transform="translate(101.023 112.466)">
          <g id="Group_310" data-name="Group 310" transform="translate(0 0)">
            <g id="Group_309" data-name="Group 309">
              <circle
                id="Ellipse_36"
                data-name="Ellipse 36"
                cx="163.623"
                cy="163.623"
                r="163.623"
                transform="translate(41.916 261.311)"
                opacity="0.179"
                fill="url(#radial-gradient)"
              />
              <g id="Group_308" data-name="Group 308">
                <path
                  id="Path_167"
                  data-name="Path 167"
                  d="M488.614,672.365l38.61-14.607-2.27,14.1Z"
                  transform="translate(-199.518 -244.887)"
                  fill="#cc6d92"
                />
                <path
                  id="Path_168"
                  data-name="Path 168"
                  d="M488.614,669l9.316-26.44,29.294,11.832Z"
                  transform="translate(-199.518 -241.521)"
                  fill="#c1859d"
                />
                <path
                  id="Path_169"
                  data-name="Path 169"
                  d="M482.871,668.337l-20.185-28.764,29.5,2.325Z"
                  transform="translate(-193.774 -240.859)"
                  fill="#db93b0"
                />
                <path
                  id="Path_170"
                  data-name="Path 170"
                  d="M457.763,639.572l-17.3,21.638,37.483,7.126Z"
                  transform="translate(-188.852 -240.859)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_171"
                  data-name="Path 171"
                  d="M457.763,638.847,445.585,636.3l-5.119,24.186Z"
                  transform="translate(-188.852 -240.134)"
                  fill="#c1859d"
                />
                <path
                  id="Path_172"
                  data-name="Path 172"
                  d="M459.22,633.2l9.181-22.406-21.359,19.857Z"
                  transform="translate(-190.309 -234.484)"
                  fill="#db93b0"
                />
                <path
                  id="Path_173"
                  data-name="Path 173"
                  d="M468.4,610.791l-21.277,4-.081,15.857Z"
                  transform="translate(-190.309 -234.484)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_174"
                  data-name="Path 174"
                  d="M471.866,610.791l7.053,9.056L462.685,633.2Z"
                  transform="translate(-193.774 -234.484)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_175"
                  data-name="Path 175"
                  d="M478.92,622.424,492.187,638.1l-29.5-2.325Z"
                  transform="translate(-193.774 -237.06)"
                  fill="#e5bdd1"
                />
                <path
                  id="Path_176"
                  data-name="Path 176"
                  d="M447.146,603.3l20.215-44.4,1.063,40.4Z"
                  transform="translate(-190.332 -222.987)"
                  fill="#e5bdd1"
                />
                <path
                  id="Path_177"
                  data-name="Path 177"
                  d="M463.635,553.53l-33.311-18.852,13.1,63.253Z"
                  transform="translate(-186.605 -217.623)"
                  fill="#efb1b1"
                />
                <path
                  id="Path_178"
                  data-name="Path 178"
                  d="M430.324,526.774,464.7,499l-1.063,46.63Z"
                  transform="translate(-186.605 -209.719)"
                  fill="#e8c0bf"
                />
                <path
                  id="Path_179"
                  data-name="Path 179"
                  d="M464.7,496.371l-28.37-9.226-6,37Z"
                  transform="translate(-186.605 -207.094)"
                  fill="#f79f9f"
                />
                <path
                  id="Path_180"
                  data-name="Path 180"
                  d="M435.563,470.681,455.582,439.4l-28.71-26.576Z"
                  transform="translate(-185.841 -190.63)"
                  fill="#f79f9f"
                />
                <path
                  id="Path_181"
                  data-name="Path 181"
                  d="M438.036,482.408l10.652-16.645,17.718,25.871Z"
                  transform="translate(-188.314 -202.357)"
                  fill="#efb1b1"
                />
                <path
                  id="Path_182"
                  data-name="Path 182"
                  d="M469.437,491.634l6.033-17.35-23.751-8.521Z"
                  transform="translate(-191.345 -202.357)"
                  fill="#eaa8a4"
                />
                <path
                  id="Path_183"
                  data-name="Path 183"
                  d="M451.719,461.6l9.368-14.636L475.47,470.12Z"
                  transform="translate(-191.345 -198.193)"
                  fill="#efb1b1"
                />
                <path
                  id="Path_184"
                  data-name="Path 184"
                  d="M419.434,412.824,393.295,451.4l34.83,19.281Z"
                  transform="translate(-178.403 -190.63)"
                  fill="#d39590"
                />
                <path
                  id="Path_185"
                  data-name="Path 185"
                  d="M390.583,442.932l-9.53-68.337,35.67,29.761Z"
                  transform="translate(-175.691 -182.162)"
                  fill="#d88277"
                />
                <path
                  id="Path_186"
                  data-name="Path 186"
                  d="M370.663,374.6l-36.514,38.572,46.045,29.765Z"
                  transform="translate(-165.301 -182.162)"
                  fill="#d89032"
                />
                <path
                  id="Path_187"
                  data-name="Path 187"
                  d="M366.857,374.6l-49.889,19.434,13.375,19.138Z"
                  transform="translate(-161.495 -182.162)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_188"
                  data-name="Path 188"
                  d="M366.027,372.084l-52.8-8.826,2.915,28.26Z"
                  transform="translate(-160.665 -179.65)"
                  fill="#976da0"
                />
                <path
                  id="Path_189"
                  data-name="Path 189"
                  d="M311.51,363.257l-6.02,16.956,8.935,11.3Z"
                  transform="translate(-158.952 -179.65)"
                  fill="#944ea0"
                />
                <path
                  id="Path_190"
                  data-name="Path 190"
                  d="M309.668,350.664,335.1,306.406l-37.923,37.959Z"
                  transform="translate(-157.11 -167.057)"
                  fill="#efac6a"
                />
                <path
                  id="Path_191"
                  data-name="Path 191"
                  d="M313.224,357.287l52.8,8.826-40.749-29.808Z"
                  transform="translate(-160.665 -173.68)"
                  fill="#944ea0"
                />
                <path
                  id="Path_192"
                  data-name="Path 192"
                  d="M135.024,460.488l-17.769,68.934V493.335Z"
                  transform="translate(-117.255 -201.189)"
                  fill="#cc6d92"
                />
                <path
                  id="Path_193"
                  data-name="Path 193"
                  d="M137.4,460.488,156.4,498.153,128,496.978Z"
                  transform="translate(-119.635 -201.189)"
                  fill="#c1859d"
                />
                <path
                  id="Path_194"
                  data-name="Path 194"
                  d="M156.4,508.537l-20.881,16.535L128,507.361Z"
                  transform="translate(-119.635 -211.572)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_195"
                  data-name="Path 195"
                  d="M135.518,525.072l-6.029,12.688L128,507.361Z"
                  transform="translate(-119.635 -211.572)"
                  fill="#e5bdd1"
                />
                <path
                  id="Path_196"
                  data-name="Path 196"
                  d="M125.618,507.361l-8.363,32.444,9.854-2.045Z"
                  transform="translate(-117.255 -211.572)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_197"
                  data-name="Path 197"
                  d="M140.08,460.488l13.561,2.764,5.433,34.9Z"
                  transform="translate(-122.311 -201.189)"
                  fill="#d3a9bc"
                />
                <path
                  id="Path_198"
                  data-name="Path 198"
                  d="M157.5,464.039l13.029,8.256-7.6,26.645Z"
                  transform="translate(-126.17 -201.975)"
                  fill="#e5bdd1"
                />
                <path
                  id="Path_199"
                  data-name="Path 199"
                  d="M172.075,474.645l11.843,24.388-19.438,2.256Z"
                  transform="translate(-127.716 -204.325)"
                  fill="#ffdbf3"
                />
                <path
                  id="Path_200"
                  data-name="Path 200"
                  d="M174.236,474.58l11.65-.227.193,24.615Z"
                  transform="translate(-129.877 -204.26)"
                  fill="#e5bdd1"
                />
                <path
                  id="Path_201"
                  data-name="Path 201"
                  d="M189.2,474.308l46.815-.161-46.622,24.776Z"
                  transform="translate(-133.192 -204.214)"
                  fill="#e8c0bf"
                />
                <path
                  id="Path_202"
                  data-name="Path 202"
                  d="M236.071,474.146,215.1,498.923H189.449Z"
                  transform="translate(-133.247 -204.214)"
                  fill="#eaa8a4"
                />
                <path
                  id="Path_203"
                  data-name="Path 203"
                  d="M243.371,474.146l42.088,41.073-63.057-16.3Z"
                  transform="translate(-140.547 -204.214)"
                  fill="#e8c0bf"
                />
                <path
                  id="Path_204"
                  data-name="Path 204"
                  d="M249.338,474.146l41.263,9.582.826,31.491Z"
                  transform="translate(-146.514 -204.214)"
                  fill="#eaa8a4"
                />
                <path
                  id="Path_205"
                  data-name="Path 205"
                  d="M302.342,486.455l13.478,32.626-12.653-1.136Z"
                  transform="translate(-158.255 -206.941)"
                  fill="#d39590"
                />
                <path
                  id="Path_206"
                  data-name="Path 206"
                  d="M302.342,486.455l29.216,21.56L315.82,519.081Z"
                  transform="translate(-158.255 -206.941)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_207"
                  data-name="Path 207"
                  d="M302.342,479.369l61.275-24.9-32.059,46.464Z"
                  transform="translate(-158.255 -199.854)"
                  fill="#bf8f56"
                />
                <path
                  id="Path_208"
                  data-name="Path 208"
                  d="M363.617,447.748,327.1,424.143l-24.761,48.509Z"
                  transform="translate(-158.255 -193.138)"
                  fill="#d88136"
                />
                <path
                  id="Path_209"
                  data-name="Path 209"
                  d="M319.4,409.984l-17.058,59.531L327.1,421.006Z"
                  transform="translate(-158.255 -190.001)"
                  fill="#bf8f56"
                />
                <path
                  id="Path_210"
                  data-name="Path 210"
                  d="M299.026,385.039l-18.95,18.593-3.766-15.213Z"
                  transform="translate(-152.489 -184.475)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_211"
                  data-name="Path 211"
                  d="M299.026,382.55l-15.544-8.745L276.31,385.93Z"
                  transform="translate(-152.489 -181.987)"
                  fill="#efac6a"
                />
                <path
                  id="Path_212"
                  data-name="Path 212"
                  d="M302.258,385.039v6.576L290.9,404.458Z"
                  transform="translate(-155.72 -184.475)"
                  fill="#efac6a"
                />
                <path
                  id="Path_213"
                  data-name="Path 213"
                  d="M300.1,385.039l-11.358,19.42-7.592-.827Z"
                  transform="translate(-153.56 -184.475)"
                  fill="#d89032"
                />
                <path
                  id="Path_214"
                  data-name="Path 214"
                  d="M283.483,373.805l-5.043,2.127-2.129,10Z"
                  transform="translate(-152.489 -181.987)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_215"
                  data-name="Path 215"
                  d="M506.452,379.888l22.422-10.738-5.262-7.363Z"
                  transform="translate(-203.469 -179.325)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_216"
                  data-name="Path 216"
                  d="M506.452,383.317l24.659,2.931-12.029-8.98Z"
                  transform="translate(-203.469 -182.754)"
                  fill="#efbb8e"
                />
                <path
                  id="Path_217"
                  data-name="Path 217"
                  d="M505.176,385.039l-4.485,11.367,29.144-8.436Z"
                  transform="translate(-202.193 -184.475)"
                  fill="#efac6a"
                />
                <path
                  id="Path_218"
                  data-name="Path 218"
                  d="M513.395,412.263l-12.7-13.916,15.7-4.543Z"
                  transform="translate(-202.193 -186.417)"
                  fill="#db9d5a"
                />
                <path
                  id="Path_219"
                  data-name="Path 219"
                  d="M520,393.8l11.212,12.6-14.2,5.863Z"
                  transform="translate(-205.808 -186.417)"
                  fill="#bf8f56"
                />
                <path
                  id="Path_220"
                  data-name="Path 220"
                  d="M506.452,377.653,515.9,351.7l7.715,7.852Z"
                  transform="translate(-203.469 -177.09)"
                  fill="#efac6a"
                />
                <path
                  id="Path_221"
                  data-name="Path 221"
                  d="M512.45,351.7l-21.556,4.933,12.112,21.021Z"
                  transform="translate(-200.022 -177.09)"
                  fill="#efbb8e"
                />
                <path
                  id="Path_222"
                  data-name="Path 222"
                  d="M532.468,371.245l2.237,13.669-12.029-8.98Z"
                  transform="translate(-207.063 -181.42)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_223"
                  data-name="Path 223"
                  d="M297.174,355.167l6.474,23.255,6.02-16.956Z"
                  transform="translate(-157.11 -177.858)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_224"
                  data-name="Path 224"
                  d="M301.067,378.421l-15.544-8.745,9.07-14.51Z"
                  transform="translate(-154.529 -177.858)"
                  fill="#f7ffef"
                />
                <path
                  id="Path_225"
                  data-name="Path 225"
                  d="M534.3,388.8l-2.237,16.489-11.212-12.6Z"
                  transform="translate(-206.659 -185.309)"
                  fill="#d5b92a"
                />
                <path
                  id="Path_226"
                  data-name="Path 226"
                  d="M633.541,344.407c-3.3-3.456-8.133-5.281-13.974-5.281-10.627,0-24,6.007-35.967,15.954-1.3.925-21.448,15.215-33.378,20.033-7.659,3.1-9.658,2.008-9.677,2,.044.029-.589-.421-5.414,1.486h0c-.606.988.037,10.315.037,15.693a9.611,9.611,0,0,1,3.305-6.03,8.023,8.023,0,0,1,9.614-.265c3.994,2.656,7.234,11.076,8.883,16.533a16.8,16.8,0,0,0,4.325,8.89c3.3,3.454,8.133,5.28,13.974,5.28h0c12.083,0,27.715-7.762,40.8-20.258C636.323,379.09,644,355.358,633.541,344.407ZM551.3,383.169a15.127,15.127,0,0,0-2.542-1.366c1.143-.365,2.349-.8,3.637-1.318a114.912,114.912,0,0,0,14.78-7.708,61.78,61.78,0,0,0-9.209,18.616C556.173,388.022,553.952,384.934,551.3,383.169Zm60.771,11.08c-12.046,11.508-26.148,18.656-36.8,18.656-4.281,0-7.573-1.175-9.786-3.491a10.317,10.317,0,0,1-2.033-3.167c-.136-.563-.426-1.7-.865-3.179-1.506-10.158,6.321-26.253,20.181-39.494,12.047-11.508,26.148-18.655,36.8-18.655,4.28,0,7.572,1.174,9.786,3.49C637.292,356.723,629.377,377.715,612.068,394.249Z"
                  transform="translate(-209.765 -174.305)"
                  fill="#d5b92a"
                />
                <path
                  id="Path_227"
                  data-name="Path 227"
                  d="M297.174,339.779l24.1-54.075L335.1,301.82Z"
                  transform="translate(-157.11 -162.471)"
                  fill="#d5b92a"
                />
                <path
                  id="Path_228"
                  data-name="Path 228"
                  d="M341.954,292.741l21.414-48.023-35.238,31.908Z"
                  transform="translate(-163.967 -153.392)"
                  fill="#f2d144"
                />
                <path
                  id="Path_229"
                  data-name="Path 229"
                  d="M367.3,244.717l18.575,31.908-39.988,16.116Z"
                  transform="translate(-167.901 -153.392)"
                  fill="#dbc775"
                />
                <path
                  id="Path_230"
                  data-name="Path 230"
                  d="M512.45,336.818l-9.444-52.3-12.112,57.231Z"
                  transform="translate(-200.022 -162.209)"
                  fill="#dbc775"
                />
                <path
                  id="Path_231"
                  data-name="Path 231"
                  d="M506.452,280.029l25.26-15.782L515.9,332.327Z"
                  transform="translate(-203.469 -157.718)"
                  fill="#f9df6e"
                />
                <path
                  id="Path_232"
                  data-name="Path 232"
                  d="M458.486,281.578,446.324,259.6l25.466-21.994Z"
                  transform="translate(-190.15 -151.817)"
                  fill="#f9df6e"
                />
                <path
                  id="Path_233"
                  data-name="Path 233"
                  d="M475.251,237.607l9.23,2.446-22.535,41.525Z"
                  transform="translate(-193.61 -151.817)"
                  fill="#e5d693"
                />
                <path
                  id="Path_234"
                  data-name="Path 234"
                  d="M471.791,234.271l-11.3-11.723-14.168,33.717Z"
                  transform="translate(-190.15 -148.481)"
                  fill="#dbc775"
                />
                <path
                  id="Path_235"
                  data-name="Path 235"
                  d="M460.492,221.827l-13.64-2.535-.528,36.253Z"
                  transform="translate(-190.15 -147.759)"
                  fill="#d5b92a"
                />
                <path
                  id="Path_236"
                  data-name="Path 236"
                  d="M460.642,218.108,453.8,202.5l-6.8,13.07Z"
                  transform="translate(-190.3 -144.04)"
                  fill="#b2a157"
                />
                <path
                  id="Path_237"
                  data-name="Path 237"
                  d="M455.738,198.18l25.225-15.191-18.386,30.8Z"
                  transform="translate(-192.235 -139.718)"
                  fill="#f9df6e"
                />
                <path
                  id="Path_238"
                  data-name="Path 238"
                  d="M477.223,197.227l29.388-6.2-20.888-8.041Z"
                  transform="translate(-196.994 -139.718)"
                  fill="#f2d144"
                />
                <path
                  id="Path_239"
                  data-name="Path 239"
                  d="M474.41,201.279l1.412,28.281-11.3-11.723Z"
                  transform="translate(-194.181 -143.769)"
                  fill="#f2d144"
                />
                <path
                  id="Path_240"
                  data-name="Path 240"
                  d="M477.223,201.279l10.643,30.727-9.23-2.446Z"
                  transform="translate(-196.994 -143.769)"
                  fill="#f9df6e"
                />
                <path
                  id="Path_241"
                  data-name="Path 241"
                  d="M477.223,201.279,498.5,218.541l-10.631,13.465Z"
                  transform="translate(-196.994 -143.769)"
                  fill="#e2daba"
                />
                <path
                  id="Path_242"
                  data-name="Path 242"
                  d="M477.223,199.515l29.388-6.2L498.5,216.777Z"
                  transform="translate(-196.994 -142.006)"
                  fill="#e5d693"
                />
                <path
                  id="Path_243"
                  data-name="Path 243"
                  d="M488.142,175.418l19.369-26.607,5.761,17.658Z"
                  transform="translate(-199.413 -132.147)"
                  fill="#e0f2af"
                />
                <path
                  id="Path_244"
                  data-name="Path 244"
                  d="M513.271,171.494l-4.242,16.99-20.888-8.041Z"
                  transform="translate(-199.413 -137.171)"
                  fill="#cee0a4"
                />
                <path
                  id="Path_245"
                  data-name="Path 245"
                  d="M479.389,175.121l-14.88-27.651-15.88,22.042Z"
                  transform="translate(-190.66 -131.85)"
                  fill="#98dd3e"
                />
                <path
                  id="Path_246"
                  data-name="Path 246"
                  d="M479.389,181.393l-25.225,15.191-5.535-20.8Z"
                  transform="translate(-190.66 -138.122)"
                  fill="#9dc165"
                />
                <path
                  id="Path_247"
                  data-name="Path 247"
                  d="M447.552,175.784l-3.781,3.16,9.316,17.64Z"
                  transform="translate(-189.584 -138.122)"
                  fill="#85a665"
                />
                <path
                  id="Path_248"
                  data-name="Path 248"
                  d="M469.027,147.47l34.249,1.044-19.368,26.607Z"
                  transform="translate(-195.179 -131.85)"
                  fill="#bde577"
                />
                <path
                  id="Path_249"
                  data-name="Path 249"
                  d="M469.027,143.025l5.755-15.621,28.494,16.664Z"
                  transform="translate(-195.179 -127.405)"
                  fill="#98dd3e"
                />
                <path
                  id="Path_250"
                  data-name="Path 250"
                  d="M476.42,127.4l21.407,2.691,7.087,13.973Z"
                  transform="translate(-196.816 -127.405)"
                  fill="#9dc165"
                />
                <path
                  id="Path_251"
                  data-name="Path 251"
                  d="M464.188,147.47l-17.006,10.287,1.126,11.755Z"
                  transform="translate(-190.34 -131.85)"
                  fill="#9dc165"
                />
                <path
                  id="Path_252"
                  data-name="Path 252"
                  d="M464.188,145.916l-10.148-5.461L447.182,156.2Z"
                  transform="translate(-190.34 -130.296)"
                  fill="#85a665"
                />
                <path
                  id="Path_253"
                  data-name="Path 253"
                  d="M466.14,143.025l-10.148-5.461,15.9-10.16Z"
                  transform="translate(-192.291 -127.405)"
                  fill="#858c65"
                />
                <path
                  id="Path_254"
                  data-name="Path 254"
                  d="M501.525,223.453l16.508,6.376-27.139,7.089Z"
                  transform="translate(-200.022 -148.681)"
                  fill="#f7ffef"
                />
                <path
                  id="Path_255"
                  data-name="Path 255"
                  d="M484.481,240.749l12.112,34.075-34.647,7.45Z"
                  transform="translate(-193.61 -152.513)"
                  fill="#f7ffef"
                />
                <path
                  id="Path_256"
                  data-name="Path 256"
                  d="M438.075,216.951l-12.1-8.227L406.7,228.657Z"
                  transform="translate(-181.372 -145.418)"
                  fill="#f7ffef"
                />
                <path
                  id="Path_257"
                  data-name="Path 257"
                  d="M438.075,219.291l-.528,36.253L406.7,231Z"
                  transform="translate(-181.372 -147.759)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_258"
                  data-name="Path 258"
                  d="M490.894,238.732l27.139-7.089-15.027,41.164Z"
                  transform="translate(-200.022 -150.495)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_259"
                  data-name="Path 259"
                  d="M461.946,291.97l15.278,25.189,19.369-32.639Z"
                  transform="translate(-193.61 -162.209)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_260"
                  data-name="Path 260"
                  d="M440.877,265.86l-19.143,37.492,31.305-15.515Z"
                  transform="translate(-184.702 -158.075)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_261"
                  data-name="Path 261"
                  d="M437.547,258.875l-24.937-.626L406.7,234.33Z"
                  transform="translate(-181.372 -151.091)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_262"
                  data-name="Path 262"
                  d="M506.452,272.807l15.027-41.164,10.233,25.381Z"
                  transform="translate(-203.469 -150.495)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_263"
                  data-name="Path 263"
                  d="M453.038,294.09l15.278,25.189-46.583-9.674Z"
                  transform="translate(-184.702 -164.329)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_264"
                  data-name="Path 264"
                  d="M403.435,228.657l-11.478-6.228,30.755-13.706Z"
                  transform="translate(-178.106 -145.418)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_265"
                  data-name="Path 265"
                  d="M342.082,306.406l27.375,53.084-40.749-29.808Z"
                  transform="translate(-164.096 -167.057)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_266"
                  data-name="Path 266"
                  d="M381.053,373.92l34.019-2.373L402.435,391.76Z"
                  transform="translate(-175.691 -181.487)"
                  fill="#f7f0d2"
                />
                <path
                  id="Path_267"
                  data-name="Path 267"
                  d="M421.733,314.02l15.652,28.147,30.93-18.473Z"
                  transform="translate(-184.702 -168.743)"
                  fill="#e8e5d9"
                />
                <path
                  id="Path_268"
                  data-name="Path 268"
                  d="M399.323,232.557l-25.929,8.087,14.451-14.314Z"
                  transform="translate(-173.994 -149.318)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_269"
                  data-name="Path 269"
                  d="M399.323,234.33l-7.354,39.994-18.575-31.908Z"
                  transform="translate(-173.994 -151.091)"
                  fill="#e8e5d9"
                />
                <path
                  id="Path_270"
                  data-name="Path 270"
                  d="M410.517,258.249l-13.262,16.075,7.354-39.994Z"
                  transform="translate(-179.28 -151.091)"
                  fill="#f2f2f2"
                />
                <path
                  id="Path_271"
                  data-name="Path 271"
                  d="M414.291,265.055l5.794,38.118,19.143-37.492Z"
                  transform="translate(-183.054 -157.897)"
                  fill="#f7ffef"
                />
                <path
                  id="Path_272"
                  data-name="Path 272"
                  d="M397.255,281.13l19.056,22.043-5.794-38.118Z"
                  transform="translate(-179.28 -157.897)"
                  fill="#e8e5d9"
                />
                <path
                  id="Path_273"
                  data-name="Path 273"
                  d="M404.932,312.333l2.35,44.784-61.394-50.712Z"
                  transform="translate(-167.901 -167.057)"
                  fill="#e8e5d9"
                />
                <path
                  id="Path_274"
                  data-name="Path 274"
                  d="M404.932,307.748,385.876,285.7,345.888,301.82Z"
                  transform="translate(-167.901 -162.471)"
                  fill="#e2daba"
                />
                <path
                  id="Path_275"
                  data-name="Path 275"
                  d="M421.733,314.02l2.35,44.784,13.3-16.637Z"
                  transform="translate(-184.702 -168.743)"
                  fill="#e2daba"
                />
                <path
                  id="Path_276"
                  data-name="Path 276"
                  d="M345.888,306.406l27.375,53.084,34.019-2.373Z"
                  transform="translate(-167.901 -167.057)"
                  fill="#e2daba"
                />
                <path
                  id="Path_277"
                  data-name="Path 277"
                  d="M440.344,160.684l1.126,11.755-25.154,21.025Z"
                  transform="translate(-183.502 -134.777)"
                  fill="#728065"
                />
                <path
                  id="Path_278"
                  data-name="Path 278"
                  d="M440.539,159.651,417.2,156.02l12.834,17.969Z"
                  transform="translate(-183.697 -133.744)"
                  fill="#858c65"
                />
                <path
                  id="Path_279"
                  data-name="Path 279"
                  d="M428.61,179.1l-17.822,7.386,4.3,11.055Z"
                  transform="translate(-182.278 -138.857)"
                  fill="#858c65"
                />
                <path
                  id="Path_280"
                  data-name="Path 280"
                  d="M417.2,152.572l30.2-12.117L440.539,156.2Z"
                  transform="translate(-183.697 -130.296)"
                  fill="#9dc165"
                />
                <path
                  id="Path_281"
                  data-name="Path 281"
                  d="M415.776,156.02l12.834,17.969-17.822,7.386Z"
                  transform="translate(-182.278 -133.744)"
                  fill="#85a665"
                />
                <path
                  id="Path_282"
                  data-name="Path 282"
                  d="M411.356,199.646l-17.433-9.221,13.129-1.835Z"
                  transform="translate(-178.542 -140.958)"
                  fill="#85a665"
                />
                <path
                  id="Path_283"
                  data-name="Path 283"
                  d="M417.2,151.7l14.051-15.2,16.151,3.08Z"
                  transform="translate(-183.697 -129.419)"
                  fill="#98dd3e"
                />
              </g>
            </g>
            <g
              id="tennis-ball"
              transform="translate(381.56 97.625) rotate(-30)"
            >
              <circle
                id="Ellipse_37"
                data-name="Ellipse 37"
                cx="14.99"
                cy="14.99"
                r="14.99"
                transform="translate(0 0)"
                fill="#55b56a"
              />
              <path
                id="Path_284"
                data-name="Path 284"
                d="M24.926,16.309,22.753,15.3a9.861,9.861,0,0,0-9.017.488l-.262.146a7.456,7.456,0,0,1-3.99,1.142,7.588,7.588,0,0,1,0-15.177,7.441,7.441,0,0,1,3.99,1.144l.25.146h.011a9.879,9.879,0,0,0,9.011.489l2.178-1.015A15.5,15.5,0,0,0,24,1.053l-2.02.888A7.976,7.976,0,0,1,14.5,1.432l-.249-.142h0A9.362,9.362,0,0,0,9.485,0a9.485,9.485,0,0,0,0,18.971,9.348,9.348,0,0,0,4.764-1.29l.252-.142a7.985,7.985,0,0,1,7.484-.508L24,17.916A15.281,15.281,0,0,0,24.926,16.309Z"
                transform="translate(3.607 5.505)"
                fill="#fafafa"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PlayerLogoIcon=({isPickleball})=> {
 return isPickleball ? (
      <svg xmlns="http://www.w3.org/2000/svg" width="201.856" height="322.736" viewBox="0 0 201.856 322.736">
        <g id="_6007844a6c16b9cd181c74e2_Dimensions-Sports-Pickleball-Simone-Jardim-Icon"
           data-name="6007844a6c16b9cd181c74e2_Dimensions-Sports-Pickleball-Simone-Jardim-Icon"
           transform="translate(-188.225 -93.708)">
          <g id="_x32_D_x24_AG-DIAGRAM" transform="translate(189.85 414.639)">
            <g id="POLYLINE_315_">
              <g id="Group_508" data-name="Group 508">
                <g id="Group_507" data-name="Group 507">
                  <line id="Line_124" data-name="Line 124" x2="1.176" fill="none" stroke="#6115ad"
                        stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"/>
                  <line id="Line_125" data-name="Line 125" x2="190.14" transform="translate(5.252)" fill="none"
                        stroke="#6115ad" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"
                        stroke-dasharray="3.962 6.933"/>
                  <line id="Line_126" data-name="Line 126" x2="1.176" transform="translate(197.43)" fill="none"
                        stroke="#6115ad" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"/>
                </g>
              </g>
            </g>
          </g>
          <g id="_x32_D_x24_AG-SPORTS" transform="translate(199.035 95.464)">
            <g id="POLYLINE_143_" transform="translate(124.955 83.348)">
              <path id="Path_311" data-name="Path 311"
                    d="M417.989,273.895a66.471,66.471,0,0,1,6.263-10.636c2.649-3.525,6.322-7.318,8.716-11.022a39.183,39.183,0,0,0,3.787-7.855c.837-2.292,1.677-4.82,2.36-7.164"
                    transform="translate(-417.989 -237.218)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_142_" transform="translate(130.36 47.868)">
              <path id="Path_312" data-name="Path 312"
                    d="M427.182,247.628c2.731-3.879,7.564-10.818,10.084-14.767a38.04,38.04,0,0,0,3.607-6.967,20.24,20.24,0,0,0,.887-3.471c.475-3.354,1.867-16.35,2.186-19.672a106.807,106.807,0,0,0,.125-17.674c-.1-1.271-.217-2.655-.41-3.915a6.992,6.992,0,0,0-.234-1.011,3.544,3.544,0,0,0-.551-1.073,4.461,4.461,0,0,0-1.017-.944,9.5,9.5,0,0,0-2.907-1.258"
                    transform="translate(-427.182 -176.876)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_141_" transform="translate(138.625 178.226)">
              <path id="Path_313" data-name="Path 313"
                    d="M441.239,398.584A169.974,169.974,0,0,1,453.9,442.06c.253,1.982.608,5.3,1.018,7.223.5,2.439,1.469,6.778,1.817,9.181a56.184,56.184,0,0,1,.645,6.672c.085,2.249.042,4.694-.051,6.946-.354,6.7-1.99,27.331-2.605,33.957"
                    transform="translate(-441.239 -398.584)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_140_" transform="translate(98.461 187.759)">
              <path id="Path_314" data-name="Path 314"
                    d="M413.017,512.976a68.227,68.227,0,0,0-.353-7.9,38.355,38.355,0,0,0-1.4-6.049l-2.643-8.35a59.964,59.964,0,0,1-3.036-20.356c.006-2.238.174-7.664.025-9.814a11.139,11.139,0,0,0-.237-1.777,4.783,4.783,0,0,0-.422-1.138,17.687,17.687,0,0,0-1.251-1.813,42.287,42.287,0,0,1-2.468-4.111c-3.08-5.646-7.056-14.045-10.923-19.094a71.961,71.961,0,0,0-5.627-6.435A151.815,151.815,0,0,0,372.93,414.8"
                    transform="translate(-372.93 -414.796)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_139_" transform="translate(130.285 285.669)">
              <path id="Path_315" data-name="Path 315"
                    d="M454.254,586.592a17.1,17.1,0,0,0-3.174-4.259,4.392,4.392,0,0,0-1.22-.775,3.407,3.407,0,0,0-1.288-.239,6.736,6.736,0,0,0-2.467.6c-1.6.64-3.347,1.71-5.071,1.941a4.6,4.6,0,0,1-2.61-.533c-.98-.469-1.882-1.235-2.883-1.658a2.117,2.117,0,0,0-1.215-.153,2.379,2.379,0,0,0-1.084.593,8.665,8.665,0,0,0-1.456,1.863,45.185,45.185,0,0,0-3.371,7.152,21.208,21.208,0,0,0-1.318,4.905,5.251,5.251,0,0,0,.4,2.862,4.617,4.617,0,0,0,1.539,1.707,15.235,15.235,0,0,0,3.424,1.642c3.71,1.334,7.875,2.418,11.151,4.682a44.528,44.528,0,0,1,4.586,3.96,16.115,16.115,0,0,0,3.517,2.577,16.98,16.98,0,0,0,7.306,1.358c1.37,0,10.209.022,11.347-.005a13.987,13.987,0,0,0,1.623-.123,4.312,4.312,0,0,0,1.395-.422,2.589,2.589,0,0,0,.95-.871,4.938,4.938,0,0,0,.659-1.936,11.8,11.8,0,0,0,.031-3.355,6.478,6.478,0,0,0-.768-2.382,5.988,5.988,0,0,0-2.781-2.174c-.77-.363-1.961-.879-2.69-1.278a22.585,22.585,0,0,1-2.029-1.242,43.063,43.063,0,0,1-4.317-3.444,40.856,40.856,0,0,1-3.309-3.286,22.381,22.381,0,0,1-1.939-2.518C456.177,590.252,455.168,588.185,454.254,586.592Z"
                    transform="translate(-427.056 -581.319)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_138_" transform="translate(8.353 176.948)">
              <path id="Path_316" data-name="Path 316"
                    d="M219.677,509.844a94.013,94.013,0,0,0,5-10.583,87.254,87.254,0,0,0,2.961-9.438l3.632-14.893c1.674-6.515,3.652-13.128,7.152-18.918a60.107,60.107,0,0,1,4.973-6.973c1.593-2,4.783-5.44,6.519-7.37a25.561,25.561,0,0,0,3.224-4.356,16.551,16.551,0,0,0,1.5-3.819,34.743,34.743,0,0,0,.863-5.014c.823-8.31,1.082-23.581,1.472-32.07"
                    transform="translate(-219.677 -396.41)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_137_" transform="translate(22.073 187.017)">
              <path id="Path_317" data-name="Path 317"
                    d="M243.013,517.808c1.128-2.891,2.464-6.351,3.837-9.1,2.376-4.813,5.478-10.024,8.22-14.653,4.665-7.5,11.576-19.37,16.638-26.45a140.579,140.579,0,0,1,9.907-11.744,39.53,39.53,0,0,0,5.332-7.307,22.854,22.854,0,0,0,1.765-4.6c.652-2.3,1.355-7.015,1.8-9.413a205.731,205.731,0,0,1,5.126-21.011"
                    transform="translate(-243.013 -413.534)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_136_" transform="translate(0 287.578)">
              <path id="Path_318" data-name="Path 318"
                    d="M228.051,589.661a7.13,7.13,0,0,0-3.274-4.41,5.467,5.467,0,0,0-2.34-.676,13.007,13.007,0,0,0-5.568,1.275,22.66,22.66,0,0,0-5.174,2.96c-2.178,1.761-3.277,4.447-4.2,7.014-.584,1.662-1.106,3.412-1.528,5.122a16.247,16.247,0,0,0-.487,2.708,4.189,4.189,0,0,0,.087,1.181,3.844,3.844,0,0,0,.425,1.047,9.468,9.468,0,0,0,.864,1.217c.683.85,2.069,2.312,2.809,3.134.415.472,1.515,1.745,1.924,2.24a10.737,10.737,0,0,0,2.97,2.569,8.74,8.74,0,0,0,2.826.866,24.32,24.32,0,0,0,2.829.225c1.878.036,12.98.049,14.944-.005a6.939,6.939,0,0,0,2.194-.372,2.347,2.347,0,0,0,1.157-.973,4.54,4.54,0,0,0,.573-2.078,8.564,8.564,0,0,0-.3-2.8,7.25,7.25,0,0,0-1.372-2.583,30.785,30.785,0,0,0-4.22-3.7,15.416,15.416,0,0,1-2.7-2.691,10.255,10.255,0,0,1-1.654-3.478,22.2,22.2,0,0,1-.489-5.3A11.986,11.986,0,0,0,228.051,589.661Z"
                    transform="translate(-205.471 -584.565)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_135_" transform="translate(33.872 128.373)">
              <path id="Path_319" data-name="Path 319"
                    d="M285.866,313.8c-4.566,5.407-8.82,11.3-11.128,18.057l-1.844,5.371a44.444,44.444,0,0,1-2.331,5.5c-1.174,2.313-3.5,5.835-4.894,8.062a21.522,21.522,0,0,0-2.423,4.765,3.833,3.833,0,0,0-.15,1.441,2.581,2.581,0,0,0,.383,1.1,3.841,3.841,0,0,0,.885.95,8.723,8.723,0,0,0,1.627.984,35.216,35.216,0,0,0,9.2,2.4,107.1,107.1,0,0,1,12.066,2.157,31.3,31.3,0,0,1,4.053,1.405c2.431,1.045,5.319,2.718,7.65,4.019a35.972,35.972,0,0,0,8.413,3.6,32.093,32.093,0,0,0,8.748.8c5.738-.094,18.333-2.275,24.158-3.024a111.379,111.379,0,0,0,18.469-4.337c2.248-.721,4.715-1.559,6.9-2.443a27.6,27.6,0,0,0,3.241-1.511,4.655,4.655,0,0,0,.886-.64,1.732,1.732,0,0,0,.416-.6,2.971,2.971,0,0,0-.155-1.925c-.513-1.525-1.891-4.09-2.608-5.572a26.951,26.951,0,0,1-1.492-3.789c-.594-2-1.314-4.524-2.073-6.451-1.408-3.834-7.8-17.753-9.531-21.719"
                    transform="translate(-263.079 -313.796)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_134_" transform="translate(56.243 110.013)">
              <path id="Path_320" data-name="Path 320"
                    d="M311,282.57c-1.887,2.815-3.848,6.511-5.732,9.325-.968,1.475-2.344,3.16-3.232,4.682a7.169,7.169,0,0,0-.815,1.921,3.5,3.5,0,0,0-.086,1.105,3.557,3.557,0,0,0,.348,1.215,10.322,10.322,0,0,0,3,3.256c2.168,1.665,4.632,3.2,6.952,4.646a121.509,121.509,0,0,0,12.078,6.578,42.991,42.991,0,0,0,7.04,2.644,23.279,23.279,0,0,0,4.1.667c1.639.134,3.771.053,5.419.032"
                    transform="translate(-301.126 -282.57)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_133_" transform="translate(106.447 31.189)">
              <path id="Path_321" data-name="Path 321"
                    d="M386.566,161.82a7.988,7.988,0,0,1,.231-3.145,3.25,3.25,0,0,1,.6-1.107,2.7,2.7,0,0,1,.734-.591c.735-.419,1.67-.628,2.441-.968a2.891,2.891,0,0,0,.9-.582,3,3,0,0,0,.681-1.4,14.814,14.814,0,0,1,.669-2.609,7.6,7.6,0,0,1,2.958-2.906"
                    transform="translate(-386.512 -148.508)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_132_" transform="translate(116.399 36.363)">
              <path id="Path_322" data-name="Path 322"
                    d="M403.438,165.077a4.372,4.372,0,0,0,1.632-.088,2.427,2.427,0,0,0,1.074-.54,2.68,2.68,0,0,0,.667-1.308,18.926,18.926,0,0,0,.68-5.831"
                    transform="translate(-403.438 -157.309)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_131_" transform="translate(115.582 10.548)">
              <path id="Path_323" data-name="Path 323"
                    d="M405.284,125.615a13.433,13.433,0,0,0,2.841.175,4.581,4.581,0,0,0,2.722-.777,5.069,5.069,0,0,0,.9-.923c.749-.983,1.5-2.35,2.193-3.378a20.2,20.2,0,0,1,5.135-5.435,9.88,9.88,0,0,1,4.907-1.849,12.924,12.924,0,0,1,5.253.842,20.755,20.755,0,0,1,5.507,3.035c1.7,1.332,3.356,3.052,3.74,5.258a8.305,8.305,0,0,1,.063,2.116c-.168,1.7-.59,3.755-.737,5.452-.35,3.14-.573,6.7-1.564,9.705a27.174,27.174,0,0,1-2.786,5.782,25.7,25.7,0,0,1-1.813,2.618,10.033,10.033,0,0,1-1.513,1.553,9.647,9.647,0,0,1-2.444,1.334,15.067,15.067,0,0,1-3.465.614,16.3,16.3,0,0,1-5.889-.906,13.433,13.433,0,0,1-5.109-3.106,22.713,22.713,0,0,1-3.046-4.038c-.647-1.034-1.51-2.527-2.237-3.481a3.248,3.248,0,0,0-1.341-1.145,12.5,12.5,0,0,0-1.521-.305,3.057,3.057,0,0,1-1.319-.723,5.7,5.7,0,0,1-1.465-3.256,15.017,15.017,0,0,1-.115-4.6,2.193,2.193,0,0,1,.56-1.308,1.306,1.306,0,0,1,.73-.288,2.283,2.283,0,0,1,1.478.391,8.158,8.158,0,0,1,1.425,1.635.636.636,0,0,0,.227.171h.058c.121,0,.206-.106.264-.2a5.319,5.319,0,0,0,.314-2.512,9.257,9.257,0,0,1,.326-2.285"
                    transform="translate(-402.048 -113.403)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_130_" transform="translate(115.869)">
              <path id="Path_324" data-name="Path 324"
                    d="M403.325,121.264a27.939,27.939,0,0,1-.37-11.461,15.8,15.8,0,0,1,3.216-7.729,17.443,17.443,0,0,1,6.16-4.512,22.46,22.46,0,0,1,11.3-2.014,21.033,21.033,0,0,1,6.387,1.56,12.949,12.949,0,0,1,4.227,2.778,13.494,13.494,0,0,1,2.547,3.9c.662,1.484,1.308,3.083,1.827,4.622"
                    transform="translate(-402.536 -95.464)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_129_" transform="translate(117.557 7.033)">
              <path id="Path_325" data-name="Path 325"
                    d="M405.407,126.142a34.041,34.041,0,0,1,1.643-3.89,37.376,37.376,0,0,1,4.661-6.668,27.88,27.88,0,0,1,6.75-5.833,17.3,17.3,0,0,1,4.817-1.921,15.626,15.626,0,0,1,6.712-.077,19.257,19.257,0,0,1,6.8,3.007,17.467,17.467,0,0,1,3.226,2.812,7.426,7.426,0,0,1,1.737,3.136,5.96,5.96,0,0,1-.24,3.3,11.292,11.292,0,0,1-1.689,3.109"
                    transform="translate(-405.407 -107.425)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_128_" transform="translate(103.778 43.425)">
              <path id="Path_326" data-name="Path 326"
                    d="M381.973,171.24a30.812,30.812,0,0,1,5.254-1.387,29.585,29.585,0,0,1,4.575-.533,6.539,6.539,0,0,1,1.889.19,1.92,1.92,0,0,1,1.147.827,3.659,3.659,0,0,1,.4,1.751c.062,1.732-.569,5.939-.739,7.727-.556,5.53-.918,11.609-1.118,17.166-.09,3.347-.21,7.263-.038,10.6a20.994,20.994,0,0,0,.787,5.078,7.6,7.6,0,0,0,.985,2.055,5.958,5.958,0,0,0,1.542,1.5,10.542,10.542,0,0,0,3.654,1.431,13.461,13.461,0,0,0,6.387,0,7.993,7.993,0,0,0,2.886-1.465,12.5,12.5,0,0,0,3.038-3.812,32.672,32.672,0,0,0,2.8-7.7c2.294-9.538,2.676-20.784,3.986-30.51"
                    transform="translate(-381.973 -169.32)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_127_" transform="translate(54.847 45.32)">
              <path id="Path_327" data-name="Path 327"
                    d="M321.457,243.506c-3.3-1.653-7.435-4.009-10.66-5.826-2.517-1.472-5.266-3.059-7.657-4.721a18.708,18.708,0,0,1-3.226-2.658,4.378,4.378,0,0,1-1.072-2.117,7.936,7.936,0,0,1,.151-3.045,23.318,23.318,0,0,1,1.745-4.838c2.576-5.338,6.206-10.316,9.684-15.1,4.413-5.849,9.481-12.624,14.237-18.179a41.357,41.357,0,0,1,17.666-12.836,24.428,24.428,0,0,1,4.311-1.456,6.634,6.634,0,0,1,2.328-.13,2.691,2.691,0,0,1,1.332.577,4.483,4.483,0,0,1,1.275,2.566,23.66,23.66,0,0,1,.229,5.431,72.075,72.075,0,0,1-1.228,10.5,41.554,41.554,0,0,1-2.632,8.657,21.027,21.027,0,0,1-3.541,5.655,9.273,9.273,0,0,1-3.172,2.338,8.578,8.578,0,0,1-4.151.436,15.83,15.83,0,0,0-3.852-.149,3.7,3.7,0,0,0-1.443.66,21.7,21.7,0,0,0-1.974,1.839c-2.416,2.284-6.051,5.017-8.517,7.253a46.5,46.5,0,0,0-3.387,3.3,12.116,12.116,0,0,0-1.515,1.991,1.962,1.962,0,0,0-.319,1.456,3.015,3.015,0,0,0,.747,1.12,35.83,35.83,0,0,0,2.882,2.644c2.22,1.879,4.618,3.852,6.99,5.53"
                    transform="translate(-298.752 -172.542)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_126_" transform="translate(135.553 50.659)">
              <path id="Path_328" data-name="Path 328"
                    d="M436.014,258.591c2.34-2,4.85-4.253,7-6.446,3.667-3.742,7.238-8,10.534-12.076a29.638,29.638,0,0,0,4.521-6.865c1.139-2.679,1.023-6.013,1.159-8.878.066-1.4.226-2.879.417-4.268l1.445-9.545a93.481,93.481,0,0,0,1.051-13.1,15.336,15.336,0,0,0-.944-5.74,13.667,13.667,0,0,0-4.363-4.927,32.4,32.4,0,0,0-6.141-3.834,23.317,23.317,0,0,0-3.815-1.289"
                    transform="translate(-436.014 -181.623)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_100_" transform="translate(119.371 118.445)">
              <path id="Path_329" data-name="Path 329"
                    d="M408.492,304.257l.4-.832a9.2,9.2,0,0,1,2.534-3.018,19.7,19.7,0,0,1,4.339-2.818,6.485,6.485,0,0,1,2.642-.678,3.475,3.475,0,0,1,1.823.524,5.62,5.62,0,0,1,1.638,1.669,17.978,17.978,0,0,1,1.725,3.5c.323.88.716,1.842.956,2.746a3.489,3.489,0,0,1,.055,1.739,4.629,4.629,0,0,1-.817,1.572,17.032,17.032,0,0,1-2.438,2.481c-.774.666-1.6,1.343-2.434,1.933a10.446,10.446,0,0,1-1.618.971,1.66,1.66,0,0,1-1.166.188,2.785,2.785,0,0,1-.686-.48"
                    transform="translate(-408.492 -296.911)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_99_" transform="translate(108.802 124.152)">
              <path id="Path_330" data-name="Path 330"
                    d="M392.018,325.122a17.029,17.029,0,0,0,4.456.11,15.436,15.436,0,0,0,3.845-.881,13.475,13.475,0,0,0,3.836-2.3,21.053,21.053,0,0,0,3.09-3.114,7.246,7.246,0,0,0,1.274-2.328,3.4,3.4,0,0,0,.138-1.124,3.755,3.755,0,0,0-.258-1.141,8.738,8.738,0,0,0-1.08-1.878c-.343-.459-1.914-2.684-2.262-3.068a3.372,3.372,0,0,0-1.305-.985,3.963,3.963,0,0,0-1.384-.218c-1.423-.019-2.936.342-4.343.014a20.661,20.661,0,0,1-2.885-1.3,6.411,6.411,0,0,0-4.622.357"
                    transform="translate(-390.517 -306.616)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_98_" transform="translate(77.547 106.947)">
              <path id="Path_331" data-name="Path 331"
                    d="M349.207,294.166c-1.922-.784-5.045-2.5-6.922-3.47-.953-.5-2.334-1.07-3.279-1.585a5.684,5.684,0,0,1-.784-.514,2.089,2.089,0,0,1-.822-1.268,4.908,4.908,0,0,1,.406-2.449,27.9,27.9,0,0,1,2.153-4.362,12.224,12.224,0,0,1,1.674-2.224,3.081,3.081,0,0,1,1.485-.891,2.662,2.662,0,0,1,1.292.079,8.39,8.39,0,0,1,1.677.733,24.078,24.078,0,0,1,3.32,2.141"
                    transform="translate(-337.361 -277.354)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_97_" transform="translate(89.241 104.178)">
              <path id="Path_332" data-name="Path 332"
                    d="M371.073,319.406a16.453,16.453,0,0,1-5.981-3.171,17.364,17.364,0,0,1-4.813-5.606,16.242,16.242,0,0,1-1.308-4.066c-.423-2.071-.694-4.806-.952-6.926a103.631,103.631,0,0,1-.29-22.374,12.238,12.238,0,0,1,.463-2.315,2.866,2.866,0,0,1,.843-1.309,4.3,4.3,0,0,1,2.254-.943,7.294,7.294,0,0,1,2.443.132,12.716,12.716,0,0,1,3.722,1.488,18.237,18.237,0,0,1,3.5,2.7,16.023,16.023,0,0,1,2.769,3.552,25.965,25.965,0,0,1,2.549,8.824l.736,5.252a7.816,7.816,0,0,0,.385,1.615,4.522,4.522,0,0,0,.552.948,14.23,14.23,0,0,1,1.769,2.774,4.965,4.965,0,0,1,.369,1.7,4.207,4.207,0,0,1-.193,1.438,9.133,9.133,0,0,1-.9,1.733,4.471,4.471,0,0,0-.434.944,4.939,4.939,0,0,0-.181,1.169c-.045,1.737.017,3.7-.135,5.428a15.068,15.068,0,0,1-.733,3.871,5.409,5.409,0,0,1-1.7,2.572A5.7,5.7,0,0,1,371.073,319.406Z"
                    transform="translate(-357.249 -272.646)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
          </g>
          <g id="_x32_D_x24_AG-OUTLINE" transform="translate(199.034 95.464)">
            <g id="POLYLINE_304_" transform="translate(124.955 83.348)">
              <path id="Path_333" data-name="Path 333"
                    d="M439.115,237.218c-.684,2.345-1.523,4.871-2.36,7.164a39.148,39.148,0,0,1-3.787,7.855c-2.392,3.7-6.068,7.5-8.716,11.022a66.443,66.443,0,0,0-6.263,10.636,12.653,12.653,0,0,1,2.912-1.363,4.145,4.145,0,0,1,2.494-.041c2.99-4.278,7.918-11.268,10.635-15.66a34.842,34.842,0,0,0,3.056-6.074,20.613,20.613,0,0,0,.934-3.758c.2-1.177.418-3.758.547-4.97Z"
                    transform="translate(-417.989 -237.218)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3.5"/>
            </g>
            <g id="POLYLINE_303_">
              <path id="Path_334" data-name="Path 334"
                    d="M322.128,121.264a27.938,27.938,0,0,1-.37-11.461,15.8,15.8,0,0,1,3.216-7.729,17.443,17.443,0,0,1,6.16-4.512,22.46,22.46,0,0,1,11.3-2.014,21.033,21.033,0,0,1,6.387,1.56,12.95,12.95,0,0,1,4.227,2.778,13.493,13.493,0,0,1,2.547,3.9c.662,1.484,1.308,3.083,1.827,4.622a7.024,7.024,0,0,1,2.081,4.249,6.478,6.478,0,0,1-.413,2.565,11.412,11.412,0,0,1-1.642,2.975c-.085.634-.383,2.444-.463,3.075-.13.943-.4,3.756-.512,4.753a34.853,34.853,0,0,1-1.088,5.988,27.664,27.664,0,0,1-3.36,6.913,15.687,15.687,0,0,1-2.724,3.341,7.554,7.554,0,0,1-1.7,1.07,9.6,9.6,0,0,1,2.856,1.222,3.989,3.989,0,0,1,1.428,1.568,23.334,23.334,0,0,1,3.815,1.289,32.407,32.407,0,0,1,6.141,3.834,13.661,13.661,0,0,1,4.363,4.927,15.324,15.324,0,0,1,.944,5.74,93.377,93.377,0,0,1-1.051,13.1l-1.445,9.545c-.191,1.389-.351,2.868-.417,4.268-.138,2.874-.018,6.193-1.159,8.878a29.637,29.637,0,0,1-4.521,6.865c-3.3,4.08-6.867,8.333-10.534,12.076-2.143,2.19-4.661,4.453-7,6.446a2.957,2.957,0,0,1-.13,1.188,6.553,6.553,0,0,1-1.49,2.243,31.056,31.056,0,0,1-3.66,3.2,10.424,10.424,0,0,1-2.414,1.449,1.3,1.3,0,0,1-.847.066,2.747,2.747,0,0,1-.694-.483,10.462,10.462,0,0,1-1.187,1.677c1.776,4.062,8.092,17.814,9.531,21.719.757,1.921,1.482,4.456,2.073,6.451a26.931,26.931,0,0,0,1.492,3.789,50.4,50.4,0,0,1,2.7,5.874,3.709,3.709,0,0,1,.169,1.047,1.59,1.59,0,0,1-.172.717,2.122,2.122,0,0,1-.583.665,9.967,9.967,0,0,1-1.719,1,169.974,169.974,0,0,1,12.661,43.476c.253,1.982.608,5.3,1.018,7.223.5,2.439,1.469,6.778,1.817,9.181a56.172,56.172,0,0,1,.645,6.672c.085,2.249.042,4.694-.051,6.946-.354,6.7-1.99,27.331-2.605,33.957a5.048,5.048,0,0,1,3.337,2.2c2.221,2.736,3.485,6.265,5.56,9.1a38.161,38.161,0,0,0,6.174,6.266,33.127,33.127,0,0,0,4.022,2.915,34.964,34.964,0,0,0,3.5,1.736,6.847,6.847,0,0,1,2.458,1.71,6.753,6.753,0,0,1,1.185,3.9,11.252,11.252,0,0,1-.239,2.877,3.817,3.817,0,0,1-.771,1.652,2.9,2.9,0,0,1-1.506.874,11.512,11.512,0,0,1-2.573.254c-2.795-.032-10.412.1-13.074-.088a17.237,17.237,0,0,1-3.339-.547,10.47,10.47,0,0,1-2.419-1,17.9,17.9,0,0,1-3-2.3,40.452,40.452,0,0,0-4.851-4.139c-3.617-2.414-8.175-3.382-12.159-5a9.139,9.139,0,0,1-2.926-1.79,3.976,3.976,0,0,1-.91-1.393,5.173,5.173,0,0,1-.285-2.089,17.6,17.6,0,0,1,1.122-4.716,49.525,49.525,0,0,1,3-6.743,13,13,0,0,1,1.817-2.669,2.779,2.779,0,0,1,1.215-.8,1.927,1.927,0,0,1,1.1.048,68.234,68.234,0,0,0-.353-7.9,38.357,38.357,0,0,0-1.4-6.048l-2.643-8.35a59.966,59.966,0,0,1-3.036-20.356c.007-2.238.174-7.664.025-9.814a11.14,11.14,0,0,0-.237-1.777,4.786,4.786,0,0,0-.422-1.138A17.692,17.692,0,0,0,334.7,324.2a42.276,42.276,0,0,1-2.468-4.111c-3.08-5.646-7.056-14.045-10.923-19.094a71.97,71.97,0,0,0-5.627-6.435,151.8,151.8,0,0,0-11.752-11.341,79.058,79.058,0,0,1-14.359,1.215,29.194,29.194,0,0,1-5.318-.646,25.657,25.657,0,0,1-4.085-1.311,205.806,205.806,0,0,0-5.126,21.011c-.453,2.431-1.147,7.093-1.8,9.413a22.87,22.87,0,0,1-1.765,4.6,39.584,39.584,0,0,1-5.332,7.307,140.458,140.458,0,0,0-9.907,11.744c-5.03,7.032-12,18.992-16.638,26.45-2.743,4.63-5.841,9.836-8.22,14.653-1.374,2.739-2.713,6.227-3.837,9.1a9.148,9.148,0,0,1,.8,3.879,22.734,22.734,0,0,0,.464,5.2,10.28,10.28,0,0,0,1.679,3.576,15.4,15.4,0,0,0,2.7,2.691,32.716,32.716,0,0,1,4.159,3.629,7.3,7.3,0,0,1,1.411,2.583,8.536,8.536,0,0,1,.325,2.8,4.57,4.57,0,0,1-.594,2.175,2.344,2.344,0,0,1-1.141.947,6.94,6.94,0,0,1-2.194.372c-1.98.053-13.045.042-14.944.005a24.206,24.206,0,0,1-2.829-.225,8.745,8.745,0,0,1-2.826-.865,10.745,10.745,0,0,1-2.97-2.569c-.979-1.187-2.562-2.962-3.617-4.091-.508-.572-1.082-1.2-1.528-1.816a6.055,6.055,0,0,1-.664-1.1,3.538,3.538,0,0,1-.3-1.241,7.99,7.99,0,0,1,.191-1.951c.317-1.555.76-3.14,1.229-4.657a39.549,39.549,0,0,1,1.716-4.587,13.209,13.209,0,0,1,1.8-2.949,12.18,12.18,0,0,1,3.409-2.712,94,94,0,0,0,5-10.583,87.252,87.252,0,0,0,2.961-9.438l3.632-14.893c1.674-6.515,3.652-13.128,7.152-18.918a60.109,60.109,0,0,1,4.973-6.973c1.593-2,4.783-5.44,6.519-7.37a25.56,25.56,0,0,0,3.224-4.356,16.55,16.55,0,0,0,1.5-3.819,34.738,34.738,0,0,0,.863-5.014c.823-8.31,1.082-23.581,1.472-32.07a42.1,42.1,0,0,1-7.2-1.672,11.686,11.686,0,0,1-3.284-1.661,3.767,3.767,0,0,1-.927-1.018,2.571,2.571,0,0,1-.342-1.03,4.15,4.15,0,0,1,.24-1.74,23.754,23.754,0,0,1,2.332-4.466c1.391-2.21,3.729-5.765,4.894-8.062a44.7,44.7,0,0,0,2.331-5.5L251,241.894c2.307-6.752,6.562-12.65,11.128-18.057a3.549,3.549,0,0,1-.414-1.488,4.074,4.074,0,0,1,.28-1.556c.727-1.889,2.329-3.727,3.46-5.4,2.085-3,4.1-6.876,6.135-9.916-2.27-1.355-4.9-2.867-7.044-4.386a24.24,24.24,0,0,1-2.458-1.922,5.117,5.117,0,0,1-1.625-2.485,5.954,5.954,0,0,1-.117-1.932,13.158,13.158,0,0,1,.579-2.752,35.868,35.868,0,0,1,3.275-7.033c5.04-8.472,11.708-16.69,17.729-24.5,3.858-4.8,7.838-9.773,12.946-13.3a49.951,49.951,0,0,1,8.611-4.577,20.726,20.726,0,0,1,5.763-1.787,27.558,27.558,0,0,1,2.723-.845,7.99,7.99,0,0,1,.231-3.145,3.25,3.25,0,0,1,.6-1.107,2.7,2.7,0,0,1,.734-.591c.735-.419,1.67-.628,2.441-.968a2.891,2.891,0,0,0,.9-.582,3,3,0,0,0,.681-1.4,14.812,14.812,0,0,1,.669-2.609,7.6,7.6,0,0,1,2.957-2.906,16.321,16.321,0,0,1-.1-3.007,6.3,6.3,0,0,1,.252-1.513,1.58,1.58,0,0,1,.326-.578A1.1,1.1,0,0,1,322.128,121.264Z"
                    transform="translate(-205.47 -95.464)" fill="none" stroke="#6115ad" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3.5"/>
            </g>
          </g>
        </g>
      </svg>
  ) : (
      <svg xmlns="http://www.w3.org/2000/svg" width="131.573" height="323.495" viewBox="0 0 131.573 323.495">
        <g id="_600782aeb85595784abf898f_Dimensions-Sports-Pickleball-Tyson-McGuffin-Icon"
           data-name="600782aeb85595784abf898f_Dimensions-Sports-Pickleball-Tyson-McGuffin-Icon"
           transform="translate(-247.194 -90.772)">
          <g id="_x32_D_x24_AG-DIAGRAM" transform="translate(248.819 412.511)">
            <g id="POLYLINE_316_">
              <g id="Group_512" data-name="Group 512">
                <g id="Group_511" data-name="Group 511">
                  <line id="Line_127" data-name="Line 127" x2="1.132" fill="none" stroke="#00b731"
                        stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"/>
                  <line id="Line_128" data-name="Line 128" x2="120.228" transform="translate(5.019)" fill="none"
                        stroke="#00b731" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"
                        stroke-dasharray="3.925 6.868"/>
                  <line id="Line_129" data-name="Line 129" x2="1.132" transform="translate(127.191)" fill="none"
                        stroke="#00b731" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"/>
                </g>
              </g>
            </g>
          </g>
          <g id="_x32_D_x24_AG-SPORTS" transform="translate(250.262 92.526)">
            <g id="POLYLINE_125_" transform="translate(110.198 280.906)">
              <path id="Path_335" data-name="Path 335"
                    d="M446.065,607.767A51.517,51.517,0,0,1,447.95,597.4l1.142-3.483a10.4,10.4,0,0,0,.614-3.043,4.179,4.179,0,0,0-.3-1.377c-.039-.1-.225-.58-.258-.672"
                    transform="translate(-446.065 -588.83)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_124_" transform="translate(96.891 280.721)">
              <path id="Path_336" data-name="Path 336"
                    d="M424.359,588.5a5.187,5.187,0,0,0-1.189.856,2.071,2.071,0,0,0-.449.873,7.065,7.065,0,0,0-.168,1.76c0,.949.134,2.529.2,3.49.11,1.534.136,3.234.115,4.773-.021.936-.136,5.466-.14,6.3"
                    transform="translate(-422.554 -588.503)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_123_" transform="translate(92.914 206.916)">
              <path id="Path_337" data-name="Path 337"
                    d="M415.528,459.619c0,4.6.187,9.578.594,14.158.332,4.218,1.338,10.783,1.956,15.03a53.475,53.475,0,0,1,.52,9.007,74.483,74.483,0,0,1-1.032,8.457,31.51,31.51,0,0,0-.36,5.663,46.745,46.745,0,0,0,1.2,7.985c.532,2.165,2.227,9.85,2.855,11.839a8.211,8.211,0,0,0,.587,1.453,2.54,2.54,0,0,0,1.058,1.083,6.1,6.1,0,0,0,1.9.528,24.253,24.253,0,0,0,3.793.134,26.809,26.809,0,0,0,3.808-.356,6.55,6.55,0,0,0,1.932-.606,2.943,2.943,0,0,0,.786-.623,4.5,4.5,0,0,0,.715-1.165,23.531,23.531,0,0,0,1.126-3.53c1.173-4.878,2.177-10.424,2.952-15.383a68.175,68.175,0,0,0,.942-11.592,35.15,35.15,0,0,0-1.007-7.246,85.421,85.421,0,0,1-2.375-11.274,14.579,14.579,0,0,1,0-3.291c.337-2.828,1.9-5.741,3.044-8.324a69.159,69.159,0,0,0,4.43-13.461"
                    transform="translate(-415.528 -458.106)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_122_" transform="translate(33.983 43.822)">
              <path id="Path_338" data-name="Path 338"
                    d="M311.408,203.357a12.105,12.105,0,0,1,.977-2.795,7.027,7.027,0,0,1,1.216-1.49,28.547,28.547,0,0,1,2.658-2.185c1.425-1.045,4.235-3.031,5.555-4.113a15.94,15.94,0,0,0,2.721-2.729,36.6,36.6,0,0,0,2.186-3.487,42.233,42.233,0,0,1,2.588-3.775,41.616,41.616,0,0,1,10.564-10.128,24.256,24.256,0,0,1,6.5-2.7"
                    transform="translate(-311.408 -169.953)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_121_" transform="translate(52.387 79.714)">
              <path id="Path_339" data-name="Path 339" d="M343.936,246.348a38.3,38.3,0,0,1,2-12.981"
                    transform="translate(-343.924 -233.367)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_120_" transform="translate(67.969 34.348)">
              <path id="Path_340" data-name="Path 340"
                    d="M383.546,153.214a33.306,33.306,0,0,0-1.207,9.834,30.622,30.622,0,0,0,.254,4.26,9.769,9.769,0,0,0,3.414,5.523,6.955,6.955,0,0,0,2.673,1.524,4.358,4.358,0,0,0,2.4-.074,12.577,12.577,0,0,0,2.073-.913,21.289,21.289,0,0,1,4.207-1.892,10.977,10.977,0,0,1,4.176-.262,7.51,7.51,0,0,1,1.813.445,7.88,7.88,0,0,1,1.434.838c.6.419,1.532.595,1.741,1.391a2.176,2.176,0,0,1,.036.758,6.084,6.084,0,0,1-.262,1.165,23.62,23.62,0,0,1-2.044,4.322,13.956,13.956,0,0,1-2.188,2.973,6.3,6.3,0,0,1-2.189,1.426,7.7,7.7,0,0,1-2.739.441,13.9,13.9,0,0,1-4.38-.819,20.571,20.571,0,0,1-5.71-3.12,19.1,19.1,0,0,1-5.607-6.65c-1.875-3.773-2.127-8.234-2.433-12.372a19.463,19.463,0,0,0-.591-3.581,6.434,6.434,0,0,0-1-2.109,4.827,4.827,0,0,0-2.648-1.713,3.218,3.218,0,0,0-1.891.042,1.841,1.841,0,0,0-.865.7,3.689,3.689,0,0,0-.524,1.73,12.167,12.167,0,0,0,.339,3.577,13.565,13.565,0,0,0,1.044,2.987,6,6,0,0,0,1.12,1.607,4.732,4.732,0,0,0,1.824.971,2.325,2.325,0,0,1,.7.387,1.552,1.552,0,0,1,.38.509,4.374,4.374,0,0,1,.272.811,18.683,18.683,0,0,1,.369,2.125,35.277,35.277,0,0,1,.16,6.922,66.532,66.532,0,0,0-.584,7.793c.1,2.658.773,5.594,2.981,7.3a3.858,3.858,0,0,0,2.938.88,4.774,4.774,0,0,0,1.559-.589,29.9,29.9,0,0,0,3.764-2.932c1.888-1.56,4.315-3.178,6.174-4.767"
                    transform="translate(-371.454 -153.214)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_119_" transform="translate(68.323 8.566)">
              <path id="Path_341" data-name="Path 341"
                    d="M373.165,134.872a30.566,30.566,0,0,1-.964-11.056,16.591,16.591,0,0,1,2.665-8.517,15.894,15.894,0,0,1,5.216-4.47,25.224,25.224,0,0,1,9.4-3.035c5.083-.6,10.585.788,14.05,4.73a21.527,21.527,0,0,1,3.675,6.262,32.4,32.4,0,0,1,1.98,6.945"
                    transform="translate(-372.08 -107.662)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_118_" transform="translate(102.391 31.35)">
              <path id="Path_342" data-name="Path 342"
                    d="M432.272,170.8l.69-3.4c.293-1.459.524-3.381.71-4.87a23.252,23.252,0,0,1,.541-2.778c.235-.905.726-2.255,1.013-3.153a10.879,10.879,0,0,0,.509-3.172,19.393,19.393,0,0,0-.205-2.479c-.127-.977-.278-2.07-.477-3.033"
                    transform="translate(-432.272 -147.918)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_117_" transform="translate(72.982 34.318)">
              <path id="Path_343" data-name="Path 343"
                    d="M404.621,154.083c-1.313.745-2.768,1.724-4.115,2.4a9.276,9.276,0,0,1-2.314.845,7.4,7.4,0,0,1-4.681-.65,26.86,26.86,0,0,1-3.564-2.31,5.3,5.3,0,0,0-3.167-1.2,9.262,9.262,0,0,0-3.26,1.142,10.691,10.691,0,0,1-1.71.651c-.255.072-1.266.346-1.5.423"
                    transform="translate(-380.311 -153.162)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_116_" transform="translate(97.292 31.23)">
              <path id="Path_344" data-name="Path 344"
                    d="M423.262,151.715a29.142,29.142,0,0,1,4.595-2.911,14.864,14.864,0,0,1,1.965-.68,10.862,10.862,0,0,1,2.155-.4,6.206,6.206,0,0,1,4.633,1.486,4.987,4.987,0,0,1,1.433,2.158,5.72,5.72,0,0,1,.179,2.694"
                    transform="translate(-423.262 -147.705)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_115_" transform="translate(78.425 25.178)">
              <path id="Path_345" data-name="Path 345"
                    d="M389.929,146.347a83,83,0,0,1,8.818-5.6c3.274-1.769,6.786-3.387,10.54-3.693a15.529,15.529,0,0,1,11.909,4.354,11.712,11.712,0,0,1,2.923,4.237,4.877,4.877,0,0,1,.311,1.763,3.616,3.616,0,0,1-.405,1.562,5.521,5.521,0,0,1-2.326,2.192,9.067,9.067,0,0,1-4.973,1.077"
                    transform="translate(-389.929 -137.012)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_114_" transform="translate(34.474 163.171)">
              <path id="Path_346" data-name="Path 346"
                    d="M328.684,381.643a82.808,82.808,0,0,0-8.893,14.146,88.1,88.1,0,0,0-6.52,15.26,19.556,19.556,0,0,0-.967,6.475,3.924,3.924,0,0,0,.691,2.074,3.492,3.492,0,0,0,1.139.92,13.489,13.489,0,0,0,2.261.878c6.776,2.006,14.1,3.834,21.025,5.224a48.947,48.947,0,0,0,8.166,1.079,5.265,5.265,0,0,0,2.232-.424,6.587,6.587,0,0,0,2.035-1.863c.957-1.149,4.383-6.42,5.3-7.745a88.93,88.93,0,0,1,5.579-7.607,5.29,5.29,0,0,1,1.234-1.113.7.7,0,0,1,.338-.08.616.616,0,0,1,.307.108,3.37,3.37,0,0,1,.846,1.084,24.483,24.483,0,0,1,1.485,3.451,84.289,84.289,0,0,1,2.585,9.259,11.128,11.128,0,0,0,.954,2.729,1.269,1.269,0,0,0,.7.605,1.766,1.766,0,0,0,.579.054c.923-.082,1.956-.151,2.888-.163,5.447-.094,14.406-.016,19.763-.358,1.692-.105,3.538-.233,5.21-.483a14.41,14.41,0,0,0,2.21-.475,2.238,2.238,0,0,0,1.258-.819,3.851,3.851,0,0,0,.388-1.276c1.076-5.616,1.207-15.373,1.558-21.162.109-2.039.314-4.629.516-6.656.211-2.2.714-6.283.749-8.476a18.038,18.038,0,0,0-.607-5.472"
                    transform="translate(-312.277 -380.817)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_113_" transform="translate(50.639 91.766)">
              <path id="Path_347" data-name="Path 347"
                    d="M343.313,275.55a234.958,234.958,0,0,1-1.187,38.165c-.3,3.032-1,7.863-1.274,10.885a7.655,7.655,0,0,0,.045,1.5,5.122,5.122,0,0,0,1.461,2.844,15.1,15.1,0,0,0,4.461,3.047,32.181,32.181,0,0,0,9.3,2.644,62.347,62.347,0,0,0,11.111.437,91.235,91.235,0,0,0,14.943-1.935c5.151-1.019,12.055-3.469,17.081-5.118a33.75,33.75,0,0,1,8.166-1.72,52.561,52.561,0,0,1,6.071.342,6.545,6.545,0,0,0,1.623-.08,1.957,1.957,0,0,0,.833-.368,1.744,1.744,0,0,0,.538-.843,4.678,4.678,0,0,0,.152-1.608,15.941,15.941,0,0,0-.433-2.7c-.681-2.818-1.948-6.261-2.6-9.081a72.926,72.926,0,0,1-1.682-22.685c.165-2.025,1.171-13.677,1.249-15.4.323-4.954.559-14.172.7-19.216"
                    transform="translate(-340.836 -254.66)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_112_">
              <path id="Path_348" data-name="Path 348"
                    d="M274.542,145.537a6.181,6.181,0,0,1,1.1-2.588,14.925,14.925,0,0,1,5.156-4.312l1.971-1.053a15.286,15.286,0,0,0,4.011-2.96,13.526,13.526,0,0,0,3.265-7.833c.343-1.531.057-20.8.116-22.857a11.759,11.759,0,0,0-.147-1.816,11.586,11.586,0,0,0-2.37-5.386,11.035,11.035,0,0,0-8.184-4.194c-.157,0-.341-.012-.5-.01l-8.23.023-8.23.023c-.155,0-.343,0-.5.013a11.036,11.036,0,0,0-1.663.209,11.157,11.157,0,0,0-6.588,4.145,11.589,11.589,0,0,0-2.252,5.283,11.755,11.755,0,0,0-.137,1.816c.07,2.144-.115,21.236.235,22.857a13.519,13.519,0,0,0,3.306,7.815,15.272,15.272,0,0,0,4.027,2.938l1.976,1.042a14.023,14.023,0,0,1,5.584,4.921"
                    transform="translate(-251.368 -92.529)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_111_" transform="translate(18.243 52.874)">
              <path id="Path_349" data-name="Path 349"
                    d="M283.6,185.958l4.623-.012a.478.478,0,0,1,.089.012.458.458,0,0,1,.265.179.481.481,0,0,1,.088.245c0,.01,0,.022,0,.032l.006,2.247c0,.04,0,.086,0,.126a2.2,2.2,0,0,1-.066.441.95.95,0,0,1-.483.686l.021,6.8"
                    transform="translate(-283.6 -185.946)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_110_" transform="translate(12.891 50.727)">
              <path id="Path_350" data-name="Path 350"
                    d="M275.415,194.873a16.768,16.768,0,0,1-1.13-4.914c-.087-.891-.132-1.849-.142-2.745a11.208,11.208,0,0,1,.072-1.625,3.9,3.9,0,0,1,.422-1.337,4.669,4.669,0,0,1,1.541-1.621,2.428,2.428,0,0,1,1.6-.462,1.383,1.383,0,0,1,.755.4,3.843,3.843,0,0,1,.792,1.3,13.9,13.9,0,0,1,.732,2.848,18.912,18.912,0,0,1-.13,7.758"
                    transform="translate(-274.143 -182.153)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_109_" transform="translate(23.755 50.983)">
              <path id="Path_351" data-name="Path 351"
                    d="M297.671,198.262a19.8,19.8,0,0,0,1.262-3.191,24.792,24.792,0,0,0,.828-4.656,18.159,18.159,0,0,0-.012-3.586,6.839,6.839,0,0,0-.539-2.077,3.384,3.384,0,0,0-.917-1.181,4.194,4.194,0,0,0-1.709-.8,5.89,5.89,0,0,0-3.247.136"
                    transform="translate(-293.338 -182.605)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_108_" transform="translate(20.427 81.281)">
              <path id="Path_352" data-name="Path 352"
                    d="M287.535,236.135a116.743,116.743,0,0,0,.374,12.286,32.61,32.61,0,0,0,.856,6.178c.41,1.47,1.094,3.137,2.642,3.7a5.092,5.092,0,0,0,1.868.284,15.609,15.609,0,0,0,3.269-.5,34.147,34.147,0,0,0,8.283-2.742"
                    transform="translate(-287.457 -236.135)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_107_" transform="translate(12.204 63.023)">
              <path id="Path_353" data-name="Path 353"
                    d="M338.2,236.063a24.455,24.455,0,0,1-2.683,2.479c-.58.466-1.534,1.271-2.134,1.679a3.875,3.875,0,0,1-1.95.738,5.8,5.8,0,0,1-1.506-.123,44.041,44.041,0,0,1-5.385-1.732,63.728,63.728,0,0,1-9.53-4.349,36.777,36.777,0,0,1-4.663-3.325c-3.454-2.933-11.627-9.674-14.89-12.649a19.558,19.558,0,0,1-1.829-1.859c-1.089-1.3-1.585-3.174-2.2-4.722A15.956,15.956,0,0,0,289,207.71a8.791,8.791,0,0,0-2.377-1.97,13.753,13.753,0,0,0-4.394-1.528,21.557,21.557,0,0,0-4.9-.3,9.3,9.3,0,0,0-2.959.581,2.583,2.583,0,0,0-1.116.816,3.075,3.075,0,0,0-.2,2.29l.23,1.184c.618,3.371.986,7.15,3.22,9.9a12.5,12.5,0,0,0,3.274,2.609c1.259.74,3.134,1.763,4.274,2.6a16.314,16.314,0,0,1,2,1.744c1.815,1.793,4.7,6.009,6.287,8.094,1.964,2.617,4.114,5.307,6.305,7.735a56.653,56.653,0,0,0,9.627,8.69,58.476,58.476,0,0,0,19.82,8.583,14.462,14.462,0,0,0,13.124-2.115c4.287-2.907,9.973-5.982,14.392-8.689"
                    transform="translate(-272.931 -203.878)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_106_" transform="translate(76.72 54.953)">
              <path id="Path_354" data-name="Path 354"
                    d="M398.56,216.443a26.056,26.056,0,0,0-4.415,3.512,62.871,62.871,0,0,0-5.736,6.508,11.519,11.519,0,0,0-1.364,2,1.477,1.477,0,0,0-.125.448.7.7,0,0,0,.14.5,2.647,2.647,0,0,0,.879.611l1.493.729c3.307,1.686,8.6,6.079,11.652,8.283a45.384,45.384,0,0,0,5.548,3.6,8.745,8.745,0,0,0,4.23,1.122,14.74,14.74,0,0,0,4.166-.981,36.294,36.294,0,0,0,5.1-2.343,52.685,52.685,0,0,0,5.989-3.807,23.721,23.721,0,0,0,5.666-5.594,16.529,16.529,0,0,0,2.462-6.18,30.318,30.318,0,0,0,.249-9.164,40.987,40.987,0,0,0-1.944-8.59,25.211,25.211,0,0,0-5.513-9.47,28.788,28.788,0,0,0-7.562-5.279,47.252,47.252,0,0,0-6.262-2.725"
                    transform="translate(-386.916 -189.619)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_105_" transform="translate(51.019 276.731)">
              <path id="Path_355" data-name="Path 355"
                    d="M342.533,601.062l-.149-4.643a58.525,58.525,0,0,1,.44-8.3,21.235,21.235,0,0,0,.14-4.1,3.374,3.374,0,0,0-.378-1.266,7.187,7.187,0,0,0-1.078-1.294"
                    transform="translate(-341.508 -581.455)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_104_" transform="translate(34.114 279.735)">
              <path id="Path_356" data-name="Path 356"
                    d="M313.179,586.762a2.527,2.527,0,0,0-1.372,1.036,2,2,0,0,0-.162.706,24.661,24.661,0,0,0,.451,3.765c.343,2.39.59,6.875.784,9.33l.125,1.353"
                    transform="translate(-311.64 -586.762)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_103_" transform="translate(27.691 201.085)">
              <path id="Path_357" data-name="Path 357"
                    d="M307.339,447.8l-.949,3.05a47.338,47.338,0,0,0-1.193,4.818c-.594,3.187-.984,7.82-1.473,11.039-.211,1.386-.473,2.863-.81,4.222-.331,1.421-1.3,4.505-1.72,5.936a18.756,18.756,0,0,0-.9,5.62,24.633,24.633,0,0,0,.268,3.167c.04.275.125.836.17,1.111l2.553,14.88,4.546,22.888.183.929c.077.357.156.736.267,1.083a3.172,3.172,0,0,0,.636,1.206,2.918,2.918,0,0,0,1.026.7,7.555,7.555,0,0,0,2.145.517,14.955,14.955,0,0,0,7.093-1.1,7.878,7.878,0,0,0,3.574-2.278,4.319,4.319,0,0,0,.683-1.384c.539-1.829.382-4.3.464-6.2a65.079,65.079,0,0,1,1-7.776,36.331,36.331,0,0,0,.208-9.4,64.116,64.116,0,0,0-1.767-9.906c-.3-1.183-.946-3.052-1.215-4.239a7.131,7.131,0,0,1-.19-1.476,6.379,6.379,0,0,1,.46-2.318,18.308,18.308,0,0,1,.822-1.818c.894-1.743,2.148-3.935,3.117-5.649,1.853-3.217,3.97-6.78,6.018-9.87a41.293,41.293,0,0,1,5.373-6.769l2.073-2.023"
                    transform="translate(-300.293 -447.803)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_102_" transform="translate(15.83 295.53)">
              <path id="Path_358" data-name="Path 358"
                    d="M317.442,619.409a15.956,15.956,0,0,0-.727-3.011,2.44,2.44,0,0,0-.515-.786.646.646,0,0,0-.4-.188.567.567,0,0,0-.308.086,3.122,3.122,0,0,0-.718.739c-2.132,2.91-3.5,4.226-6.841,1.842-1.907-1.358-3.948-2.983-6.322-3.35a4.187,4.187,0,0,0-2.744.389,4.015,4.015,0,0,0-1.124,1,22.6,22.6,0,0,0-2.188,3.994,12.369,12.369,0,0,1-2.519,3.659,13.735,13.735,0,0,1-2.589,1.915,81.35,81.35,0,0,1-8.83,4.043,4.094,4.094,0,0,0-1.661,1.071,2.9,2.9,0,0,0-.461,1.276,14.15,14.15,0,0,0-.048,3.85,5.514,5.514,0,0,0,.568,1.962,2.118,2.118,0,0,0,.945.875,5.642,5.642,0,0,0,2.246.347l30.235,0c.247-.009.833,0,1.068-.015a14.551,14.551,0,0,0,2.093-.184,3.473,3.473,0,0,0,1.866-.829,4.339,4.339,0,0,0,.917-3.029,30.9,30.9,0,0,0-.24-3.838C318.7,627.592,318.047,623.017,317.442,619.409Z"
                    transform="translate(-279.335 -614.669)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
            <g id="POLYLINE_101_" transform="translate(93.948 295.772)">
              <path id="Path_359" data-name="Path 359"
                    d="M433.6,619.166a6.547,6.547,0,0,0-3.044-3.355,8.993,8.993,0,0,0-3.543-.709,21.264,21.264,0,0,0-3.007.143,4.778,4.778,0,0,0-1.875.576c-1.352.819-1.778,2.476-2.159,3.909-.275,1.036-.921,4.527-1.143,5.637-.413,2.117-1.169,5.139-1.39,7.259a8.124,8.124,0,0,0,.276,3.74,3.852,3.852,0,0,0,1.673,1.992,6.28,6.28,0,0,0,2.129.719,16.346,16.346,0,0,0,2.049.2c1.056.053,9.47.031,10.719.034a11.8,11.8,0,0,0,2.148-.146,2.35,2.35,0,0,0,.917-.376,2.291,2.291,0,0,0,.782-1.328,12.92,12.92,0,0,0,.235-2.981,17.512,17.512,0,0,0-.435-3.994A13.968,13.968,0,0,0,437,627.9a36.972,36.972,0,0,1-1.859-4.267C434.689,622.3,434.193,620.44,433.6,619.166Z"
                    transform="translate(-417.354 -615.095)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.75"/>
            </g>
          </g>
          <g id="_x32_D_x24_AG-OUTLINE" transform="translate(250.261 92.522)">
            <g id="POLYLINE_31_">
              <path id="Path_360" data-name="Path 360"
                    d="M320.775,128.3a30.567,30.567,0,0,1-.964-11.056,16.592,16.592,0,0,1,2.665-8.517,15.894,15.894,0,0,1,5.216-4.47,25.224,25.224,0,0,1,9.4-3.035c5.083-.6,10.585.788,14.05,4.73a21.527,21.527,0,0,1,3.675,6.262,32.4,32.4,0,0,1,1.98,6.945,15.323,15.323,0,0,1,6.243,5.31,6.617,6.617,0,0,1,1.256,3.68,3.789,3.789,0,0,1-.994,2.368,7.1,7.1,0,0,1-2.689,1.783,8.945,8.945,0,0,1-4.02.631c-.277.831-.737,2.134-.941,2.97a23.859,23.859,0,0,0-.491,2.587c-.187,1.495-.416,3.407-.71,4.87l-.69,3.4a1.35,1.35,0,0,1,.621.717,48.846,48.846,0,0,1,6.838,3.024,27.622,27.622,0,0,1,7.126,5.125,25.81,25.81,0,0,1,5.534,9.8,40.527,40.527,0,0,1,1.954,10.082,27.27,27.27,0,0,1-.794,8.784c-.147,5.089-.38,14.229-.7,19.216-.074,1.676-1.09,13.448-1.249,15.4a72.912,72.912,0,0,0,1.682,22.685c.635,2.718,1.862,6.116,2.544,8.828a18.425,18.425,0,0,1,.469,2.6,5.721,5.721,0,0,1-.067,1.738,2.018,2.018,0,0,1-.455.929,18.863,18.863,0,0,1,.582,6.154c-.126,2.691-.659,6.837-.89,9.538-.487,5.179-.731,15-1.161,20.213a56.236,56.236,0,0,1-.851,6.37,1.752,1.752,0,0,1-1.229,1.473,69.127,69.127,0,0,1-4.43,13.461c-1.146,2.588-2.706,5.491-3.044,8.324a14.579,14.579,0,0,0,0,3.291,85.352,85.352,0,0,0,2.375,11.274,35.14,35.14,0,0,1,1.007,7.246,68.115,68.115,0,0,1-.942,11.592c-.774,4.958-1.779,10.5-2.952,15.383a24.473,24.473,0,0,1-1.078,3.418c.032.089.22.573.258.672a4.155,4.155,0,0,1,.3,1.377,10.381,10.381,0,0,1-.614,3.043L363.45,382a51.471,51.471,0,0,0-1.885,10.362c.588,1.27,1.086,3.136,1.535,4.47a36.858,36.858,0,0,0,1.859,4.267,13.668,13.668,0,0,1,.981,2.746,19.967,19.967,0,0,1,.363,5.314,7.5,7.5,0,0,1-.247,1.652,2.442,2.442,0,0,1-.491.945,1.927,1.927,0,0,1-.955.55,8.719,8.719,0,0,1-2.023.194c-2.906-.05-9.662.141-12.454-.136a8.179,8.179,0,0,1-2.214-.529,4.04,4.04,0,0,1-1.7-1.289,4.676,4.676,0,0,1-.84-2.225,13.766,13.766,0,0,1,.212-3.83c.338-1.954,1.761-8.819,2.177-10.846a18.992,18.992,0,0,1,.662-2.355c0-.807.119-5.391.14-6.3.02-1.542,0-3.237-.115-4.773-.062-.971-.2-2.536-.2-3.491a7.069,7.069,0,0,1,.168-1.76,2.077,2.077,0,0,1,.449-.873,5.157,5.157,0,0,1,1.189-.856c-.222-.676-.434-1.508-.609-2.2-1.087-4.911-3.024-11.726-3.431-16.685a29.8,29.8,0,0,1,.3-6.752,74.691,74.691,0,0,0,1.032-8.457,53.533,53.533,0,0,0-.52-9.007c-.623-4.281-1.621-10.788-1.956-15.03-.408-4.578-.594-9.559-.594-14.158a9.24,9.24,0,0,1-1.3.073,1.133,1.133,0,0,1-.481-.155,1.523,1.523,0,0,1-.48-.527,11.392,11.392,0,0,1-.936-2.7,61.979,61.979,0,0,0-3.831-12.26,5.237,5.237,0,0,0-.967-1.445.664.664,0,0,0-.528-.193.973.973,0,0,0-.385.16,4.429,4.429,0,0,0-.672.584,38.2,38.2,0,0,0-3.012,3.773c-2.37,3.215-5.591,8.326-7.942,11.59a13.3,13.3,0,0,1-1.289,1.5,4.127,4.127,0,0,1-1.082.794,6.085,6.085,0,0,1-2.813.417l-2.073,2.023a41.217,41.217,0,0,0-5.373,6.769c-2.046,3.09-4.165,6.653-6.018,9.87-.971,1.721-2.22,3.9-3.117,5.649a18.446,18.446,0,0,0-.822,1.818,6.38,6.38,0,0,0-.46,2.318,7.13,7.13,0,0,0,.19,1.476c.268,1.188.912,3.058,1.215,4.239a63.962,63.962,0,0,1,1.767,9.906,36.354,36.354,0,0,1-.208,9.4c-.213,1.39-.779,4.638-.89,5.991-.136,1.253-.143,3.657-.177,4.942a16.045,16.045,0,0,1-.217,2.282,7.187,7.187,0,0,1,1.078,1.294,3.388,3.388,0,0,1,.378,1.266,21.232,21.232,0,0,1-.14,4.1,58.526,58.526,0,0,0-.44,8.3l.149,4.643a.527.527,0,0,1,.3-.049.672.672,0,0,1,.34.176,2.781,2.781,0,0,1,.647,1.116,11.885,11.885,0,0,1,.346,1.338c.586,2.922,1.131,7.082,1.563,10.063a41.027,41.027,0,0,1,.589,7.726,3.716,3.716,0,0,1-.761,2.128,3.318,3.318,0,0,1-1.977.946,14.315,14.315,0,0,1-2.093.184c-.234.017-.829.007-1.068.015l-30.235,0a5.642,5.642,0,0,1-2.246-.347,2.12,2.12,0,0,1-.945-.875,5.671,5.671,0,0,1-.58-2.057,14.081,14.081,0,0,1,.072-3.826,2.755,2.755,0,0,1,.464-1.225,4.174,4.174,0,0,1,1.646-1.052c3.151-1.353,6.821-2.713,9.687-4.58a10.974,10.974,0,0,0,3.245-3.223c1.08-1.646,1.753-3.7,2.849-5.339a4.462,4.462,0,0,1,1.59-1.534l-.125-1.353c-.2-2.479-.439-6.919-.784-9.33a24.593,24.593,0,0,1-.451-3.765,1.982,1.982,0,0,1,.162-.706,2.525,2.525,0,0,1,1.372-1.036c-.082-.275-.154-.59-.214-.871l-.208-1.048-4.546-22.888-2.553-14.88-.089-.56-.082-.551a24.654,24.654,0,0,1-.268-3.167,18.759,18.759,0,0,1,.9-5.62c.429-1.46,1.386-4.507,1.72-5.936.337-1.358.6-2.836.81-4.222.49-3.225.878-7.846,1.473-11.039a47.426,47.426,0,0,1,1.193-4.818l.949-3.05a8.736,8.736,0,0,1-.14-3.717,38.36,38.36,0,0,1,2.279-8.128,114.445,114.445,0,0,1,5.816-12.427,77.884,77.884,0,0,1,8.189-12.815,9.053,9.053,0,0,1-.078-3.809c.981-7.653,1.933-16.078,2.323-23.779.393-7.759.362-15.994-.01-23.753a49.763,49.763,0,0,1-7.364-4.659A60.688,60.688,0,0,1,289.162,193a34.082,34.082,0,0,1-8.283,2.742,15.65,15.65,0,0,1-3.269.5,5.092,5.092,0,0,1-1.868-.284c-1.547-.559-2.231-2.225-2.642-3.7a32.612,32.612,0,0,1-.856-6.178c-.164-3.511-.642-8.816-.374-12.286a18.169,18.169,0,0,1-4.5-3.185c-2.443-2.751-2.815-6.694-3.454-10.171l-.23-1.184a3.5,3.5,0,0,1,.071-2.066,2.777,2.777,0,0,1,1.768-1.228,16.768,16.768,0,0,1-1.13-4.914,24.18,24.18,0,0,1-.076-4.316,3.947,3.947,0,0,1,.43-1.391,4.666,4.666,0,0,1,1.741-1.742,14.023,14.023,0,0,0-5.584-4.921l-1.976-1.042a15.282,15.282,0,0,1-4.027-2.938,13.52,13.52,0,0,1-3.305-7.815c-.351-1.529-.165-20.8-.235-22.857a11.827,11.827,0,0,1,.137-1.816,11.586,11.586,0,0,1,2.342-5.4,11.151,11.151,0,0,1,6.5-4.029,10.966,10.966,0,0,1,1.663-.209c.157-.005.341-.014.5-.012l8.23-.023,8.23-.023c.155,0,.343,0,.5.01a10.976,10.976,0,0,1,1.665.2,11.154,11.154,0,0,1,6.61,4.109,11.592,11.592,0,0,1,2.28,5.271,11.82,11.82,0,0,1,.147,1.816c-.058,2.145.226,21.235-.116,22.857a13.528,13.528,0,0,1-3.265,7.833,15.28,15.28,0,0,1-4.011,2.96L280.8,138.63a13.718,13.718,0,0,0-5.679,5.174,5.9,5.9,0,0,1,3.247-.136,4.193,4.193,0,0,1,1.709.8,3.371,3.371,0,0,1,.917,1.181,6.842,6.842,0,0,1,.539,2.077,18.157,18.157,0,0,1,.012,3.586,24.748,24.748,0,0,1-.828,4.656,19.8,19.8,0,0,1-1.262,3.191c1.734,1.945,2.55,4.6,3.468,6.993a9.737,9.737,0,0,0,.926,1.871,10.671,10.671,0,0,0,1.5,1.722,12.108,12.108,0,0,1,.977-2.795,7.029,7.029,0,0,1,1.216-1.49,28.541,28.541,0,0,1,2.658-2.185c1.425-1.045,4.235-3.031,5.555-4.113a15.939,15.939,0,0,0,2.721-2.729,36.6,36.6,0,0,0,2.186-3.487,42.228,42.228,0,0,1,2.588-3.775,41.616,41.616,0,0,1,10.564-10.128,24.256,24.256,0,0,1,6.5-2.7,14.309,14.309,0,0,1-.984-5.152C319.36,130.1,319.625,128.728,320.775,128.3Z"
                    transform="translate(-251.367 -92.522)" fill="none" stroke="#00b731" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3.5"/>
            </g>
          </g>
        </g>
      </svg>
  )
}
